var items = {
  "block.minecraft.acacia_button": "'aqey'Sa Sor leQ",
  "block.minecraft.acacia_door": "'aqey'Sa Sor lojmIt",
  "block.minecraft.acacia_fence": "'aqey'Sa Sor tlhoy'Hom",
  "block.minecraft.acacia_fence_gate": "'aqey'Sa Sor tlhoy'Hom lojmIt",
  "block.minecraft.acacia_hanging_sign": "'aqey'Sa Sor QIn 'echlet tlhep",
  "block.minecraft.acacia_leaves": "'aqey'Sa Sor pormey",
  "block.minecraft.acacia_log": "'aqey'Sa Sor Qechjem'a'",
  "block.minecraft.acacia_planks": "'aqey'Sa Sor 'echletmey",
  "block.minecraft.acacia_pressure_plate": "'aqey'Sa Sor Surmen 'echlet",
  "block.minecraft.acacia_sapling": "'aqey'Sa SorHom",
  "block.minecraft.acacia_shelf": "'aqey'Sa Sor yorgh",
  "block.minecraft.acacia_sign": "'aqey'Sa Sor QIn 'echlet",
  "block.minecraft.acacia_slab": "'aqey'Sa Sor buq'Ir bID",
  "block.minecraft.acacia_stairs": "'aqey'Sa Sor letlh",
  "block.minecraft.acacia_trapdoor": "'aqey'Sa Sor vonmeH lojmIt",
  "block.minecraft.acacia_wall_hanging_sign": "'aqey'Sa Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.acacia_wall_sign": "'aqey'Sa Sor tlhoy' QIn 'echlet",
  "block.minecraft.acacia_wood": "'aqey'Sa Sor Hap",
  "block.minecraft.activator_rail": "chu'wI' tIHmey",
  "block.minecraft.air": "rewve'",
  "block.minecraft.allium": "'anyan o'Qqar 'InSong",
  "block.minecraft.amethyst_block": "choSom nguv buq'Ir",
  "block.minecraft.amethyst_cluster": "choSom nguv qutmey",
  "block.minecraft.ancient_debris": "DI tIQ",
  "block.minecraft.andesite": "chan nagh",
  "block.minecraft.andesite_slab": "chan nagh buq'Ir bID",
  "block.minecraft.andesite_stairs": "chan nagh letlh",
  "block.minecraft.andesite_wall": "chan nagh tlhoy'",
  "block.minecraft.anvil": "'achme'",
  "block.minecraft.attached_melon_stem": "qaq naH Qechjem rarlu'bogh",
  "block.minecraft.attached_pumpkin_stem": "'aquta' rarlu'bogh",
  "block.minecraft.azalea": "'aSe'lIya SorHom",
  "block.minecraft.azalea_leaves": "DIS lav pormey",
  "block.minecraft.azure_bluet": "'aSur bIlu''et 'InSong",
  "block.minecraft.bamboo": "bambu'",
  "block.minecraft.bamboo_block": "bambu' buq'Ir",
  "block.minecraft.bamboo_button": "bambu' leQ",
  "block.minecraft.bamboo_door": "bambu' lojmIt",
  "block.minecraft.bamboo_fence": "bambu' tlhoy'Hom",
  "block.minecraft.bamboo_fence_gate": "bambu' tlhoy'Hom lojmIt",
  "block.minecraft.bamboo_hanging_sign": "bambu' QIn 'echlet tlhep",
  "block.minecraft.bamboo_mosaic": "bambu' HaSreH",
  "block.minecraft.bamboo_mosaic_slab": "bambu' HaSreH buq'Ir bID",
  "block.minecraft.bamboo_mosaic_stairs": "bambu' HaSreH letlh",
  "block.minecraft.bamboo_planks": "bambu' 'echletmey",
  "block.minecraft.bamboo_pressure_plate": "bambu' Surmen 'echlet",
  "block.minecraft.bamboo_sapling": "bambu' ghub",
  "block.minecraft.bamboo_shelf": "bambu' yorgh",
  "block.minecraft.bamboo_sign": "bambu' QIn 'echlet",
  "block.minecraft.bamboo_slab": "bambu' buq'Ir bID",
  "block.minecraft.bamboo_stairs": "bambu' letlh",
  "block.minecraft.bamboo_trapdoor": "bambu' vonmeH lojmIt",
  "block.minecraft.bamboo_wall_hanging_sign": "bambu' tlhoy' QIn 'echlet tlhep",
  "block.minecraft.bamboo_wall_sign": "bambu' tlhoy' QIn 'echlet",
  "block.minecraft.banner.base.black": "weSjech qIj",
  "block.minecraft.banner.base.blue": "SuDbogh weSjech 'ej Hurghbogh",
  "block.minecraft.banner.base.brown": "Doqbogh weSjech 'ej wovbe'bogh",
  "block.minecraft.banner.base.cyan": "SuDqu'bogh weSjech 'ej wovbogh",
  "block.minecraft.banner.base.gray": "qIjbogh weSjech 'ej wovbogh",
  "block.minecraft.banner.base.green": "weSjech SuDqu'",
  "block.minecraft.banner.base.light_blue": "SuDbogh weSjech 'ej wovbogh",
  "block.minecraft.banner.base.light_gray": "qIjbogh weSjech 'ej wovqu'bogh",
  "block.minecraft.banner.base.lime": "SuDqu'bogh weSjech 'ej wovqu'bogh",
  "block.minecraft.banner.base.magenta": "Doqqu'bogh weSjech 'ej wovbogh",
  "block.minecraft.banner.base.orange": "Doqbogh weSjech 'ej beqpuj rurbogh",
  "block.minecraft.banner.base.pink": "Doqqu'bogh weSjech 'ej wovqu'bogh",
  "block.minecraft.banner.base.purple": "ghIrep Hurgh rurbogh weSjech'e'",
  "block.minecraft.banner.base.red": "Doqqu'bogh joqwI' naQ",
  "block.minecraft.banner.base.white": "weSjech chIS",
  "block.minecraft.banner.base.yellow": "SuDbogh weSjech 'ej wovqu'bogh",
  "block.minecraft.banner.border.black": "HeH qIj",
  "block.minecraft.banner.border.blue": "SuDbogh HeH 'ej Hurghbogh",
  "block.minecraft.banner.border.brown": "Doqbogh HeH 'ej wovbe'bogh",
  "block.minecraft.banner.border.cyan": "SuDqu'bogh HeH 'ej wovbogh",
  "block.minecraft.banner.border.gray": "qIjbogh HeH 'ej wovbogh",
  "block.minecraft.banner.border.green": "HeH SuDqu'",
  "block.minecraft.banner.border.light_blue": "SuDbogh HeH 'ej wovbogh",
  "block.minecraft.banner.border.light_gray": "qIjbogh HeH 'ej wovqu'bogh",
  "block.minecraft.banner.border.lime": "SuDqu'bogh HeH 'ej wovqu'bogh",
  "block.minecraft.banner.border.magenta": "Doqqu'bogh HeH 'ej wovbogh",
  "block.minecraft.banner.border.orange": "Doqbogh HeH 'ej beqpuj rurbogh",
  "block.minecraft.banner.border.pink": "Doqqu'bogh HeH 'ej wovqu'bogh",
  "block.minecraft.banner.border.purple": "ghIrep Hurgh rurbogh HeH'e'",
  "block.minecraft.banner.border.red": "HeH Doqqu'",
  "block.minecraft.banner.border.white": "HeH chIS",
  "block.minecraft.banner.border.yellow": "SuDbogh HeH 'ej wovqu'bogh",
  "block.minecraft.banner.bricks.black": "ngogh reD qIj",
  "block.minecraft.banner.bricks.blue": "SuDbogh ngogh reD 'ej Hurghbogh",
  "block.minecraft.banner.bricks.brown": "Doqbogh ngogh reD 'ej wovbe'bogh",
  "block.minecraft.banner.bricks.cyan": "SuDqu'bogh ngogh reD 'ej wovbogh",
  "block.minecraft.banner.bricks.gray": "qIjbogh ngogh reD 'ej wovbogh",
  "block.minecraft.banner.bricks.green": "ngogh reD SuDqu'",
  "block.minecraft.banner.bricks.light_blue": "SuDbogh ngogh reD 'ej wovbogh",
  "block.minecraft.banner.bricks.light_gray": "qIjbogh ngogh reD 'ej wovqu'bogh",
  "block.minecraft.banner.bricks.lime": "SuDqu'bogh ngogh reD 'ej wovqu'bogh",
  "block.minecraft.banner.bricks.magenta": "Doqqu'bogh ngogh reD 'ej wovbogh",
  "block.minecraft.banner.bricks.orange": "Doqbogh ngogh reD 'ej beqpuj rurbogh",
  "block.minecraft.banner.bricks.pink": "Doqqu'bogh ngogh reD 'ej wovqu'bogh",
  "block.minecraft.banner.bricks.purple": "ghIrep Hurgh rurbogh ngogh reD'e'",
  "block.minecraft.banner.bricks.red": "ngogh Doqqu'",
  "block.minecraft.banner.bricks.white": "ngogh reD chIS",
  "block.minecraft.banner.bricks.yellow": "SuDbogh ngogh reD 'ej wovqu'bogh",
  "block.minecraft.banner.circle.black": "botlh gho qIj",
  "block.minecraft.banner.circle.blue": "SuDbogh botlh gho 'ej Hurghbogh",
  "block.minecraft.banner.circle.brown": "Doqbogh botlh gho 'ej wovbe'bogh",
  "block.minecraft.banner.circle.cyan": "SuDqu'bogh botlh gho 'ej wovbogh",
  "block.minecraft.banner.circle.gray": "qIjbogh botlh gho 'ej wovbogh",
  "block.minecraft.banner.circle.green": "botlh gho SuDqu'",
  "block.minecraft.banner.circle.light_blue": "SuDbogh botlh gho 'ej wovbogh",
  "block.minecraft.banner.circle.light_gray": "qIjbogh botlh gho 'ej wovqu'bogh",
  "block.minecraft.banner.circle.lime": "SuDqu'bogh botlh gho 'ej wovqu'bogh",
  "block.minecraft.banner.circle.magenta": "Doqqu'bogh botlh gho 'ej wovbogh",
  "block.minecraft.banner.circle.orange": "Doqbogh botlh gho 'ej beqpuj rurbogh",
  "block.minecraft.banner.circle.pink": "Doqqu'bogh botlh gho 'ej wovqu'bogh",
  "block.minecraft.banner.circle.purple": "ghIrep Hurgh rurbogh botlh gho'e'",
  "block.minecraft.banner.circle.red": "botlh gho Doqqu'",
  "block.minecraft.banner.circle.white": "botlh gho chIS",
  "block.minecraft.banner.circle.yellow": "SuDbogh botlh gho 'ej wovqu'bogh",
  "block.minecraft.banner.creeper.black": "creeper Degh qIj",
  "block.minecraft.banner.creeper.blue": "SuDbogh creeper Degh 'ej Hurghbogh",
  "block.minecraft.banner.creeper.brown": "Doqbogh creeper Degh 'ej wovbe'bogh",
  "block.minecraft.banner.creeper.cyan": "SuDqu'bogh creeper Degh 'ej wovbogh",
  "block.minecraft.banner.creeper.gray": "qIjbogh creeper Degh 'ej wovbogh",
  "block.minecraft.banner.creeper.green": "creeper Degh SuDqu'",
  "block.minecraft.banner.creeper.light_blue": "SuDbogh creeper Degh 'ej wovbogh",
  "block.minecraft.banner.creeper.light_gray": "qIjbogh creeper Degh 'ej wovqu'bogh",
  "block.minecraft.banner.creeper.lime": "SuDqu'bogh creeper Degh 'ej wovqu'bogh",
  "block.minecraft.banner.creeper.magenta": "Doqqu'bogh creeper Degh 'ej wovbogh",
  "block.minecraft.banner.creeper.orange": "Doqbogh creeper Degh 'ej beqpuj rurbogh",
  "block.minecraft.banner.creeper.pink": "Doqqu'bogh creeper Degh 'ej wovqu'bogh",
  "block.minecraft.banner.creeper.purple": "ghIrep Hurgh rurbogh creeper Degh'e'",
  "block.minecraft.banner.creeper.red": "creeper Degh Doqqu'",
  "block.minecraft.banner.creeper.white": "creeper Degh chIS",
  "block.minecraft.banner.creeper.yellow": "SuDbogh creeper Degh 'ej wovqu'bogh",
  "block.minecraft.banner.cross.black": "bo'ghey me'cheD qIj",
  "block.minecraft.banner.cross.blue": "SuDbogh bo'ghey me'cheD 'ej Hurghbogh",
  "block.minecraft.banner.cross.brown": "Doqbogh bo'ghey me'cheD 'ej wovbe'bogh",
  "block.minecraft.banner.cross.cyan": "SuDqu'bogh bo'ghey me'cheD 'ej wovbogh",
  "block.minecraft.banner.cross.gray": "qIjbogh bo'ghey me'cheD 'ej wovbogh",
  "block.minecraft.banner.cross.green": "bo'ghey me'cheD SuDqu'",
  "block.minecraft.banner.cross.light_blue": "SuDbogh bo'ghey me'cheD 'ej wovbogh",
  "block.minecraft.banner.cross.light_gray": "qIjbogh bo'ghey me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.cross.lime": "SuDqu'bogh bo'ghey me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.cross.magenta": "Doqqu'bogh bo'ghey me'cheD 'ej wovbogh",
  "block.minecraft.banner.cross.orange": "Doqbogh bo'ghey me'cheD 'ej beqpuj rurbogh",
  "block.minecraft.banner.cross.pink": "Doqqu'bogh bo'ghey me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.cross.purple": "ghIrep Hurgh rurbogh bo'ghey me'cheD'e'",
  "block.minecraft.banner.cross.red": "bo'ghey me'cheD Doqqu'",
  "block.minecraft.banner.cross.white": "bo'ghey me'cheD chIS",
  "block.minecraft.banner.cross.yellow": "SuDbogh bo'ghey me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.curly_border.black": "qIjbogh HeH tIy",
  "block.minecraft.banner.curly_border.blue": "SuDbogh HeH tIy 'ej Hurghbogh",
  "block.minecraft.banner.curly_border.brown": "Doqbogh HeH tIy 'ej wovbe'bogh",
  "block.minecraft.banner.curly_border.cyan": "SuDqu'bogh HeH tIy 'ej wovbogh",
  "block.minecraft.banner.curly_border.gray": "qIjbogh HeH tIy 'ej wovbogh",
  "block.minecraft.banner.curly_border.green": "SuDqu'bogh HeH tIy",
  "block.minecraft.banner.curly_border.light_blue": "SuDbogh HeH tIy 'ej wovbogh",
  "block.minecraft.banner.curly_border.light_gray": "qIjbogh HeH tIy 'ej wovqu'bogh",
  "block.minecraft.banner.curly_border.lime": "SuDqu'bogh HeH tIy 'ej wovqu'bogh",
  "block.minecraft.banner.curly_border.magenta": "Doqqu'bogh HeH tIy 'ej wovbogh",
  "block.minecraft.banner.curly_border.orange": "Doqbogh HeH tIy 'ej beqpuj rurbogh",
  "block.minecraft.banner.curly_border.pink": "Doqqu'bogh HeH tIy 'ej wovqu'bogh",
  "block.minecraft.banner.curly_border.purple": "ghIrep Hurgh rurbogh HeH'e' tIy",
  "block.minecraft.banner.curly_border.red": "Doqqu'bogh HeH tIy",
  "block.minecraft.banner.curly_border.white": "chISbogh HeH tIy",
  "block.minecraft.banner.curly_border.yellow": "SuDbogh HeH tIy 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_left.black": "yor poS bo'ghey qIj",
  "block.minecraft.banner.diagonal_left.blue": "SuDbogh yor poS bo'ghey 'ej Hurghbogh",
  "block.minecraft.banner.diagonal_left.brown": "Doqbogh yor poS bo'ghey 'ej wovbe'bogh",
  "block.minecraft.banner.diagonal_left.cyan": "SuDqu'bogh yor poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_left.gray": "qIjbogh yor poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_left.green": "yor poS bo'ghey SuDqu'",
  "block.minecraft.banner.diagonal_left.light_blue": "SuDbogh yor poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_left.light_gray": "qIjbogh yor poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_left.lime": "SuDqu'bogh yor poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_left.magenta": "Doqqu'bogh yor poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_left.orange": "Doqbogh yor poS bo'ghey 'ej beqpuj rurbogh",
  "block.minecraft.banner.diagonal_left.pink": "Doqqu'bogh yor poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_left.purple": "ghIrep Hurgh rurbogh yor poS bo'ghey'e'",
  "block.minecraft.banner.diagonal_left.red": "yor poS bo'ghey Doqqu'",
  "block.minecraft.banner.diagonal_left.white": "yor poS bo'ghey chIS",
  "block.minecraft.banner.diagonal_left.yellow": "SuDbogh yor poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_right.black": "yor nIH bo'ghey qIj",
  "block.minecraft.banner.diagonal_right.blue": "SuDbogh yor nIH bo'ghey 'ej Hurghbogh",
  "block.minecraft.banner.diagonal_right.brown": "Doqbogh yor nIH bo'ghey 'ej wovbe'bogh",
  "block.minecraft.banner.diagonal_right.cyan": "SuDqu'bogh yor nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_right.gray": "qIjbogh yor nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_right.green": "yor nIH bo'ghey SuDqu'",
  "block.minecraft.banner.diagonal_right.light_blue": "SuDbogh yor nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_right.light_gray": "qIjbogh yor nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_right.lime": "SuDqu'bogh yor nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_right.magenta": "Doqqu'bogh yor nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_right.orange": "Doqbogh yor nIH bo'ghey 'ej beqpuj rurbogh",
  "block.minecraft.banner.diagonal_right.pink": "Doqqu'bogh yor nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_right.purple": "ghIrep Hurgh rurbogh yor nIH bo'ghey'e'",
  "block.minecraft.banner.diagonal_right.red": "yor nIH bo'ghey Doqqu'",
  "block.minecraft.banner.diagonal_right.white": "yor nIH bo'ghey chIS",
  "block.minecraft.banner.diagonal_right.yellow": "SuDbogh yor nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_left.black": "pIrmuS poS bo'ghey qIj",
  "block.minecraft.banner.diagonal_up_left.blue": "SuDbogh pIrmuS poS bo'ghey 'ej Hurghbogh",
  "block.minecraft.banner.diagonal_up_left.brown": "Doqbogh pIrmuS poS bo'ghey 'ej wovbe'bogh",
  "block.minecraft.banner.diagonal_up_left.cyan": "SuDqu'bogh pIrmuS poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_left.gray": "qIjbogh pIrmuS poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_left.green": "pIrmuS poS bo'ghey SuDqu'",
  "block.minecraft.banner.diagonal_up_left.light_blue": "SuDbogh pIrmuS poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_left.light_gray": "qIjbogh pIrmuS poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_left.lime": "SuDqu'bogh pIrmuS poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_left.magenta": "Doqqu'bogh pIrmuS poS bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_left.orange": "Doqbogh pIrmuS poS bo'ghey 'ej beqpuj rurbogh",
  "block.minecraft.banner.diagonal_up_left.pink": "Doqqu'bogh pIrmuS poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_left.purple": "ghIrep Hurgh rurbogh pIrmuS poS bo'ghey'e'",
  "block.minecraft.banner.diagonal_up_left.red": "pIrmuS poS bo'ghey Doqqu'",
  "block.minecraft.banner.diagonal_up_left.white": "pIrmuS poS bo'ghey chIS",
  "block.minecraft.banner.diagonal_up_left.yellow": "SuDbogh pIrmuS poS bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_right.black": "pIrmuS nIH bo'ghey qIj",
  "block.minecraft.banner.diagonal_up_right.blue": "SuDbogh pIrmuS nIH bo'ghey 'ej Hurghbogh",
  "block.minecraft.banner.diagonal_up_right.brown": "Doqbogh pIrmuS nIH bo'ghey 'ej wovbe'bogh",
  "block.minecraft.banner.diagonal_up_right.cyan": "SuDqu'bogh pIrmuS nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_right.gray": "qIjbogh pIrmuS nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_right.green": "pIrmuS nIH bo'ghey SuDqu'",
  "block.minecraft.banner.diagonal_up_right.light_blue": "SuDbogh pIrmuS nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_right.light_gray": "qIjbogh pIrmuS nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_right.lime": "SuDqu'bogh pIrmuS nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_right.magenta": "Doqqu'bogh pIrmuS nIH bo'ghey 'ej wovbogh",
  "block.minecraft.banner.diagonal_up_right.orange": "Doqbogh pIrmuS nIH bo'ghey 'ej beqpuj rurbogh",
  "block.minecraft.banner.diagonal_up_right.pink": "Doqqu'bogh pIrmuS nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.diagonal_up_right.purple": "ghIrep Hurgh rurbogh pIrmuS nIH bo'ghey'e'",
  "block.minecraft.banner.diagonal_up_right.red": "pIrmuS nIH bo'ghey Doqqu'",
  "block.minecraft.banner.diagonal_up_right.white": "pIrmuS nIH bo'ghey chIS",
  "block.minecraft.banner.diagonal_up_right.yellow": "SuDbogh pIrmuS nIH bo'ghey 'ej wovqu'bogh",
  "block.minecraft.banner.flow.black": "Dem'ot qIj",
  "block.minecraft.banner.flow.blue": "SuDbogh Dem'ot 'ej Hurghbogh",
  "block.minecraft.banner.flow.brown": "Doqbogh Dem'ot 'ej wovbe'bogh",
  "block.minecraft.banner.flow.cyan": "SuDqu'bogh Dem'ot 'ej wovbogh",
  "block.minecraft.banner.flow.gray": "qIjbogh Dem'ot 'ej wovbogh",
  "block.minecraft.banner.flow.green": "Dem'ot SuDqu'",
  "block.minecraft.banner.flow.light_blue": "SuDbogh Dem'ot 'ej wovbogh",
  "block.minecraft.banner.flow.light_gray": "qIjbogh Dem'ot 'ej wovqu'bogh",
  "block.minecraft.banner.flow.lime": "SuDqu'bogh Dem'ot 'ej wovqu'bogh",
  "block.minecraft.banner.flow.magenta": "Doqqu'bogh Dem'ot 'ej wovbogh",
  "block.minecraft.banner.flow.orange": "Doqbogh Dem'ot 'ej wovbogh",
  "block.minecraft.banner.flow.pink": "Doqqu'bogh Dem'ot 'ej wovqu'bogh",
  "block.minecraft.banner.flow.purple": "ghIrep Hurgh rurbogh Dem'ot",
  "block.minecraft.banner.flow.red": "Dem'ot Doqqu'",
  "block.minecraft.banner.flow.white": "Dem'ot chIS",
  "block.minecraft.banner.flow.yellow": "SuDbogh Dem'ot 'ej wovqu'bogh",
  "block.minecraft.banner.flower.black": "'InSong Degh qIj",
  "block.minecraft.banner.flower.blue": "SuDbogh 'InSong Degh 'ej Hurghbogh",
  "block.minecraft.banner.flower.brown": "Doqbogh 'InSong Degh 'ej wovbe'bogh",
  "block.minecraft.banner.flower.cyan": "SuDqu'bogh 'InSong Degh 'ej wovbogh",
  "block.minecraft.banner.flower.gray": "qIjbogh 'InSong Degh 'ej wovbogh",
  "block.minecraft.banner.flower.green": "'InSong Degh SuDqu’",
  "block.minecraft.banner.flower.light_blue": "SuDbogh 'InSong Degh 'ej wovbogh",
  "block.minecraft.banner.flower.light_gray": "qIjbogh 'InSong Degh 'ej wovqu'bogh",
  "block.minecraft.banner.flower.lime": "SuDqu'bogh 'InSong Degh 'ej wovqu'bogh",
  "block.minecraft.banner.flower.magenta": "Doqqu'bogh 'InSong Degh 'ej wovbogh",
  "block.minecraft.banner.flower.orange": "Doqbogh 'InSong Degh 'ej beqpuj rurbogh",
  "block.minecraft.banner.flower.pink": "Doqqu'bogh 'InSong Degh 'ej wovqu'bogh",
  "block.minecraft.banner.flower.purple": "ghIrep Hurgh rurbogh 'InSong Degh'e'",
  "block.minecraft.banner.flower.red": "'InSong Degh Doqqu'",
  "block.minecraft.banner.flower.white": "'InSong Degh chIS",
  "block.minecraft.banner.flower.yellow": "SuDbogh 'InSong Degh 'ej wovqu'bogh",
  "block.minecraft.banner.globe.black": "yuQ qIj",
  "block.minecraft.banner.globe.blue": "SuDbogh yuQ 'ej Hurghbogh",
  "block.minecraft.banner.globe.brown": "Doqbogh yuQ 'ej wovbe'bogh",
  "block.minecraft.banner.globe.cyan": "SuDqu'bogh yuQ 'ej wovbogh",
  "block.minecraft.banner.globe.gray": "qIjbogh yuQ 'ej wovbogh",
  "block.minecraft.banner.globe.green": "yuQ SuDqu'",
  "block.minecraft.banner.globe.light_blue": "SuDbogh yuQ 'ej wovbogh",
  "block.minecraft.banner.globe.light_gray": "qIjbogh yuQ 'ej wovqu'bogh",
  "block.minecraft.banner.globe.lime": "SuDqu'bogh yuQ 'ej wovqu'bogh",
  "block.minecraft.banner.globe.magenta": "Doqqu'bogh yuQ 'ej wovbogh",
  "block.minecraft.banner.globe.orange": "Doqbogh yuQ 'ej beqpuj rurbogh",
  "block.minecraft.banner.globe.pink": "Doqqu'bogh yuQ 'ej wovqu'bogh",
  "block.minecraft.banner.globe.purple": "ghIrep Hurgh rurbogh yuQ'e'",
  "block.minecraft.banner.globe.red": "qo' Doqqu'",
  "block.minecraft.banner.globe.white": "yuQ chIS",
  "block.minecraft.banner.globe.yellow": "SuDbogh yuQ 'ej wovqu'bogh",
  "block.minecraft.banner.gradient.black": "yor Delnga qIj",
  "block.minecraft.banner.gradient.blue": "SuDbogh yor Delnga 'ej Hurghbogh",
  "block.minecraft.banner.gradient.brown": "Doqbogh yor Delnga 'ej wovbe'bogh",
  "block.minecraft.banner.gradient.cyan": "SuDqu'bogh yor choH Hab 'ej wovbogh",
  "block.minecraft.banner.gradient.gray": "qIjbogh yor Delnga 'ej wovbogh",
  "block.minecraft.banner.gradient.green": "yor Delnga SuDqu'",
  "block.minecraft.banner.gradient.light_blue": "SuDbogh yor Delnga 'ej wovbogh",
  "block.minecraft.banner.gradient.light_gray": "qIjbogh yor Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.gradient.lime": "SuDqu'bogh yor choH Hab 'ej wovqu'bogh",
  "block.minecraft.banner.gradient.magenta": "Doqqu'bogh yor choH Hab 'ej wovbogh",
  "block.minecraft.banner.gradient.orange": "Doqbogh yor Delnga 'ej beqpuj rurbogh",
  "block.minecraft.banner.gradient.pink": "Doqqu'bogh yor Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.gradient.purple": "ghIrep Hurgh rurbogh yor Delnga",
  "block.minecraft.banner.gradient.red": "yor Delnga Doqqu'",
  "block.minecraft.banner.gradient.white": "yor Delnga chIS",
  "block.minecraft.banner.gradient.yellow": "SuDbogh yor Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.gradient_up.black": "pIrmuS Delnga qIj",
  "block.minecraft.banner.gradient_up.blue": "SuDbogh pIrmuS Delnga 'ej Hurghbogh",
  "block.minecraft.banner.gradient_up.brown": "Doqbogh pIrmuS Delnga 'ej wovbe'bogh",
  "block.minecraft.banner.gradient_up.cyan": "SuDqu'bogh pIrmuS choH Hab 'ej wovbogh",
  "block.minecraft.banner.gradient_up.gray": "qIjbogh pIrmuS Delnga 'ej wovbogh",
  "block.minecraft.banner.gradient_up.green": "pIrmuS Delnga SuDqu'",
  "block.minecraft.banner.gradient_up.light_blue": "SuDbogh pIrmuS Delnga 'ej wovbogh",
  "block.minecraft.banner.gradient_up.light_gray": "qIjbogh pIrmuS Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.gradient_up.lime": "SuDqu'bogh pIrmuS choH Hab 'ej wovqu'bogh",
  "block.minecraft.banner.gradient_up.magenta": "Doqqu'bogh pIrmuS choH Hab 'ej wovbogh",
  "block.minecraft.banner.gradient_up.orange": "Doqbogh pIrmuS Delnga 'ej beqpuj rurbogh",
  "block.minecraft.banner.gradient_up.pink": "Doqqu'bogh pIrmuS Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.gradient_up.purple": "ghIrep Hurgh rurbogh pIrmuS Delnga",
  "block.minecraft.banner.gradient_up.red": "pIrmuS Delnga Doqqu'",
  "block.minecraft.banner.gradient_up.white": "pIrmuS Delnga chIS",
  "block.minecraft.banner.gradient_up.yellow": "SuDbogh pIrmuS Delnga 'ej wovqu'bogh",
  "block.minecraft.banner.guster.black": "cheqwI' qIj",
  "block.minecraft.banner.guster.blue": "SuDbogh cheqwI' 'ej Hurghbogh",
  "block.minecraft.banner.guster.brown": "Doqbogh cheqwI' 'ej wovbe'bogh",
  "block.minecraft.banner.guster.cyan": "SuDqu'bogh cheqwI' 'ej wovbogh",
  "block.minecraft.banner.guster.gray": "qIjbogh cheqwI' 'ej wovbogh",
  "block.minecraft.banner.guster.green": "cheqwI' SuDqu'",
  "block.minecraft.banner.guster.light_blue": "SuDbogh cheqwI' 'ej wovbogh",
  "block.minecraft.banner.guster.light_gray": "qIjbogh cheqwI' 'ej wovqu'bogh",
  "block.minecraft.banner.guster.lime": "SuDqu'bogh cheqwI' 'ej wovqu'bogh",
  "block.minecraft.banner.guster.magenta": "Doqqu'bogh cheqwI' 'ej wovbogh",
  "block.minecraft.banner.guster.orange": "Doqbogh cheqwI' 'ej wovbogh",
  "block.minecraft.banner.guster.pink": "Doqqu'bogh cheqwI' 'ej wovqu'bogh",
  "block.minecraft.banner.guster.purple": "ghIrep Hurgh rurbogh cheqwI'",
  "block.minecraft.banner.guster.red": "cheqwI' Doqqu'",
  "block.minecraft.banner.guster.white": "cheqwI' chIS",
  "block.minecraft.banner.guster.yellow": "SuDbogh cheqwI' 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal.black": "yor bID qIj",
  "block.minecraft.banner.half_horizontal.blue": "SuDbogh yor bID 'ej Hurghbogh",
  "block.minecraft.banner.half_horizontal.brown": "Doqbogh yor bID 'ej wovbe'bogh",
  "block.minecraft.banner.half_horizontal.cyan": "SuDqu'bogh yor bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal.gray": "qIjbogh yor bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal.green": "yor bID SuDqu'",
  "block.minecraft.banner.half_horizontal.light_blue": "SuDbogh yor bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal.light_gray": "qIjbogh yor bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal.lime": "SuDqu'bogh yor bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal.magenta": "Doqqu'bogh yor bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal.orange": "Doqbogh yor bID 'ej beqpuj rurbogh",
  "block.minecraft.banner.half_horizontal.pink": "Doqqu'bogh yor bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal.purple": "ghIrep Hurgh rurbogh yor bID'e'",
  "block.minecraft.banner.half_horizontal.red": "yor bID Doqqu'",
  "block.minecraft.banner.half_horizontal.white": "yor bID chIS",
  "block.minecraft.banner.half_horizontal.yellow": "SuDbogh yor bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal_bottom.black": "pIrmuS bID qIj",
  "block.minecraft.banner.half_horizontal_bottom.blue": "SuDbogh pIrmuS bID 'ej Hurghbogh",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Doqbogh pIrmuS bID 'ej wovbe'bogh",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "SuDqu'bogh pIrmuS bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal_bottom.gray": "qIjbogh pIrmuS bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal_bottom.green": "pIrmuS bID SuDqu'",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "SuDbogh pIrmuS bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "qIjbogh pIrmuS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal_bottom.lime": "SuDqu'bogh pIrmuS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Doqqu'bogh pIrmuS bID 'ej wovbogh",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Doqbogh pIrmuS bID 'ej beqpuj rurbogh",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Doqqu'bogh pIrmuS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_horizontal_bottom.purple": "ghIrep Hurgh rurbogh pIrmuS bID'e'",
  "block.minecraft.banner.half_horizontal_bottom.red": "pIrmuS bID Doqqu'",
  "block.minecraft.banner.half_horizontal_bottom.white": "pIrmuS bID chIS",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "SuDbogh pIrmuS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical.black": "poS bID qIj",
  "block.minecraft.banner.half_vertical.blue": "SuDbogh poS bID 'ej Hurghbogh",
  "block.minecraft.banner.half_vertical.brown": "Doqbogh poS bID 'ej wovbe'bogh",
  "block.minecraft.banner.half_vertical.cyan": "SuDqu'bogh poS bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical.gray": "qIjbogh poS bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical.green": "poS bID SuDqu'",
  "block.minecraft.banner.half_vertical.light_blue": "SuDbogh poS bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical.light_gray": "qIjbogh poS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical.lime": "SuDqu'bogh poS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical.magenta": "Doqqu'bogh poS bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical.orange": "Doqbogh poS bID 'ej beqpuj rurbogh",
  "block.minecraft.banner.half_vertical.pink": "Doqqu'bogh poS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical.purple": "ghIrep Hurgh rurbogh poS bID'e'",
  "block.minecraft.banner.half_vertical.red": "poS bID Doqqu'",
  "block.minecraft.banner.half_vertical.white": "poS bID chIS",
  "block.minecraft.banner.half_vertical.yellow": "SuDbogh poS bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical_right.black": "nIH bID qIj",
  "block.minecraft.banner.half_vertical_right.blue": "SuDbogh nIH bID 'ej Hurghbogh",
  "block.minecraft.banner.half_vertical_right.brown": "Doqbogh nIH bID 'ej wovbe'bogh",
  "block.minecraft.banner.half_vertical_right.cyan": "SuDqu'bogh nIH bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical_right.gray": "qIjbogh nIH bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical_right.green": "nIH bID SuDqu'",
  "block.minecraft.banner.half_vertical_right.light_blue": "SuDbogh nIH bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical_right.light_gray": "qIjbogh nIH bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical_right.lime": "SuDqu'bogh nIH bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical_right.magenta": "Doqqu'bogh nIH bID 'ej wovbogh",
  "block.minecraft.banner.half_vertical_right.orange": "Doqbogh nIH bID 'ej beqpuj rurbogh",
  "block.minecraft.banner.half_vertical_right.pink": "Doqqu'bogh nIH bID 'ej wovqu'bogh",
  "block.minecraft.banner.half_vertical_right.purple": "ghIrep Hurgh rurbogh nIH bID'e'",
  "block.minecraft.banner.half_vertical_right.red": "nIH bID Doqqu'",
  "block.minecraft.banner.half_vertical_right.white": "nIH bID chIS",
  "block.minecraft.banner.half_vertical_right.yellow": "SuDbogh nIH bID 'ej wovqu'bogh",
  "block.minecraft.banner.mojang.black": "vIqraq qIj",
  "block.minecraft.banner.mojang.blue": "SuDbogh vIqraq 'ej Hurghbogh",
  "block.minecraft.banner.mojang.brown": "Doqbogh vIqraq 'ej wovbe'bogh",
  "block.minecraft.banner.mojang.cyan": "SuDqu'bogh vIqraq 'ej wovbogh",
  "block.minecraft.banner.mojang.gray": "qIjbogh vIqraq 'ej wovbogh",
  "block.minecraft.banner.mojang.green": "vIqraq SuDqu'",
  "block.minecraft.banner.mojang.light_blue": "SuDbogh vIqraq 'ej wovbogh",
  "block.minecraft.banner.mojang.light_gray": "qIjbogh vIqraq 'ej wovqu'bogh",
  "block.minecraft.banner.mojang.lime": "SuDqu'bogh vIqraq 'ej wovqu'bogh",
  "block.minecraft.banner.mojang.magenta": "Doqqu'bogh vIqraq 'ej wovbogh",
  "block.minecraft.banner.mojang.orange": "Doqbogh vIqraq 'ej beqpuj rurbogh",
  "block.minecraft.banner.mojang.pink": "Doqqu'bogh vIqraq 'ej wovqu'bogh",
  "block.minecraft.banner.mojang.purple": "ghIrep Hurgh rurbogh vIqraq'e'",
  "block.minecraft.banner.mojang.red": "Doch Doqqu'",
  "block.minecraft.banner.mojang.white": "vIqraq chIS",
  "block.minecraft.banner.mojang.yellow": "SuDbogh vIqraq 'ej wovqu'bogh",
  "block.minecraft.banner.piglin.black": "ghIch qIj",
  "block.minecraft.banner.piglin.blue": "SuDbogh ghIch 'ej Hurghbogh",
  "block.minecraft.banner.piglin.brown": "Doqbogh ghIch 'ej wovbe'bogh",
  "block.minecraft.banner.piglin.cyan": "SuDqu'bogh ghIch 'ej wovbogh",
  "block.minecraft.banner.piglin.gray": "qIjbogh ghIch 'ej wovbogh",
  "block.minecraft.banner.piglin.green": "ghIch SuDqu'",
  "block.minecraft.banner.piglin.light_blue": "SuDbogh ghIch 'ej wovbogh",
  "block.minecraft.banner.piglin.light_gray": "qIjbogh ghIch 'ej wovqu'bogh",
  "block.minecraft.banner.piglin.lime": "SuDqu'bogh ghIch 'ej wovqu'bogh",
  "block.minecraft.banner.piglin.magenta": "Doqqu'bogh ghIch 'ej wovbogh",
  "block.minecraft.banner.piglin.orange": "Doqbogh ghIch 'ej beqpuj rurbogh",
  "block.minecraft.banner.piglin.pink": "Doqqu'bogh ghIch 'ej wovqu'bogh",
  "block.minecraft.banner.piglin.purple": "ghIrep Hurgh rurbogh ghIch'e'",
  "block.minecraft.banner.piglin.red": "ghIch Doqqu'",
  "block.minecraft.banner.piglin.white": "ghIch chIS",
  "block.minecraft.banner.piglin.yellow": "SuDbogh ghIch 'ej wovqu'bogh",
  "block.minecraft.banner.rhombus.black": "botlh meyrI' qIj",
  "block.minecraft.banner.rhombus.blue": "SuDbogh botlh meyrI' 'ej Hurghbogh",
  "block.minecraft.banner.rhombus.brown": "Doqbogh botlh meyrI' 'ej wovbe'bogh",
  "block.minecraft.banner.rhombus.cyan": "SuDqu'bogh botlh meyrI' 'ej wovbogh",
  "block.minecraft.banner.rhombus.gray": "qIjbogh botlh meyrI' 'ej wovbogh",
  "block.minecraft.banner.rhombus.green": "botlh meyrI' SuDqu'",
  "block.minecraft.banner.rhombus.light_blue": "SuDbogh botlh meyrI' 'ej wovbogh",
  "block.minecraft.banner.rhombus.light_gray": "qIjbogh botlh meyrI' 'ej wovqu'bogh",
  "block.minecraft.banner.rhombus.lime": "SuDqu'bogh botlh meyrI' 'ej wovqu'bogh",
  "block.minecraft.banner.rhombus.magenta": "Doqqu'bogh botlh meyrI' 'ej wovbogh",
  "block.minecraft.banner.rhombus.orange": "Doqbogh botlh meyrI' 'ej beqpuj rurbogh",
  "block.minecraft.banner.rhombus.pink": "Doqqu'bogh botlh meyrI' 'ej wovqu'bogh",
  "block.minecraft.banner.rhombus.purple": "ghIrep Hurgh rurbogh botlh meyrI''e'",
  "block.minecraft.banner.rhombus.red": "botlh Hov Doqqu'",
  "block.minecraft.banner.rhombus.white": "botlh meyrI' chIS",
  "block.minecraft.banner.rhombus.yellow": "SuDbogh botlh meyrI' 'ej wovqu'bogh",
  "block.minecraft.banner.skull.black": "DughrI' Degh qIj",
  "block.minecraft.banner.skull.blue": "SuDbogh DughrI' Degh 'ej Hurghbogh",
  "block.minecraft.banner.skull.brown": "Doqbogh DughrI' Degh 'ej wovbe'bogh",
  "block.minecraft.banner.skull.cyan": "SuDqu'bogh DughrI' Degh 'ej wovbogh",
  "block.minecraft.banner.skull.gray": "qIjbogh DughrI' Degh 'ej wovbogh",
  "block.minecraft.banner.skull.green": "DughrI' Degh SuDqu'",
  "block.minecraft.banner.skull.light_blue": "SuDbogh DughrI' Degh 'ej wovbogh",
  "block.minecraft.banner.skull.light_gray": "qIjbogh DughrI' Degh 'ej wovqu'bogh",
  "block.minecraft.banner.skull.lime": "SuDqu'bogh DughrI' Degh 'ej wovqu'bogh",
  "block.minecraft.banner.skull.magenta": "Doqqu'bogh DughrI' Degh 'ej wovbogh",
  "block.minecraft.banner.skull.orange": "Doqbogh DughrI' Degh 'ej beqpuj rurbogh",
  "block.minecraft.banner.skull.pink": "Doqqu'bogh DughrI' Degh 'ej wovqu'bogh",
  "block.minecraft.banner.skull.purple": "ghIrep Hurgh rurbogh DughrI' Degh'e'",
  "block.minecraft.banner.skull.red": "DughrI' Degh Doqqu'",
  "block.minecraft.banner.skull.white": "DughrI' Degh chIS",
  "block.minecraft.banner.skull.yellow": "SuDbogh DughrI' Degh 'ej wovqu'bogh",
  "block.minecraft.banner.small_stripes.black": "qIjbogh weSjech way",
  "block.minecraft.banner.small_stripes.blue": "SuDbogh weSjech way 'ej Hurghbogh",
  "block.minecraft.banner.small_stripes.brown": "Doqbogh weSjech way 'ej wovbe'bogh",
  "block.minecraft.banner.small_stripes.cyan": "SuDqu'bogh weSjech way 'ej wovbogh",
  "block.minecraft.banner.small_stripes.gray": "qIjbogh weSjech way 'ej wovbogh",
  "block.minecraft.banner.small_stripes.green": "SuDqu'bogh weSjech way",
  "block.minecraft.banner.small_stripes.light_blue": "SuDbogh weSjech way 'ej wovbogh",
  "block.minecraft.banner.small_stripes.light_gray": "qIjbogh weSjech way 'ej wovqu'bogh",
  "block.minecraft.banner.small_stripes.lime": "SuDqu'bogh weSjech way 'ej wovqu'bogh",
  "block.minecraft.banner.small_stripes.magenta": "Doqqu'bogh weSjech way 'ej wovbogh",
  "block.minecraft.banner.small_stripes.orange": "Doqbogh weSjech way 'ej beqpuj rurbogh",
  "block.minecraft.banner.small_stripes.pink": "Doqqu'bogh weSjech way 'ej wovqu'bogh",
  "block.minecraft.banner.small_stripes.purple": "ghIrep Hurgh rurbogh weSjech'e' way",
  "block.minecraft.banner.small_stripes.red": "Doqqu'bogh weSjech way",
  "block.minecraft.banner.small_stripes.white": "chISbogh weSjech way",
  "block.minecraft.banner.small_stripes.yellow": "SuDbogh weSjech way 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_left.black": "pIrmuS poS po'oH qIj",
  "block.minecraft.banner.square_bottom_left.blue": "SuDbogh pIrmuS poS po'oH 'ej Hurghbogh",
  "block.minecraft.banner.square_bottom_left.brown": "Doqbogh pIrmuS poS po'oH 'ej wovbe'bogh",
  "block.minecraft.banner.square_bottom_left.cyan": "SuDqu'bogh pIrmuS poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_left.gray": "qIjbogh pIrmuS poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_left.green": "pIrmuS poS po'oH SuDqu'",
  "block.minecraft.banner.square_bottom_left.light_blue": "SuDbogh pIrmuS poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_left.light_gray": "qIjbogh pIrmuS poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_left.lime": "SuDqu'bogh pIrmuS poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_left.magenta": "Doqqu'bogh pIrmuS poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_left.orange": "Doqbogh pIrmuS poS po'oH 'ej beqpuj rurbogh",
  "block.minecraft.banner.square_bottom_left.pink": "Doqqu'bogh pIrmuS poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_left.purple": "ghIrep Hurgh rurbogh pIrmuS poS po'oH'e'",
  "block.minecraft.banner.square_bottom_left.red": "pIrmuS poS po'oH Doqqu'",
  "block.minecraft.banner.square_bottom_left.white": "pIrmuS poS po'oH chIS",
  "block.minecraft.banner.square_bottom_left.yellow": "SuDbogh pIrmuS poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_right.black": "pIrmuS nIH po'oH qIj",
  "block.minecraft.banner.square_bottom_right.blue": "SuDbogh pIrmuS nIH po'oH 'ej Hurghbogh",
  "block.minecraft.banner.square_bottom_right.brown": "Doqbogh pIrmuS nIH po'oH 'ej wovbe'bogh",
  "block.minecraft.banner.square_bottom_right.cyan": "SuDqu'bogh pIrmuS nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_right.gray": "qIjbogh pIrmuS nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_right.green": "pIrmuS nIH po'oH SuDqu'",
  "block.minecraft.banner.square_bottom_right.light_blue": "SuDbogh pIrmuS nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_right.light_gray": "qIjbogh pIrmuS nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_right.lime": "SuDqu'bogh pIrmuS nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_right.magenta": "Doqqu'bogh pIrmuS nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_bottom_right.orange": "Doqbogh pIrmuS nIH po'oH 'ej beqpuj rurbogh",
  "block.minecraft.banner.square_bottom_right.pink": "Doqqu'bogh pIrmuS nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_bottom_right.purple": "ghIrep Hurgh rurbogh pIrmuS nIH po'oH'e'",
  "block.minecraft.banner.square_bottom_right.red": "pIrmuS nIH po'oH Doqqu'",
  "block.minecraft.banner.square_bottom_right.white": "pIrmuS nIH po'oH chIS",
  "block.minecraft.banner.square_bottom_right.yellow": "SuDbogh pIrmuS nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_left.black": "yor poS po'oH qIj",
  "block.minecraft.banner.square_top_left.blue": "SuDbogh yor poS po'oH 'ej Hurghbogh",
  "block.minecraft.banner.square_top_left.brown": "Doqbogh yor poS po'oH 'ej wovbe'bogh",
  "block.minecraft.banner.square_top_left.cyan": "SuDqu'bogh yor poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_left.gray": "qIjbogh yor poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_left.green": "yor poS po'oH SuDqu'",
  "block.minecraft.banner.square_top_left.light_blue": "SuDbogh yor poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_left.light_gray": "qIjbogh yor poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_left.lime": "SuDqu'bogh yor poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_left.magenta": "Doqqu'bogh yor poS po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_left.orange": "Doqbogh yor poS po'oH 'ej beqpuj rurbogh",
  "block.minecraft.banner.square_top_left.pink": "Doqqu'bogh yor poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_left.purple": "ghIrep Hurgh rurbogh yor poS po'oH'e'",
  "block.minecraft.banner.square_top_left.red": "yor poS po'oH Doqqu'",
  "block.minecraft.banner.square_top_left.white": "yor poS po'oH chIS",
  "block.minecraft.banner.square_top_left.yellow": "SuDbogh yor poS po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_right.black": "yor nIH po'oH qIj",
  "block.minecraft.banner.square_top_right.blue": "SuDbogh yor nIH po'oH 'ej Hurghbogh",
  "block.minecraft.banner.square_top_right.brown": "Doqbogh yor nIH po'oH 'ej wovbe'bogh",
  "block.minecraft.banner.square_top_right.cyan": "SuDqu'bogh yor nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_right.gray": "qIjbogh yor nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_right.green": "yor nIH po'oH SuDqu'",
  "block.minecraft.banner.square_top_right.light_blue": "SuDbogh yor nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_right.light_gray": "qIjbogh yor nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_right.lime": "SuDqu'bogh yor nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_right.magenta": "Doqqu'bogh yor nIH po'oH 'ej wovbogh",
  "block.minecraft.banner.square_top_right.orange": "Doqbogh yor nIH po'oH 'ej beqpuj rurbogh",
  "block.minecraft.banner.square_top_right.pink": "Doqqu'bogh yor nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.square_top_right.purple": "ghIrep Hurgh rurbogh yor nIH po'oH'e'",
  "block.minecraft.banner.square_top_right.red": "yor nIH po'oH Doqqu'",
  "block.minecraft.banner.square_top_right.white": "yor nIH po'oH chIS",
  "block.minecraft.banner.square_top_right.yellow": "SuDbogh yor nIH po'oH 'ej wovqu'bogh",
  "block.minecraft.banner.straight_cross.black": "me'cheD qIj",
  "block.minecraft.banner.straight_cross.blue": "SuDbogh me'cheD 'ej Hurghbogh",
  "block.minecraft.banner.straight_cross.brown": "Doqbogh me'cheD 'ej wovbe'bogh",
  "block.minecraft.banner.straight_cross.cyan": "SuDqu'bogh me'cheD 'ej wovbogh",
  "block.minecraft.banner.straight_cross.gray": "qIjbogh me'cheD 'ej wovbogh",
  "block.minecraft.banner.straight_cross.green": "me'cheD SuDqu'",
  "block.minecraft.banner.straight_cross.light_blue": "SuDbogh me'cheD 'ej wovbogh",
  "block.minecraft.banner.straight_cross.light_gray": "qIjbogh me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.straight_cross.lime": "SuDqu'bogh me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.straight_cross.magenta": "Doqqu'bogh me'cheD 'ej wovbogh",
  "block.minecraft.banner.straight_cross.orange": "Doqbogh me'cheD 'ej beqpuj rurbogh",
  "block.minecraft.banner.straight_cross.pink": "Doqqu'bogh me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.straight_cross.purple": "ghIrep Hurgh rurbogh me'cheD'e'",
  "block.minecraft.banner.straight_cross.red": "me'cheD Doqqu'",
  "block.minecraft.banner.straight_cross.white": "me'cheD chIS",
  "block.minecraft.banner.straight_cross.yellow": "SuDbogh me'cheD 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_bottom.black": "pIrmuS 'ejvoH qIj",
  "block.minecraft.banner.stripe_bottom.blue": "SuDbogh pIrmuS 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_bottom.brown": "Doqbogh pIrmuS 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_bottom.cyan": "SuDqu'bogh pIrmuS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_bottom.gray": "qIjbogh pIrmuS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_bottom.green": "pIrmuS 'ejvoH SuDqu'",
  "block.minecraft.banner.stripe_bottom.light_blue": "SuDbogh pIrmuS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_bottom.light_gray": "qIjbogh pIrmuS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_bottom.lime": "SuDqu'bogh pIrmuS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_bottom.magenta": "Doqqu'bogh pIrmuS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_bottom.orange": "Doqbogh pIrmuS 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_bottom.pink": "Doqqu'bogh pIrmuS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_bottom.purple": "ghIrep Hurgh rurbogh pIrmuS 'ejvoH'e'",
  "block.minecraft.banner.stripe_bottom.red": "pIrmuS 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_bottom.white": "pIrmuS 'ejvoH chIS",
  "block.minecraft.banner.stripe_bottom.yellow": "SuDbogh pIrmuS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_center.black": "botlh 'ejvoH chong qIj",
  "block.minecraft.banner.stripe_center.blue": "SuDbogh botlh 'ejvoH chong 'ej Hurghbogh",
  "block.minecraft.banner.stripe_center.brown": "Doqbogh botlh 'ejvoH chong 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_center.cyan": "SuDqu'bogh botlh 'ejvoH chong 'ej wovbogh",
  "block.minecraft.banner.stripe_center.gray": "qIjbogh botlh 'ejvoH chong 'ej wovbogh",
  "block.minecraft.banner.stripe_center.green": "botlh 'ejvoH chong SuDqu'",
  "block.minecraft.banner.stripe_center.light_blue": "SuDbogh botlh 'ejvoH chong 'ej wovbogh",
  "block.minecraft.banner.stripe_center.light_gray": "qIjbogh botlh 'ejvoH chong 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_center.lime": "SuDqu'bogh botlh 'ejvoH chong 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_center.magenta": "Doqqu'bogh botlh 'ejvoH chong 'ej wovbogh",
  "block.minecraft.banner.stripe_center.orange": "Doqbogh botlh 'ejvoH chong 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_center.pink": "Doqqu'bogh botlh 'ejvoH chong 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_center.purple": "ghIrep Hurgh rurbogh botlh 'ejvoH'e' chong",
  "block.minecraft.banner.stripe_center.red": "Doqqu'bogh botlh 'ejvoH chong",
  "block.minecraft.banner.stripe_center.white": "chISbogh botlh 'ejvoH chong",
  "block.minecraft.banner.stripe_center.yellow": "SuDbogh botlh 'ejvoH chong 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downleft.black": "poS bo'ghey 'ejvoH qIj",
  "block.minecraft.banner.stripe_downleft.blue": "SuDbogh poS bo'ghey 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_downleft.brown": "Doqbogh poS bo'ghey 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_downleft.cyan": "SuDqu'bogh poS bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downleft.gray": "qIjbogh poS bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downleft.green": "poS bo'ghey 'ejvoH SuDqu'",
  "block.minecraft.banner.stripe_downleft.light_blue": "SuDbogh poS bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downleft.light_gray": "qIjbogh poS bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downleft.lime": "SuDqu'bogh poS bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downleft.magenta": "Doqqu'bogh poS bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downleft.orange": "Doqbogh poS bo'ghey 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_downleft.pink": "Doqqu'bogh poS bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downleft.purple": "ghIrep Hurgh rurbogh poS bo'ghey 'ejvoH'e'",
  "block.minecraft.banner.stripe_downleft.red": "poS bo'ghey 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_downleft.white": "poS bo'ghey 'ejvoH chIS",
  "block.minecraft.banner.stripe_downleft.yellow": "SuDbogh poS bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downright.black": "nIH bo'ghey 'ejvoH qIj",
  "block.minecraft.banner.stripe_downright.blue": "SuDbogh nIH bo'ghey 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_downright.brown": "Doqbogh nIH bo'ghey 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_downright.cyan": "SuDqu'bogh nIH bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downright.gray": "qIjbogh nIH bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downright.green": "nIH bo'ghey 'ejvoH SuDqu'",
  "block.minecraft.banner.stripe_downright.light_blue": "SuDbogh nIH bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downright.light_gray": "qIjbogh nIH bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downright.lime": "SuDqu'bogh nIH bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downright.magenta": "Doqqu'bogh nIH bo'ghey 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_downright.orange": "Doqbogh nIH bo'ghey 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_downright.pink": "Doqqu'bogh nIH bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_downright.purple": "ghIrep Hurgh rurbogh nIH bo'ghey 'ejvoH'e'",
  "block.minecraft.banner.stripe_downright.red": "nIH bo'ghey 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_downright.white": "nIH bo'ghey 'ejvoH chIS",
  "block.minecraft.banner.stripe_downright.yellow": "SuDbogh nIH bo'ghey 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_left.black": "poS 'ejvoH qIj",
  "block.minecraft.banner.stripe_left.blue": "SuDbogh poS 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_left.brown": "Doqbogh poS 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_left.cyan": "SuDqu'bogh poS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_left.gray": "qIjbogh poS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_left.green": "poS 'ejvoH SuDqu'",
  "block.minecraft.banner.stripe_left.light_blue": "SuDbogh poS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_left.light_gray": "qIjbogh poS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_left.lime": "SuDqu'bogh poS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_left.magenta": "Doqqu'bogh poS 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_left.orange": "Doqbogh poS 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_left.pink": "Doqqu'bogh poS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_left.purple": "ghIrep Hurgh rurbogh poS 'ejvoH'e'",
  "block.minecraft.banner.stripe_left.red": "poS 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_left.white": "poS 'ejvoH chIS",
  "block.minecraft.banner.stripe_left.yellow": "SuDbogh poS 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_middle.black": "qIjbogh botlh 'ejvoH SaS",
  "block.minecraft.banner.stripe_middle.blue": "SuDbogh botlh 'ejvoH SaS 'ej Hurghbogh",
  "block.minecraft.banner.stripe_middle.brown": "Doqbogh botlh 'ejvoH SaS 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_middle.cyan": "SuDqu'bogh botlh 'ejvoH SaS 'ej wovbogh",
  "block.minecraft.banner.stripe_middle.gray": "qIjbogh botlh 'ejvoH SaS 'ej wovbogh",
  "block.minecraft.banner.stripe_middle.green": "SuDqu'bogh botlh 'ejvoH SaS",
  "block.minecraft.banner.stripe_middle.light_blue": "SuDbogh botlh 'ejvoH SaS 'ej wovbogh",
  "block.minecraft.banner.stripe_middle.light_gray": "qIjbogh botlh 'ejvoH SaS 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_middle.lime": "SuDqu'bogh botlh 'ejvoH SaS 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_middle.magenta": "Doqqu'bogh botlh 'ejvoH SaS 'ej wovbogh",
  "block.minecraft.banner.stripe_middle.orange": "Doqbogh botlh 'ejvoH SaS 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_middle.pink": "Doqqu'bogh botlh 'ejvoH SaS 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_middle.purple": "ghIrep Hurgh rurbogh botlh 'ejvoH'e' SaS",
  "block.minecraft.banner.stripe_middle.red": "Doqqu'bogh botlh 'ejvoH SaS",
  "block.minecraft.banner.stripe_middle.white": "chISbogh botlh 'ejvoH SaS",
  "block.minecraft.banner.stripe_middle.yellow": "SuDbogh botlh 'ejvoH SaS 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_right.black": "nIH 'ejvoH qIj",
  "block.minecraft.banner.stripe_right.blue": "SuDbogh nIH 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_right.brown": "Doqbogh nIH 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_right.cyan": "SuDqu'bogh nIH 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_right.gray": "qIjbogh nIH 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_right.green": "nIH 'ejvoH SuDqu'",
  "block.minecraft.banner.stripe_right.light_blue": "SuDbogh nIH 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_right.light_gray": "qIjbogh nIH 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_right.lime": "SuDqu'bogh nIH 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_right.magenta": "Doqqu'bogh nIH 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_right.orange": "Doqbogh nIH 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_right.pink": "Doqqu'bogh nIH 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_right.purple": "ghIrep Hurgh rurbogh nIH 'ejvoH'e'",
  "block.minecraft.banner.stripe_right.red": "nIH 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_right.white": "nIH 'ejvoH chIS",
  "block.minecraft.banner.stripe_right.yellow": "SuDbogh nIH 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_top.black": "yor 'ejvoH qIj",
  "block.minecraft.banner.stripe_top.blue": "SuDbogh yor 'ejvoH 'ej Hurghbogh",
  "block.minecraft.banner.stripe_top.brown": "Doqbogh yor 'ejvoH 'ej wovbe'bogh",
  "block.minecraft.banner.stripe_top.cyan": "SuDqu'bogh yor 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_top.gray": "qIjbogh yor 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_top.green": "SuDqu' yor 'ejvoH",
  "block.minecraft.banner.stripe_top.light_blue": "SuDbogh yor 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_top.light_gray": "qIjbogh yor 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_top.lime": "SuDqu'bogh yor 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_top.magenta": "Doqqu'bogh yor 'ejvoH 'ej wovbogh",
  "block.minecraft.banner.stripe_top.orange": "Doqbogh yor 'ejvoH 'ej beqpuj rurbogh",
  "block.minecraft.banner.stripe_top.pink": "Doqqu'bogh yor 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.stripe_top.purple": "ghIrep Hurgh rurbogh yor 'ejvoH'e'",
  "block.minecraft.banner.stripe_top.red": "yor 'ejvoH Doqqu'",
  "block.minecraft.banner.stripe_top.white": "yor 'ejvoH chIS",
  "block.minecraft.banner.stripe_top.yellow": "SuDbogh yor 'ejvoH 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_bottom.black": "pIrmuS ra'Duch qIj",
  "block.minecraft.banner.triangle_bottom.blue": "SuDbogh pIrmuS ra'Duch 'ej Hurghbogh",
  "block.minecraft.banner.triangle_bottom.brown": "Doqbogh pIrmuS ra'Duch 'ej wovbe'bogh",
  "block.minecraft.banner.triangle_bottom.cyan": "SuDqu'bogh pIrmuS ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_bottom.gray": "qIjbogh pIrmuS ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_bottom.green": "pIrmuS ra'Duch SuDqu'",
  "block.minecraft.banner.triangle_bottom.light_blue": "SuDbogh pIrmuS ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_bottom.light_gray": "qIjbogh pIrmuS ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_bottom.lime": "SuDqu'bogh pIrmuS ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_bottom.magenta": "Doqqu'bogh pIrmuS ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_bottom.orange": "Doqbogh pIrmuS ra'Duch 'ej beqpuj rurbogh",
  "block.minecraft.banner.triangle_bottom.pink": "Doqqu'bogh pIrmuS ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_bottom.purple": "ghIrep Hurgh rurbogh pIrmuS ra'Duch'e'",
  "block.minecraft.banner.triangle_bottom.red": "pIrmuS ra'Duch Doqqu'",
  "block.minecraft.banner.triangle_bottom.white": "pIrmuS ra'Duch chIS",
  "block.minecraft.banner.triangle_bottom.yellow": "SuDbogh pIrmuS ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_top.black": "yor ra'Duch qIj",
  "block.minecraft.banner.triangle_top.blue": "SuDbogh yor ra'Duch 'ej Hurghbogh",
  "block.minecraft.banner.triangle_top.brown": "Doqbogh yor ra'Duch 'ej wovbe'bogh",
  "block.minecraft.banner.triangle_top.cyan": "SuDqu'bogh yor ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_top.gray": "qIjbogh yor ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_top.green": "yor ra'Duch SuDqu'",
  "block.minecraft.banner.triangle_top.light_blue": "SuDbogh yor ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_top.light_gray": "qIjbogh yor ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_top.lime": "SuDqu'bogh yor ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_top.magenta": "Doqqu'bogh yor ra'Duch 'ej wovbogh",
  "block.minecraft.banner.triangle_top.orange": "Doqbogh yor ra'Duch 'ej beqpuj rurbogh",
  "block.minecraft.banner.triangle_top.pink": "Doqqu'bogh yor ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangle_top.purple": "ghIrep Hurgh rurbogh yor ra'Duch'e'",
  "block.minecraft.banner.triangle_top.red": "yor ra'Duch Doqqu'",
  "block.minecraft.banner.triangle_top.white": "yor ra'Duch chIS",
  "block.minecraft.banner.triangle_top.yellow": "SuDbogh yor ra'Duch 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_bottom.black": "pIrmuS Ho'Du' qIj",
  "block.minecraft.banner.triangles_bottom.blue": "SuDbogh pIrmuS Ho'Du' 'ej Hurghbogh",
  "block.minecraft.banner.triangles_bottom.brown": "Doqbogh pIrmuS Ho'Du' 'ej wovbe'bogh",
  "block.minecraft.banner.triangles_bottom.cyan": "SuDqu'bogh pIrmuS Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_bottom.gray": "qIjbogh pIrmuS Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_bottom.green": "pIrmuS Ho'Du' SuDqu'",
  "block.minecraft.banner.triangles_bottom.light_blue": "SuDbogh pIrmuS Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_bottom.light_gray": "qIjbogh pIrmuS Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_bottom.lime": "SuDqu'bogh pIrmuS Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_bottom.magenta": "Doqqu'bogh pIrmuS Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_bottom.orange": "Doqbogh pIrmuS Ho'Du' 'ej beqpuj rurbogh",
  "block.minecraft.banner.triangles_bottom.pink": "Doqqu'bogh pIrmuS Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_bottom.purple": "ghIrep Hurgh rurbogh pIrmuS Ho'Du''e'",
  "block.minecraft.banner.triangles_bottom.red": "pIrmuS Ho'Du' Doqqu'",
  "block.minecraft.banner.triangles_bottom.white": "pIrmuS Ho'Du' chIS",
  "block.minecraft.banner.triangles_bottom.yellow": "SuDbogh pIrmuS Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_top.black": "yor Ho'Du' qIj",
  "block.minecraft.banner.triangles_top.blue": "SuDbogh yor Ho'Du' 'ej Hurghbogh",
  "block.minecraft.banner.triangles_top.brown": "Doqbogh yor Ho'Du' 'ej wovbe'bogh",
  "block.minecraft.banner.triangles_top.cyan": "SuDqu'bogh yor Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_top.gray": "qIjbogh yor Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_top.green": "yor Ho'Du' SuDqu'",
  "block.minecraft.banner.triangles_top.light_blue": "SuDbogh yor Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_top.light_gray": "qIjbogh yor Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_top.lime": "SuDqu'bogh yor Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_top.magenta": "Doqqu'bogh yor Ho'Du' 'ej wovbogh",
  "block.minecraft.banner.triangles_top.orange": "Doqbogh yor Ho'Du' 'ej beqpuj rurbogh",
  "block.minecraft.banner.triangles_top.pink": "Doqqu'bogh yor Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.banner.triangles_top.purple": "ghIrep Hurgh rurbogh yor Ho'Du''e'",
  "block.minecraft.banner.triangles_top.red": "yor Ho'Du' Doqqu'",
  "block.minecraft.banner.triangles_top.white": "yor Ho'Du' chIS",
  "block.minecraft.banner.triangles_top.yellow": "SuDbogh yor Ho'Du' 'ej wovqu'bogh",
  "block.minecraft.barrel": "qegh",
  "block.minecraft.barrier": "botwI' buq'Ir",
  "block.minecraft.basalt": "Hotnagh",
  "block.minecraft.beacon": "rI'meH wovmoHwI'",
  "block.minecraft.beacon.primary": "HoS'a'",
  "block.minecraft.beacon.secondary": "HoS cha'DIch",
  "block.minecraft.bed.no_sleep": "bIQongmeH qaSnIStaH ram qoj jevnIStaH muD",
  "block.minecraft.bed.not_safe": "bIQonglaHbe'; SoH Sum tlhapragh",
  "block.minecraft.bed.obstructed": "QongDaqvam waQlu'",
  "block.minecraft.bed.occupied": "buy' QongDaqvam",
  "block.minecraft.bed.too_far_away": "bIQonglaHbe'; tlhoy Hop QongDaq",
  "block.minecraft.bedrock": "ghorbe'bogh nagh",
  "block.minecraft.bee_nest": "lachvoH but",
  "block.minecraft.beehive": "lachvoH",
  "block.minecraft.beetroots": "'oQqarmey Doqqu'",
  "block.minecraft.bell": "'In",
  "block.minecraft.big_dripleaf": "por tom tIn",
  "block.minecraft.big_dripleaf_stem": "por tom Qechjem",
  "block.minecraft.birch_button": "berIch Sor leQ",
  "block.minecraft.birch_door": "berIch Sor lojmIt",
  "block.minecraft.birch_fence": "berIch Sor Solrogh",
  "block.minecraft.birch_fence_gate": "berIch Sor Solrogh lojmIt",
  "block.minecraft.birch_hanging_sign": "berIch Sor QIn 'echlet tlhep",
  "block.minecraft.birch_leaves": "berIch Sor pormey",
  "block.minecraft.birch_log": "berIch Sor Qechjem'a'",
  "block.minecraft.birch_planks": "berIch Sor 'echletmey",
  "block.minecraft.birch_pressure_plate": "berIch Sor Surmen 'echlet",
  "block.minecraft.birch_sapling": "berIch SorHom",
  "block.minecraft.birch_shelf": "berIch Sor yorgh",
  "block.minecraft.birch_sign": "berIch Sor QIn 'echlet",
  "block.minecraft.birch_slab": "berIch Sor buq'Ir bID",
  "block.minecraft.birch_stairs": "berIch Sor letlh",
  "block.minecraft.birch_trapdoor": "berIch Sor vonmeH lojmIt",
  "block.minecraft.birch_wall_hanging_sign": "berIch Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.birch_wall_sign": "berIch Sor tlhoy' QIn 'echlet",
  "block.minecraft.birch_wood": "berIch Sor Hap",
  "block.minecraft.black_banner": "joqwI' qIj",
  "block.minecraft.black_bed": "QongDaq qIj",
  "block.minecraft.black_candle": "weQ qIj",
  "block.minecraft.black_candle_cake": "weQ qIj ghajbogh chab",
  "block.minecraft.black_carpet": "tlhIm qIj",
  "block.minecraft.black_concrete": "tungyen qIj",
  "block.minecraft.black_concrete_powder": "tungyen Say'qIS qIj",
  "block.minecraft.black_glazed_terracotta": "qIjbogh HaSreH nagh ghun",
  "block.minecraft.black_shulker_box": "shulker ngaSwI' qIj",
  "block.minecraft.black_stained_glass": "'al'on qIj",
  "block.minecraft.black_stained_glass_pane": "'al'on 'echlet qIj",
  "block.minecraft.black_terracotta": "qIjbogh nagh ghun",
  "block.minecraft.black_wool": "veD qIj",
  "block.minecraft.blackstone": "nagh qIj",
  "block.minecraft.blackstone_slab": "nagh qIj buq'Ir bID",
  "block.minecraft.blackstone_stairs": "nagh qIj letlh",
  "block.minecraft.blackstone_wall": "nagh qIj tlhoy'",
  "block.minecraft.blast_furnace": "vIncha' tujqu'",
  "block.minecraft.blue_banner": "SuDbogh joqwI' 'ej Hurghbogh",
  "block.minecraft.blue_bed": "SuDbogh QongDaq 'ej Hurghbogh",
  "block.minecraft.blue_candle": "SuDbogh weQ 'ej Hurghbogh",
  "block.minecraft.blue_candle_cake": "SuDbogh weQ 'ej Hurghbogh ghajbogh chab",
  "block.minecraft.blue_carpet": "SuDbogh tlhIm 'ej Hurghbogh",
  "block.minecraft.blue_concrete": "SuDbogh tungyen 'ej Hurghbogh",
  "block.minecraft.blue_concrete_powder": "SuDbogh tungyen Say'qIS 'ej Hurghbogh",
  "block.minecraft.blue_glazed_terracotta": "SuDbogh HaSreH nagh ghun 'ej Hurghbogh",
  "block.minecraft.blue_ice": "chuch SuD",
  "block.minecraft.blue_orchid": "bIlu 'orqID 'InSong",
  "block.minecraft.blue_shulker_box": "SuDbogh shulker ngaSwI' 'ej Hurghbogh",
  "block.minecraft.blue_stained_glass": "'al'on SuD",
  "block.minecraft.blue_stained_glass_pane": "'al'on 'echlet SuD",
  "block.minecraft.blue_terracotta": "SuDbogh nagh ghun 'ej Hurghbogh",
  "block.minecraft.blue_wool": "SuDbogh veD 'ej Hurghbogh",
  "block.minecraft.bone_block": "Hom buq'Ir",
  "block.minecraft.bookshelf": "paq bey'",
  "block.minecraft.brain_coral": "QoghIj 'oqe'",
  "block.minecraft.brain_coral_block": "QoghIj 'oqe' buq'Ir",
  "block.minecraft.brain_coral_fan": "QoghIj 'oqe' mIjDang",
  "block.minecraft.brain_coral_wall_fan": "QoghIj 'oqe' tlhoy' mIjDang",
  "block.minecraft.brewing_stand": "taS vutmeH qal'aq",
  "block.minecraft.brick_slab": "ngoghmey buq'Ir bID",
  "block.minecraft.brick_stairs": "ngogh letlh",
  "block.minecraft.brick_wall": "ngoghmey tlhoy'",
  "block.minecraft.bricks": "ngoghmey",
  "block.minecraft.brown_banner": "Doqbogh joqwI' 'ej wovbe'bogh",
  "block.minecraft.brown_bed": "Doqbogh QongDaq 'ej wovbe'bogh",
  "block.minecraft.brown_candle": "Doqbogh weQ 'ej wovbe'bogh",
  "block.minecraft.brown_candle_cake": "Doqbogh weQ 'ej wovbe'bogh ghajbogh chab",
  "block.minecraft.brown_carpet": "Doqbogh tlhIm 'ej wovbe'bogh",
  "block.minecraft.brown_concrete": "Doqbogh tungyen 'ej wovbe'bogh",
  "block.minecraft.brown_concrete_powder": "Doqbogh tungyen Say'qIS 'ej wovbe'bogh",
  "block.minecraft.brown_glazed_terracotta": "Doqbogh HaSreH nagh ghun 'ej wovbe'bogh",
  "block.minecraft.brown_mushroom": "yav 'atlhqam wovbe'",
  "block.minecraft.brown_mushroom_block": "yav 'atlhqam wovbe' buq'Ir",
  "block.minecraft.brown_shulker_box": "Doqbogh shulker ngaSwI' 'ej wovbe'bogh",
  "block.minecraft.brown_stained_glass": "'al'on Doq 'ej Hurgh",
  "block.minecraft.brown_stained_glass_pane": "'al'on 'echlet Doq 'ej Hurgh",
  "block.minecraft.brown_terracotta": "Doqbogh nagh ghun 'ej wovbe'bogh",
  "block.minecraft.brown_wool": "Doqbogh veD 'ej wovbe'bogh",
  "block.minecraft.bubble_column": "ba'Suq tut",
  "block.minecraft.bubble_coral": "ba'Suq 'oqe'",
  "block.minecraft.bubble_coral_block": "ba'Suq 'oqe' buq'Ir",
  "block.minecraft.bubble_coral_fan": "ba'Suq 'oqe' mIjDang",
  "block.minecraft.bubble_coral_wall_fan": "ba'Suq 'oqe' tlhoy' mIjDang",
  "block.minecraft.budding_amethyst": "Sachbogh choSom nguv",
  "block.minecraft.bush": "lav",
  "block.minecraft.cactus": "qaqtaS San'emDer",
  "block.minecraft.cactus_flower": "qaqtaS 'InSong",
  "block.minecraft.cake": "chab",
  "block.minecraft.calcite": "'apraQ nagh",
  "block.minecraft.calibrated_sculk_sensor": "sculk noch pup",
  "block.minecraft.campfire": "raQ qul",
  "block.minecraft.candle": "weQ",
  "block.minecraft.candle_cake": "weQ ghajbogh chab",
  "block.minecraft.carrots": "qe'rot 'oQqarmey",
  "block.minecraft.cartography_table": "pu'jIn raS",
  "block.minecraft.carved_pumpkin": "'aquta' naH pe'lu'ta'bogh",
  "block.minecraft.cauldron": "bargh'a'",
  "block.minecraft.cave_air": "DIS rewve'",
  "block.minecraft.cave_vines": "DIS 'arDeH",
  "block.minecraft.cave_vines_plant": "DIS 'arDeH San'emDer",
  "block.minecraft.chain": "mIr",
  "block.minecraft.chain_command_block": "mIr ra'wI' buq'Ir",
  "block.minecraft.cherry_button": "tapqej Sor leQ",
  "block.minecraft.cherry_door": "tapqej Sor lojmIt",
  "block.minecraft.cherry_fence": "tapqej Sor tlhoy'Hom",
  "block.minecraft.cherry_fence_gate": "tapqej Sor tlhoy'Hom lojmIt",
  "block.minecraft.cherry_hanging_sign": "tapqej Sor QIn 'echlet tlhep",
  "block.minecraft.cherry_leaves": "tapqej Sor pormey",
  "block.minecraft.cherry_log": "tapqej Sor Qechjem'a'",
  "block.minecraft.cherry_planks": "tapqej Sor 'echletmey",
  "block.minecraft.cherry_pressure_plate": "tapqej Sor Surmen 'echlet",
  "block.minecraft.cherry_sapling": "tapqej SorHom",
  "block.minecraft.cherry_shelf": "tapqej Sor yorgh",
  "block.minecraft.cherry_sign": "tapqej Sor QIn 'echlet",
  "block.minecraft.cherry_slab": "tapqej Sor buq'Ir bID",
  "block.minecraft.cherry_stairs": "tapqej Sor letlh",
  "block.minecraft.cherry_trapdoor": "tapqej Sor vonmeH lojmIt",
  "block.minecraft.cherry_wall_hanging_sign": "tapqej Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.cherry_wall_sign": "tapqej Sor tlhoy' QIn 'echlet",
  "block.minecraft.cherry_wood": "tapqej Sor Hap",
  "block.minecraft.chest": "DerlIq",
  "block.minecraft.chipped_anvil": "'achme' QIHlu'pu'bogh",
  "block.minecraft.chiseled_bookshelf": "paq yorgh nanlu'bogh",
  "block.minecraft.chiseled_copper": "Sorpuq nanlu'bogh",
  "block.minecraft.chiseled_deepslate": "qIj'am jaQ nanlu'bogh",
  "block.minecraft.chiseled_nether_bricks": "nether ngoghmey nanlu'bogh",
  "block.minecraft.chiseled_polished_blackstone": "Habqu'bogh nagh qIj nanlu'bogh",
  "block.minecraft.chiseled_quartz_block": "choSom buq'Ir nanlu'bogh",
  "block.minecraft.chiseled_red_sandstone": "Do'ol nagh Doq nanlu'bogh",
  "block.minecraft.chiseled_resin_bricks": "rebmugh ngoghmey nanlu'bogh",
  "block.minecraft.chiseled_sandstone": "Do'ol nagh nanlu'bogh",
  "block.minecraft.chiseled_stone_bricks": "nagh ngoghmey nanlu'bogh",
  "block.minecraft.chiseled_tuff": "tIpqan nagh nanlu'bogh",
  "block.minecraft.chiseled_tuff_bricks": "tIpqan nagh ngoghmey nanlu'bogh",
  "block.minecraft.chorus_flower": "bomwI' ghom 'InSong",
  "block.minecraft.chorus_plant": "bomwI' ghom San'emDer",
  "block.minecraft.clay": "DabqI'",
  "block.minecraft.closed_eyeblossom": "mIn 'InSong SoQ",
  "block.minecraft.coal_block": "meStlhal buq'Ir",
  "block.minecraft.coal_ore": "nagh meStlhal",
  "block.minecraft.coarse_dirt": "lam ghegh",
  "block.minecraft.cobbled_deepslate": "tlherbogh qIj'am jaQ",
  "block.minecraft.cobbled_deepslate_slab": "tlherbogh qIj'am jaQ buq'Ir bID",
  "block.minecraft.cobbled_deepslate_stairs": "tlherbogh qIj'am jaQ letlh",
  "block.minecraft.cobbled_deepslate_wall": "tlherbogh qIj'am jaQ tlhoy'",
  "block.minecraft.cobblestone": "nagh tlher",
  "block.minecraft.cobblestone_slab": "nagh tlher buq'Ir bID",
  "block.minecraft.cobblestone_stairs": "nagh tlher letlh",
  "block.minecraft.cobblestone_wall": "nagh tlher tlhoy'",
  "block.minecraft.cobweb": "SIrgh SIr'o'",
  "block.minecraft.cocoa": "yuch",
  "block.minecraft.command_block": "ra'wI' buq'Ir",
  "block.minecraft.comparator": "redstone DaywI'",
  "block.minecraft.composter": "nonmoHwI' 'Ib",
  "block.minecraft.conduit": "'och",
  "block.minecraft.copper_bars": "Sorpuq naQmey",
  "block.minecraft.copper_block": "Sorpuq buq'Ir",
  "block.minecraft.copper_bulb": "Sorpuq wovmoHwI'",
  "block.minecraft.copper_chain": "Sorpuq mIr",
  "block.minecraft.copper_chest": "Sorpuq DerlIq",
  "block.minecraft.copper_door": "Sorpuq lojmIt",
  "block.minecraft.copper_golem_statue": "Sorpuq yoq pargh Hew",
  "block.minecraft.copper_grate": "Sorpuq neng'el",
  "block.minecraft.copper_lantern": "Sorpuq Sech 'aplo'",
  "block.minecraft.copper_ore": "nagh Sorpuq",
  "block.minecraft.copper_torch": "Sorpuq Sech",
  "block.minecraft.copper_trapdoor": "Sorpuq vonmeH lojmIt",
  "block.minecraft.copper_wall_torch": "Sorpuq tlhoy' Sech",
  "block.minecraft.cornflower": "qorInvIlaw''er 'InSong",
  "block.minecraft.cracked_deepslate_bricks": "qIj'am jaQ ngoghmey maD",
  "block.minecraft.cracked_deepslate_tiles": "qIj'am jaQ majyang maD",
  "block.minecraft.cracked_nether_bricks": "nether ngogh maD",
  "block.minecraft.cracked_polished_blackstone_bricks": "Habbogh nagh qIj ngoghmey maD",
  "block.minecraft.cracked_stone_bricks": "nagh ngoghmey maD",
  "block.minecraft.crafter": "chenmoHwI'",
  "block.minecraft.crafting_table": "vummeH raS",
  "block.minecraft.creaking_heart": "HaSwI' tIq",
  "block.minecraft.creeper_head": "creeper nach",
  "block.minecraft.creeper_wall_head": "creeper tlhoy' nach",
  "block.minecraft.crimson_button": "nether Sor Doq leQ",
  "block.minecraft.crimson_door": "nether Sor Doq lojmIt",
  "block.minecraft.crimson_fence": "nether Sor Doq tlhoy'Hom",
  "block.minecraft.crimson_fence_gate": "nether Sor Doq tlhoy'Hom lojmIt",
  "block.minecraft.crimson_fungus": "'atlhqam Doq",
  "block.minecraft.crimson_hanging_sign": "nether Sor Doq QIn 'echlet tlhep",
  "block.minecraft.crimson_hyphae": "nether Sor Doq SIylaw'mey",
  "block.minecraft.crimson_nylium": "nether magh Doq",
  "block.minecraft.crimson_planks": "nether Sor Doq 'echletmey",
  "block.minecraft.crimson_pressure_plate": "nether Sor Doq Surmen 'echlet",
  "block.minecraft.crimson_roots": "'oQqar Doq",
  "block.minecraft.crimson_shelf": "nether Sor Doq yorgh",
  "block.minecraft.crimson_sign": "nether Sor Doq QIn 'echlet",
  "block.minecraft.crimson_slab": "nether Sor Doq buq'Ir bID",
  "block.minecraft.crimson_stairs": "nether Sor Doq letlh",
  "block.minecraft.crimson_stem": "nether Sor Doq Qechjem",
  "block.minecraft.crimson_trapdoor": "nether Sor Doq vonmeH lojmIt",
  "block.minecraft.crimson_wall_hanging_sign": "nether Sor Doq tlhoy' QIn 'echlet tlhep",
  "block.minecraft.crimson_wall_sign": "nether Sor Doq tlhoy' QIn 'echlet",
  "block.minecraft.crying_obsidian": "SaQbogh 'al'on nagh",
  "block.minecraft.cut_copper": "Sorpuq pe'lu'bogh",
  "block.minecraft.cut_copper_slab": "Sorpuq pe'lu'bogh buq'Ir bID",
  "block.minecraft.cut_copper_stairs": "Sorpuq pe'lu'bogh letlh",
  "block.minecraft.cut_red_sandstone": "Do'ol nagh Doq pe'lu'bogh",
  "block.minecraft.cut_red_sandstone_slab": "Do'ol nagh Doq pe'lu'bogh buq'Ir bID",
  "block.minecraft.cut_sandstone": "Do'ol nagh pe'lu'bogh",
  "block.minecraft.cut_sandstone_slab": "Do'ol nagh pe'lu'bogh buq'Ir bID",
  "block.minecraft.cyan_banner": "SuDqu'bogh joqwI' 'ej wovbogh",
  "block.minecraft.cyan_bed": "SuDqu'bogh QongDaq 'ej wovbogh",
  "block.minecraft.cyan_candle": "SuDqu'bogh weQ 'ej wovbogh",
  "block.minecraft.cyan_candle_cake": "SuDqu'bogh weQ 'ej wovbogh ghajbogh chab",
  "block.minecraft.cyan_carpet": "SuDqu'bogh tlhIm 'ej wovbogh",
  "block.minecraft.cyan_concrete": "SuDqu'bogh tungyen 'ej wovbogh",
  "block.minecraft.cyan_concrete_powder": "SuDqu'bogh tungyen Say'qIS 'ej wovbogh",
  "block.minecraft.cyan_glazed_terracotta": "SuDqu'bogh HaSreH nagh ghun 'ej wovbogh",
  "block.minecraft.cyan_shulker_box": "SuDqu'bogh shulker ngaSwI' 'ej wovbogh",
  "block.minecraft.cyan_stained_glass": "SuDqu'bogh 'al'on 'ej wovbogh",
  "block.minecraft.cyan_stained_glass_pane": "SuDqu'bogh 'al'on 'echlet 'ej wovbogh",
  "block.minecraft.cyan_terracotta": "SuDqu'bogh nagh ghun 'ej wovbogh",
  "block.minecraft.cyan_wool": "SuDqu'bogh veD 'ej wovbogh",
  "block.minecraft.damaged_anvil": "'achme' QIHqu'lu'pu'bogh",
  "block.minecraft.dandelion": "DanDelay'an 'InSong",
  "block.minecraft.dark_oak_button": "'oq Hurgh Sor leQ",
  "block.minecraft.dark_oak_door": "Sor Hurgh lojmIt",
  "block.minecraft.dark_oak_fence": "'oq Hurgh Sor tlhoy'Hom",
  "block.minecraft.dark_oak_fence_gate": "'oq Hurgh Sor tlhoy'Hom lojmIt",
  "block.minecraft.dark_oak_hanging_sign": "'oq Hurgh Sor QIn 'echlet tlhep",
  "block.minecraft.dark_oak_leaves": "'oq Hurgh Sor pormey",
  "block.minecraft.dark_oak_log": "'oq Hurgh Sor Qechjem'a'",
  "block.minecraft.dark_oak_planks": "'oq Hurgh Sor 'echletmey",
  "block.minecraft.dark_oak_pressure_plate": "'oq Hurgh Sor Surmen 'echlet",
  "block.minecraft.dark_oak_sapling": "'oq Hurgh SorHom",
  "block.minecraft.dark_oak_shelf": "'oq Hurgh Sor yorgh",
  "block.minecraft.dark_oak_sign": "'oq Hurgh Sor QIn 'echlet",
  "block.minecraft.dark_oak_slab": "'oq Hurgh Sor buq'Ir bID",
  "block.minecraft.dark_oak_stairs": "'oq Hurgh Sor letlh",
  "block.minecraft.dark_oak_trapdoor": "'oq Hurgh Sor vonmeH lojmIt",
  "block.minecraft.dark_oak_wall_hanging_sign": "'oq Hurgh Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.dark_oak_wall_sign": "'oq Hurgh Sor tlhoy' QIn 'echlet",
  "block.minecraft.dark_oak_wood": "'oq Hurgh Sor Hap",
  "block.minecraft.dark_prismarine": "prismarine Hurgh",
  "block.minecraft.dark_prismarine_slab": "prismarine Hurgh buq'Ir bID",
  "block.minecraft.dark_prismarine_stairs": "prismarine Hurgh letlh",
  "block.minecraft.daylight_detector": "pem noch",
  "block.minecraft.dead_brain_coral": "Heghpu'bogh QoghIj 'oqe'",
  "block.minecraft.dead_brain_coral_block": "Heghpu'bogh QoghIj 'oqe' buq'Ir",
  "block.minecraft.dead_brain_coral_fan": "Heghpu'bogh QoghIj 'oqe' mIjDang",
  "block.minecraft.dead_brain_coral_wall_fan": "Heghpu'bogh QoghIj 'oqe' tlhoy' mIjDang",
  "block.minecraft.dead_bubble_coral": "Heghpu'bogh ba'Suq 'oqe'",
  "block.minecraft.dead_bubble_coral_block": "Heghpu'bogh ba'Suq 'oqe' buq'Ir",
  "block.minecraft.dead_bubble_coral_fan": "Heghpu'bogh ba'Suq 'oqe' mIjDang",
  "block.minecraft.dead_bubble_coral_wall_fan": "Heghpu'bogh ba'Suq 'oqe' tlhoy' mIjDang",
  "block.minecraft.dead_bush": "Heghbogh lav",
  "block.minecraft.dead_fire_coral": "Heghpu'bogh qul 'oqe'",
  "block.minecraft.dead_fire_coral_block": "Heghpu'bogh qul 'oqe' buq'Ir",
  "block.minecraft.dead_fire_coral_fan": "Heghpu'bogh qul 'oqe' mIjDang",
  "block.minecraft.dead_fire_coral_wall_fan": "Heghpu'bogh qul 'oqe' tlhoy' mIjDang",
  "block.minecraft.dead_horn_coral": "Heghpu'bogh pu' 'oqe'",
  "block.minecraft.dead_horn_coral_block": "Heghpu'bogh pu' 'oqe' buq'Ir",
  "block.minecraft.dead_horn_coral_fan": "Heghpu'bogh pu' 'oqe' mIjDang",
  "block.minecraft.dead_horn_coral_wall_fan": "Heghpu'bogh pu' 'oqe' tlhoy' mIjDang",
  "block.minecraft.dead_tube_coral": "Heghpu'bogh 'och 'oqe'",
  "block.minecraft.dead_tube_coral_block": "Heghpu'bogh 'och 'oqe' buq'Ir",
  "block.minecraft.dead_tube_coral_fan": "Heghpu'bogh 'och 'oqe' mIjDang",
  "block.minecraft.dead_tube_coral_wall_fan": "Heghpu'bogh 'och 'oqe' tlhoy' mIjDang",
  "block.minecraft.decorated_pot": "bal putlh",
  "block.minecraft.deepslate": "qIj'am jaQ",
  "block.minecraft.deepslate_brick_slab": "qIj'am jaQ ngogh buq'Ir bID",
  "block.minecraft.deepslate_brick_stairs": "qIj'am jaQ ngogh letlh",
  "block.minecraft.deepslate_brick_wall": "qIj'am jaQ ngogh tlhoy'",
  "block.minecraft.deepslate_bricks": "qIj'am jaQ ngoghmey",
  "block.minecraft.deepslate_coal_ore": "qIj'am jaQ meStlhal",
  "block.minecraft.deepslate_copper_ore": "qIj'am jaQ Sorpuq",
  "block.minecraft.deepslate_diamond_ore": "qIj'am jaQ chanmon",
  "block.minecraft.deepslate_emerald_ore": "qIj'am jaQ patmor",
  "block.minecraft.deepslate_gold_ore": "qIj'am jaQ qol'om",
  "block.minecraft.deepslate_iron_ore": "qIj'am jaQ 'uSqan",
  "block.minecraft.deepslate_lapis_ore": "qIj'am jaQ Doltop",
  "block.minecraft.deepslate_redstone_ore": "qIj'am jaQ redstone",
  "block.minecraft.deepslate_tile_slab": "qIj'am jaQ majyang buq'Ir bID",
  "block.minecraft.deepslate_tile_stairs": "qIj'am jaQ majyang letlh",
  "block.minecraft.deepslate_tile_wall": "qIj'am jaQ majyang tlhoy'",
  "block.minecraft.deepslate_tiles": "qIj'am jaQ majyang",
  "block.minecraft.detector_rail": "noch tIHmey",
  "block.minecraft.diamond_block": "chanmon buq'Ir",
  "block.minecraft.diamond_ore": "nagh chanmon",
  "block.minecraft.diorite": "qopagh",
  "block.minecraft.diorite_slab": "qopagh buq'Ir bID",
  "block.minecraft.diorite_stairs": "qopagh letlh",
  "block.minecraft.diorite_wall": "qopagh tlhoy'",
  "block.minecraft.dirt": "lam",
  "block.minecraft.dirt_path": "lam taw",
  "block.minecraft.dispenser": "baHjan",
  "block.minecraft.dragon_egg": "lung'a' QIm",
  "block.minecraft.dragon_head": "lung'a' nach",
  "block.minecraft.dragon_wall_head": "lung'a' tlhoy' nach",
  "block.minecraft.dried_ghast": "ghast QaD",
  "block.minecraft.dried_kelp_block": "nI'qur QaD buq'Ir",
  "block.minecraft.dripstone_block": "De'lor buq'Ir",
  "block.minecraft.dropper": "chaghwI'",
  "block.minecraft.emerald_block": "patmor buq'Ir",
  "block.minecraft.emerald_ore": "nagh patmor",
  "block.minecraft.enchanting_table": "reSmeH raS",
  "block.minecraft.end_gateway": "end DIn",
  "block.minecraft.end_portal": "end lojmIt",
  "block.minecraft.end_portal_frame": "end lojmIt qal'aq",
  "block.minecraft.end_rod": "end naQ",
  "block.minecraft.end_stone": "end nagh",
  "block.minecraft.end_stone_brick_slab": "end nagh ngoghmey buq'Ir bID",
  "block.minecraft.end_stone_brick_stairs": "end nagh ngoghmey letlh",
  "block.minecraft.end_stone_brick_wall": "end nagh ngoghmey tlhoy'",
  "block.minecraft.end_stone_bricks": "End nagh ngoghmey",
  "block.minecraft.ender_chest": "ender DerlIq",
  "block.minecraft.exposed_chiseled_copper": "raghchoHbogh Sorpuq nanlu'bogh",
  "block.minecraft.exposed_copper": "raghchoHbogh Sorpuq",
  "block.minecraft.exposed_copper_bars": "raghchoHbogh Sorpuq naQmey",
  "block.minecraft.exposed_copper_bulb": "raghchoHbogh Sorpuq wovmoHwI'",
  "block.minecraft.exposed_copper_chain": "raghchoHbogh  Sorpuq mIr",
  "block.minecraft.exposed_copper_chest": "raghchoHbogh Sorpuq DerlIq",
  "block.minecraft.exposed_copper_door": "raghchoHbogh Sorpuq lojmIt",
  "block.minecraft.exposed_copper_golem_statue": "raghchoHbogh Sorpuq yoq pargh Hew",
  "block.minecraft.exposed_copper_grate": "raghchoHbogh Sorpuq neng'el",
  "block.minecraft.exposed_copper_lantern": "raghchoHbogh Sorpuq Sech 'aplo'",
  "block.minecraft.exposed_copper_trapdoor": "raghchoHbogh Sorpuq vonmeH lojmIt",
  "block.minecraft.exposed_cut_copper": "raghchoHbogh Sorpuq pe'lu'pu'bogh",
  "block.minecraft.exposed_cut_copper_slab": "raghchoHbogh Sorpuq pe'lu'bogh buq'Ir bID",
  "block.minecraft.exposed_cut_copper_stairs": "raghchoHbogh Sorpuq pe'lu'bogh letlh",
  "block.minecraft.exposed_lightning_rod": "raghchoHbogh pe'bIl naQ",
  "block.minecraft.farmland": "Du' puH",
  "block.minecraft.fern": "DIS'oS",
  "block.minecraft.fire": "qul",
  "block.minecraft.fire_coral": "qul 'oqe'",
  "block.minecraft.fire_coral_block": "qul 'oqe' ngogh",
  "block.minecraft.fire_coral_fan": "qul 'oqe' mIjDang",
  "block.minecraft.fire_coral_wall_fan": "qul 'oqe' tlhoy' mIjDang",
  "block.minecraft.firefly_bush": "wewbogh ghew lav",
  "block.minecraft.fletching_table": "naQjejHom raS",
  "block.minecraft.flower_pot": "'InSong bal",
  "block.minecraft.flowering_azalea": "'InSong 'aSe'lIya lav",
  "block.minecraft.flowering_azalea_leaves": "'InSong 'aSe'lIya pormey",
  "block.minecraft.frogspawn": "mabeb QImmey",
  "block.minecraft.frosted_ice": "chuch ru'",
  "block.minecraft.furnace": "vIncha'",
  "block.minecraft.gilded_blackstone": "qol'om nagh qIj",
  "block.minecraft.glass": "'al'on",
  "block.minecraft.glass_pane": "'al'on 'echlet",
  "block.minecraft.glow_lichen": "wewbogh namchIl 'atlhqam",
  "block.minecraft.glowstone": "wovbogh nagh",
  "block.minecraft.gold_block": "qol'om buq'Ir",
  "block.minecraft.gold_ore": "nagh qol'om",
  "block.minecraft.golden_dandelion": "qol'om DanDelay'an",
  "block.minecraft.granite": "lIvrI'",
  "block.minecraft.granite_slab": "lIvrI' buq'Ir bID",
  "block.minecraft.granite_stairs": "lIvrI' letlh",
  "block.minecraft.granite_wall": "lIvrI' tlhoy'",
  "block.minecraft.grass": "magh",
  "block.minecraft.grass_block": "magh buq'Ir",
  "block.minecraft.gravel": "yetmoS",
  "block.minecraft.gray_banner": "qIjbogh joqwI' 'ej wovbogh",
  "block.minecraft.gray_bed": "qIjbogh QongDaq 'ej wovbogh",
  "block.minecraft.gray_candle": "qIjbogh weQ 'ej wovbogh",
  "block.minecraft.gray_candle_cake": "qIjbogh weQ 'ej wovbogh ghajbogh chab",
  "block.minecraft.gray_carpet": "qIjbogh tlhIm 'ej wovbogh",
  "block.minecraft.gray_concrete": "qIjbogh tungyen 'ej wovbogh",
  "block.minecraft.gray_concrete_powder": "qIjbogh tungyen Say'qIS 'ej wovbogh",
  "block.minecraft.gray_glazed_terracotta": "qIjbogh HaSreH nagh ghun 'ej wovbogh",
  "block.minecraft.gray_shulker_box": "qIjbogh shulker ngaSwI' 'ej wovbogh",
  "block.minecraft.gray_stained_glass": "'al'on qIj 'ej wov",
  "block.minecraft.gray_stained_glass_pane": "'al'on 'echlet qIj 'ej wov",
  "block.minecraft.gray_terracotta": "qIjbogh nagh ghun 'ej wovbogh",
  "block.minecraft.gray_wool": "qIjbogh veD 'ej wovbogh",
  "block.minecraft.green_banner": "joqwI' SuDqu'",
  "block.minecraft.green_bed": "QongDaq SuDqu'",
  "block.minecraft.green_candle": "weQ SuDqu'",
  "block.minecraft.green_candle_cake": "weQ SuDqu' ghajbogh chab",
  "block.minecraft.green_carpet": "tlhIm SuDqu'",
  "block.minecraft.green_concrete": "tungyen SuDqu'",
  "block.minecraft.green_concrete_powder": "tungyen Say'qIS SuDqu'",
  "block.minecraft.green_glazed_terracotta": "SuDqu'bogh HaSreH nagh ghun",
  "block.minecraft.green_shulker_box": "shulker ngaSwI' SuDqu'",
  "block.minecraft.green_stained_glass": "'al'on SuDqu'",
  "block.minecraft.green_stained_glass_pane": "'al'on 'echlet SuDqu'",
  "block.minecraft.green_terracotta": "SuDqu'bogh nagh ghun",
  "block.minecraft.green_wool": "veD SuDqu'",
  "block.minecraft.grindstone": "Do'ol nagh rutlh",
  "block.minecraft.hanging_roots": "'oQqar tlhep",
  "block.minecraft.hay_block": "magh gha'naD Doj",
  "block.minecraft.heavy_core": "SuqSIv 'ugh",
  "block.minecraft.heavy_weighted_pressure_plate": "Surmen 'echlet 'ugh",
  "block.minecraft.honey_block": "DayqIr buq'Ir",
  "block.minecraft.honeycomb_block": "DayqIr SIr'o' buq'Ir",
  "block.minecraft.hopper": "tomter",
  "block.minecraft.horn_coral": "pu' 'oqe'",
  "block.minecraft.horn_coral_block": "pu' 'oqe' buq'Ir",
  "block.minecraft.horn_coral_fan": "pu' 'oqe' mIjDang",
  "block.minecraft.horn_coral_wall_fan": "pu' 'oqe' tlhoy' mIjDang",
  "block.minecraft.ice": "chuch",
  "block.minecraft.infested_chiseled_stone_bricks": "nagh ngoghmey nanlu'bogh 'ej ngejlu'bogh",
  "block.minecraft.infested_cobblestone": "nagh tlher ngejlu'bogh",
  "block.minecraft.infested_cracked_stone_bricks": "nagh ngoghmey maD ngejlu'bogh",
  "block.minecraft.infested_deepslate": "qIj'am jaQ ngejlu'bogh",
  "block.minecraft.infested_mossy_stone_bricks": "'ayIvlaS nagh ngoghmey ngejlu'bogh",
  "block.minecraft.infested_stone": "nagh ngejlu'bogh",
  "block.minecraft.infested_stone_bricks": "nagh ngoghmey ngejlu'bogh",
  "block.minecraft.iron_bars": "'uSqan naQmey",
  "block.minecraft.iron_block": "'uSqan buq'Ir",
  "block.minecraft.iron_chain": "'uSqan mIr",
  "block.minecraft.iron_door": "'uSqan lojmIt",
  "block.minecraft.iron_ore": "nagh 'uSqan",
  "block.minecraft.iron_trapdoor": "'uSqan vonmeH lojmIt",
  "block.minecraft.jack_o_lantern": "'aquta' naH wovmoHwI'",
  "block.minecraft.jigsaw": "Qay'mol buq'Ir",
  "block.minecraft.jukebox": "bom jengva' chu'wI'",
  "block.minecraft.jungle_button": "ngem yIQ Sor leQ",
  "block.minecraft.jungle_door": "ngem yIQ Sor lojmIt",
  "block.minecraft.jungle_fence": "ngem yIQ Sor tlhoy'Hom",
  "block.minecraft.jungle_fence_gate": "ngem yIQ Sor tlhoy'Hom lojmIt",
  "block.minecraft.jungle_hanging_sign": "ngem yIQ Sor QIn 'echlet tlhep",
  "block.minecraft.jungle_leaves": "ngem yIQ Sor pormey",
  "block.minecraft.jungle_log": "ngem yIQ Sor Qechjem'a'",
  "block.minecraft.jungle_planks": "ngem yIQ Sor 'echletmey",
  "block.minecraft.jungle_pressure_plate": "ngem yIQ Sor Surmen 'echlet",
  "block.minecraft.jungle_sapling": "ngem yIQ SorHom",
  "block.minecraft.jungle_shelf": "ngem yIQ Sor yorgh",
  "block.minecraft.jungle_sign": "ngem yIQ Sor QIn 'echlet",
  "block.minecraft.jungle_slab": "ngem yIQ Sor buq'Ir bID",
  "block.minecraft.jungle_stairs": "ngem yIQ Sor letlh",
  "block.minecraft.jungle_trapdoor": "ngem yIQ Sor vonmeH lojmIt",
  "block.minecraft.jungle_wall_hanging_sign": "ngem yIQ Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.jungle_wall_sign": "ngem yIQ Sor tlhoy' QIn 'echlet",
  "block.minecraft.jungle_wood": "ngem yIQ Sor Hap",
  "block.minecraft.kelp": "nI'qur",
  "block.minecraft.kelp_plant": "nI'qur San'emDer",
  "block.minecraft.ladder": "Selrach",
  "block.minecraft.lantern": "Sech 'aplo'",
  "block.minecraft.lapis_block": "Doltop buq'Ir",
  "block.minecraft.lapis_ore": "nagh Doltop",
  "block.minecraft.large_amethyst_bud": "choSom nguv ghub'a'",
  "block.minecraft.large_fern": "DIS'oS tIn",
  "block.minecraft.lava": "vaHbo'",
  "block.minecraft.lava_cauldron": "vaHbo' bargh'a'",
  "block.minecraft.leaf_litter": "por DI",
  "block.minecraft.lectern": "paq raS",
  "block.minecraft.lever": "chu'meH naQ",
  "block.minecraft.light": "wovmoHwI'",
  "block.minecraft.light_blue_banner": "SuDbogh joqwI' 'ej wovbogh",
  "block.minecraft.light_blue_bed": "SuDbogh QongDaq 'ej wovbogh",
  "block.minecraft.light_blue_candle": "SuDbogh weQ 'ej wovbogh",
  "block.minecraft.light_blue_candle_cake": "SuDbogh weQ 'ej wovbogh ghajbogh chab",
  "block.minecraft.light_blue_carpet": "SuDbogh tlhIm 'ej wovbogh",
  "block.minecraft.light_blue_concrete": "SuDbogh tungyen 'ej wovbogh",
  "block.minecraft.light_blue_concrete_powder": "SuDbogh tungyen Say'qIS 'ej wovbogh",
  "block.minecraft.light_blue_glazed_terracotta": "SuDbogh HaSreH nagh ghun 'ej wovbogh",
  "block.minecraft.light_blue_shulker_box": "SuDbogh shulker ngaSwI' 'ej wovbogh",
  "block.minecraft.light_blue_stained_glass": "'al'on SuD 'ej wov",
  "block.minecraft.light_blue_stained_glass_pane": "'al'on 'echlet SuD 'ej wov",
  "block.minecraft.light_blue_terracotta": "SuDbogh nagh ghun 'ej wovbogh",
  "block.minecraft.light_blue_wool": "SuDbogh veD 'ej wovbogh",
  "block.minecraft.light_gray_banner": "qIjbogh joqwI' 'ej wovqu'bogh",
  "block.minecraft.light_gray_bed": "qIjbogh QongDaq 'ej wovqu'bogh",
  "block.minecraft.light_gray_candle": "qIjbogh weQ 'ej wovqu'bogh",
  "block.minecraft.light_gray_candle_cake": "qIjbogh weQ 'ej wovqu'bogh ghajbogh chab",
  "block.minecraft.light_gray_carpet": "qIjbogh tlhIm 'ej wovqu'bogh",
  "block.minecraft.light_gray_concrete": "qIjbogh tungyen 'ej wovqu'bogh",
  "block.minecraft.light_gray_concrete_powder": "qIjbogh tungyen Say'qIS 'ej wovqu'bogh",
  "block.minecraft.light_gray_glazed_terracotta": "qIjbogh HaSreH nagh ghun 'ej wovqu'bogh",
  "block.minecraft.light_gray_shulker_box": "qIjbogh shulker ngaSwI' 'ej wovqu'bogh",
  "block.minecraft.light_gray_stained_glass": "'al'on qIj 'ej wovqu'",
  "block.minecraft.light_gray_stained_glass_pane": "'al'on 'echlet qIj 'ej wovqu'",
  "block.minecraft.light_gray_terracotta": "qIjbogh nagh ghun 'ej wovqu'bogh",
  "block.minecraft.light_gray_wool": "qIjbogh veD 'ej wovqu'bogh",
  "block.minecraft.light_weighted_pressure_plate": "Surmen 'echlet tIS",
  "block.minecraft.lightning_rod": "pe'bIl naQ",
  "block.minecraft.lilac": "laylaq 'InSong",
  "block.minecraft.lily_of_the_valley": "ngech lI'lIy",
  "block.minecraft.lily_pad": "'echlet por'a'",
  "block.minecraft.lime_banner": "SuDqu'bogh joqwI' 'ej wovqu'bogh",
  "block.minecraft.lime_bed": "SuDqu'bogh QongDaq 'ej wovqu'bogh",
  "block.minecraft.lime_candle": "SuDqu'bogh weQ 'ej wovqu'bogh",
  "block.minecraft.lime_candle_cake": "SuDqu'bogh weQ 'ej wovqu'bogh ghajbogh chab",
  "block.minecraft.lime_carpet": "SuDqu'bogh tlhIm 'ej wovqu'bogh",
  "block.minecraft.lime_concrete": "SuDqu'bogh tungyen 'ej wovqu'bogh",
  "block.minecraft.lime_concrete_powder": "SuDqu'bogh tungyen Say'qIS 'ej wovqu'bogh",
  "block.minecraft.lime_glazed_terracotta": "SuDqu'bogh HaSreH nagh ghun 'ej wovqu'bogh",
  "block.minecraft.lime_shulker_box": "SuDqu'bogh shulker ngaSwI' 'ej wovqu'bogh",
  "block.minecraft.lime_stained_glass": "SuDqu'bogh 'al'on 'ej wovqu'bogh",
  "block.minecraft.lime_stained_glass_pane": "SuDqu'bogh 'al'on 'echlet 'ej wovqu'bogh",
  "block.minecraft.lime_terracotta": "SuDqu'bogh nagh ghun 'ej wovqu'bogh",
  "block.minecraft.lime_wool": "SuDqu'bogh veD 'ej wovqu'bogh",
  "block.minecraft.lodestone": "peQnagh",
  "block.minecraft.loom": "nIqmeH qal'aq",
  "block.minecraft.magenta_banner": "Doqqu'bogh joqwI' 'ej wovbogh",
  "block.minecraft.magenta_bed": "Doqqu'bogh QongDaq 'ej wovbogh",
  "block.minecraft.magenta_candle": "Doqqu'bogh weQ 'ej wovbogh",
  "block.minecraft.magenta_candle_cake": "Doqqu'bogh weQ 'ej wovbogh ghajbogh chab",
  "block.minecraft.magenta_carpet": "Doqqu'bogh tlhIm 'ej wovbogh",
  "block.minecraft.magenta_concrete": "Doqqu'bogh tungyen 'ej wovbogh",
  "block.minecraft.magenta_concrete_powder": "Doqqu'bogh tungyen Say'qIS 'ej wovbogh",
  "block.minecraft.magenta_glazed_terracotta": "Doqqu'bogh HaSreH nagh ghun 'ej wovbogh",
  "block.minecraft.magenta_shulker_box": "Doqqu'bogh shulker ngaSwI' 'ej wovbogh",
  "block.minecraft.magenta_stained_glass": "Doqqu'bogh 'al'on 'ej wovbogh",
  "block.minecraft.magenta_stained_glass_pane": "Doqqu'bogh 'al'on 'echlet 'ej wovbogh",
  "block.minecraft.magenta_terracotta": "Doqqu'bogh nagh ghun 'ej wovbogh",
  "block.minecraft.magenta_wool": "Doqqu'bogh veD 'ej wovbogh",
  "block.minecraft.magma_block": "vaHbo' buq'Ir",
  "block.minecraft.mangrove_button": "mangghov Sor leQ",
  "block.minecraft.mangrove_door": "mangghov Sor lojmIt",
  "block.minecraft.mangrove_fence": "mangghov Sor tlhoy'Hom",
  "block.minecraft.mangrove_fence_gate": "mangghov Sor tlhoy'Hom lojmIt",
  "block.minecraft.mangrove_hanging_sign": "mangghov Sor QIn 'echlet tlhep",
  "block.minecraft.mangrove_leaves": "mangghov Sor pormey",
  "block.minecraft.mangrove_log": "mangghov Sor Qechjem'a'",
  "block.minecraft.mangrove_planks": "mangghov Sor 'echletmey",
  "block.minecraft.mangrove_pressure_plate": "mangghov Sor Surmen 'echlet",
  "block.minecraft.mangrove_propagule": "mangghov Sor raS'IS'a'",
  "block.minecraft.mangrove_roots": "mangghov Sor 'oQqar",
  "block.minecraft.mangrove_shelf": "mangghov Sor yorgh",
  "block.minecraft.mangrove_sign": "mangghov Sor QIn 'echlet",
  "block.minecraft.mangrove_slab": "mangghov Sor buq'Ir bID",
  "block.minecraft.mangrove_stairs": "mangghov Sor letlh",
  "block.minecraft.mangrove_trapdoor": "mangghov Sor jonmeH lojmIt",
  "block.minecraft.mangrove_wall_hanging_sign": "mangghov Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.mangrove_wall_sign": "mangghov Sor tlhoy' QIn 'echlet",
  "block.minecraft.mangrove_wood": "mangghov Sor Hap",
  "block.minecraft.medium_amethyst_bud": "choSom nguv ghub",
  "block.minecraft.melon": "qaq naH",
  "block.minecraft.melon_stem": "qaq naH Qechjem",
  "block.minecraft.moss_block": "'ayIvlaS buq'Ir",
  "block.minecraft.moss_carpet": "'ayIvlaS tlhIm",
  "block.minecraft.mossy_cobblestone": "'ayIvlaS nagh tlher",
  "block.minecraft.mossy_cobblestone_slab": "'ayIvlaS nagh tlher buq'Ir bID",
  "block.minecraft.mossy_cobblestone_stairs": "'ayIvlaS nagh tlher letlh",
  "block.minecraft.mossy_cobblestone_wall": "'ayIvlaS nagh tlher tlhoy'",
  "block.minecraft.mossy_stone_brick_slab": "'ayIvlaS nagh ngoghmey buq'Ir bID",
  "block.minecraft.mossy_stone_brick_stairs": "'ayIvlaS nagh ngoghmey letlh",
  "block.minecraft.mossy_stone_brick_wall": "'ayIvlaS nagh ngoghmey tlhoy'",
  "block.minecraft.mossy_stone_bricks": "'ayIvlaS nagh ngoghmey",
  "block.minecraft.moving_piston": "vIHtaHbogh ghunglItlh",
  "block.minecraft.mud": "DabqI' yIQ",
  "block.minecraft.mud_brick_slab": "DabqI' yIQ ngoghmey buq'Ir bID",
  "block.minecraft.mud_brick_stairs": "DabqI' yIQ ngoghmey letlh",
  "block.minecraft.mud_brick_wall": "DabqI' yIQ ngoghmey tlhoy'",
  "block.minecraft.mud_bricks": "DabqI' yIQ ngoghmey",
  "block.minecraft.muddy_mangrove_roots": "mangghov Sor 'oQqar lam",
  "block.minecraft.mushroom_stem": "yav 'atlhqam Qechjem",
  "block.minecraft.mycelium": "'atlhqam SIrghmey",
  "block.minecraft.nether_brick_fence": "nether ngogh Solrogh",
  "block.minecraft.nether_brick_slab": "nether ngogh buq'Ir bID",
  "block.minecraft.nether_brick_stairs": "nether ngogh letlh",
  "block.minecraft.nether_brick_wall": "nether ngogh tlhoy'",
  "block.minecraft.nether_bricks": "nether ngoghmey",
  "block.minecraft.nether_gold_ore": "nether nagh qol'om",
  "block.minecraft.nether_portal": "nether lojmIt",
  "block.minecraft.nether_quartz_ore": "nether nagh choSom",
  "block.minecraft.nether_sprouts": "nether ghubmey",
  "block.minecraft.nether_wart": "nether 'ejtlhal 'atlhqam",
  "block.minecraft.nether_wart_block": "nether 'ejtlhal buq'Ir",
  "block.minecraft.netherite_block": "netherite buq'Ir",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.note_block": "'awtIr buq'Ir",
  "block.minecraft.oak_button": "'oq Sor leQ",
  "block.minecraft.oak_door": "'oq Sor lojmIt",
  "block.minecraft.oak_fence": "'oq Sor tlhoy'Hom",
  "block.minecraft.oak_fence_gate": "'oq Sor tlhoy'Hom lojmIt",
  "block.minecraft.oak_hanging_sign": "'oq Sor QIn 'echlet tlhep",
  "block.minecraft.oak_leaves": "'oq Sor pormey",
  "block.minecraft.oak_log": "'oq Sor Qechjem'a'",
  "block.minecraft.oak_planks": "'oq Sor 'echletmey",
  "block.minecraft.oak_pressure_plate": "'oq Sor Surmen 'echlet",
  "block.minecraft.oak_sapling": "'oq SorHom",
  "block.minecraft.oak_shelf": "'oq Sor yorgh",
  "block.minecraft.oak_sign": "'oq Sor QIn 'echlet",
  "block.minecraft.oak_slab": "'oq Sor buq'Ir bID",
  "block.minecraft.oak_stairs": "'oq Sor letlh",
  "block.minecraft.oak_trapdoor": "'oq Sor vonmeH lojmIt",
  "block.minecraft.oak_wall_hanging_sign": "'oq Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.oak_wall_sign": "'oq Sor tlhoy' QIn 'echlet",
  "block.minecraft.oak_wood": "'oq Sor Hap",
  "block.minecraft.observer": "bejwI'",
  "block.minecraft.obsidian": "'al'on nagh",
  "block.minecraft.ochre_froglight": "mabeb wovmoHwI' SuD",
  "block.minecraft.ominous_banner": "maQmIgh joqwI'",
  "block.minecraft.open_eyeblossom": "mIn 'InSong poS",
  "block.minecraft.orange_banner": "Doqbogh joqwI' 'ej beqpuj rurbogh",
  "block.minecraft.orange_bed": "Doqbogh QongDaq 'ej beqpuj rurbogh",
  "block.minecraft.orange_candle": "Doqbogh weQ 'ej beqpuj rurbogh",
  "block.minecraft.orange_candle_cake": "Doqbogh weQ 'ej beqpuj rurbogh ghajbogh chab",
  "block.minecraft.orange_carpet": "Doqbogh tlhIm 'ej beqpuj rurbogh",
  "block.minecraft.orange_concrete": "Doqbogh tungyen 'ej beqpuj rurbogh",
  "block.minecraft.orange_concrete_powder": "Doqbogh tungyen Say'qIS 'ej beqpuj rurbogh",
  "block.minecraft.orange_glazed_terracotta": "Doqbogh HaSreH nagh ghun 'ej beqpuj rurbogh",
  "block.minecraft.orange_shulker_box": "Doqbogh shulker ngaSwI' 'ej beqpuj rurbogh",
  "block.minecraft.orange_stained_glass": "Doqbogh 'al'on 'ej beqpuj rurbogh",
  "block.minecraft.orange_stained_glass_pane": "Doqbogh 'al'on 'echlet 'ej beqpuj rurbogh",
  "block.minecraft.orange_terracotta": "Doqbogh nagh ghun 'ej beqpuj rurbogh",
  "block.minecraft.orange_tulip": "Doqbogh tu'lIp 'ej beqpuj rurbogh",
  "block.minecraft.orange_wool": "Doqbogh veD 'ej beqpuj rurbogh",
  "block.minecraft.oxeye_daisy": "'aqSay DeySIy 'InSong",
  "block.minecraft.oxidized_chiseled_copper": "raghchu'bogh Sorpuq nanlu'bogh",
  "block.minecraft.oxidized_copper": "raghchu'bogh Sorpuq",
  "block.minecraft.oxidized_copper_bars": "raghchu'bogh Sorpuq naQmey",
  "block.minecraft.oxidized_copper_bulb": "raghchu'bogh Sorpuq wovmoHwI'",
  "block.minecraft.oxidized_copper_chain": "raghchu'bogh Sorpuq mIr",
  "block.minecraft.oxidized_copper_chest": "raghchu'bogh Sorpuq DerlIq",
  "block.minecraft.oxidized_copper_door": "raghchu'bogh Sorpuq lojmIt",
  "block.minecraft.oxidized_copper_golem_statue": "raghchu'bogh Sorpuq yoq pargh Hew",
  "block.minecraft.oxidized_copper_grate": "raghchu'bogh Sorpuq neng'el",
  "block.minecraft.oxidized_copper_lantern": "raghchu'bogh Sorpuq Sech 'aplo'",
  "block.minecraft.oxidized_copper_trapdoor": "raghchu'bogh Sorpuq vonmeH lojmIt",
  "block.minecraft.oxidized_cut_copper": "raghchu'bogh Sorpuq pe'lu'bogh",
  "block.minecraft.oxidized_cut_copper_slab": "raghchu'bogh Sorpuq pe'lu'bogh buq'Ir bID",
  "block.minecraft.oxidized_cut_copper_stairs": "raghchu'bogh Sorpuq pe'lu'bogh letlh",
  "block.minecraft.oxidized_lightning_rod": "raghchu'bogh pe'bIl naQ",
  "block.minecraft.packed_ice": "chuch HIS",
  "block.minecraft.packed_mud": "HISbogh DabqI' yIQ",
  "block.minecraft.pale_hanging_moss": "wovbogh 'ayIvlaS tlhep",
  "block.minecraft.pale_moss_block": "'ayIvlaS wov buq'Ir",
  "block.minecraft.pale_moss_carpet": "'ayIvlaS wov tlhIm",
  "block.minecraft.pale_oak_button": "'oq wov Sor leQ",
  "block.minecraft.pale_oak_door": "'oq wov Sor lojmIt",
  "block.minecraft.pale_oak_fence": "'oq wov Sor Solrogh",
  "block.minecraft.pale_oak_fence_gate": "'oq wov Sor Solrogh lojmIt",
  "block.minecraft.pale_oak_hanging_sign": "'oq wov Sor QIn 'echlet tlhep",
  "block.minecraft.pale_oak_leaves": "'oq wov Sor pormey",
  "block.minecraft.pale_oak_log": "'oq wov Sor Qechjem'a'",
  "block.minecraft.pale_oak_planks": "'oq wov Sor 'echletmey",
  "block.minecraft.pale_oak_pressure_plate": "'oq wov Sor Surmen 'echlet",
  "block.minecraft.pale_oak_sapling": "'oq wov SorHom",
  "block.minecraft.pale_oak_shelf": "'oq wov Sor yorgh",
  "block.minecraft.pale_oak_sign": "'oq wov Sor QIn 'echlet",
  "block.minecraft.pale_oak_slab": "'oq wov Sor buq'Ir bID",
  "block.minecraft.pale_oak_stairs": "'oq wov Sor letlh",
  "block.minecraft.pale_oak_trapdoor": "'oq wov Sor vonmeH lojmIt",
  "block.minecraft.pale_oak_wall_hanging_sign": "'oq wov Sor tlhoy' QIn 'echlet tlhep",
  "block.minecraft.pale_oak_wall_sign": "'oq wov Sor tlhoy' QIn 'echlet",
  "block.minecraft.pale_oak_wood": "'oq wov Sor Hap",
  "block.minecraft.pearlescent_froglight": "mabeb wovmoHwI' Doq",
  "block.minecraft.peony": "pIy'anIy 'InSong",
  "block.minecraft.petrified_oak_slab": "'oq Sor buq'Ir bID 'an",
  "block.minecraft.piglin_head": "piglin nach",
  "block.minecraft.piglin_wall_head": "piglin tlhoy' nach",
  "block.minecraft.pink_banner": "Doqqu'bogh joqwI' 'ej wovqu'bogh",
  "block.minecraft.pink_bed": "Doqqu'bogh QongDaq 'ej wovqu'bogh",
  "block.minecraft.pink_candle": "Doqqu'bogh weQ 'ej wovqu'bogh",
  "block.minecraft.pink_candle_cake": "Doqqu'bogh weQ 'ej wovqu'bogh ghajbogh chab",
  "block.minecraft.pink_carpet": "Doqqu'bogh tlhIm 'ej wovqu'bogh",
  "block.minecraft.pink_concrete": "Doqqu'bogh tungyen 'ej wovqu'bogh",
  "block.minecraft.pink_concrete_powder": "Doqqu'bogh tungyen Say'qIS 'ej wovqu'bogh",
  "block.minecraft.pink_glazed_terracotta": "Doqqu'bogh HaSreH nagh ghun 'ej wovqu'bogh",
  "block.minecraft.pink_petals": "Doqqu'bogh 'uma'mey 'ej wovqu'bogh",
  "block.minecraft.pink_shulker_box": "Doqqu'bogh shulker ngaSwI' 'ej wovqu'bogh",
  "block.minecraft.pink_stained_glass": "'al'on Doqqu' 'ej wov",
  "block.minecraft.pink_stained_glass_pane": "'al'on 'echlet Doqqu' 'ej wov",
  "block.minecraft.pink_terracotta": "Doqqu'bogh nagh ghun 'ej wovqu'bogh",
  "block.minecraft.pink_tulip": "Doqqu'bogh tu'lIp 'ej wovqu'bogh",
  "block.minecraft.pink_wool": "Doqqu'bogh veD 'ej wovqu'bogh",
  "block.minecraft.piston": "ghunglItlh",
  "block.minecraft.piston_head": "ghunglItlh nach",
  "block.minecraft.pitcher_crop": "bal San'emDer wIjlu'bogh",
  "block.minecraft.pitcher_plant": "bal San'emDer",
  "block.minecraft.player_head": "QujwI' nach",
  "block.minecraft.player_head.named": "%s nach",
  "block.minecraft.player_wall_head": "QujwI' tlhoy' nach",
  "block.minecraft.podzol": "ngem bIr lam",
  "block.minecraft.pointed_dripstone": "De'lor jej",
  "block.minecraft.polished_andesite": "chan nagh Hab",
  "block.minecraft.polished_andesite_slab": "chan nagh Hab buq'Ir bID",
  "block.minecraft.polished_andesite_stairs": "chan nagh Hab letlh",
  "block.minecraft.polished_basalt": "Hotnagh Hab",
  "block.minecraft.polished_blackstone": "Habbogh nagh qIj",
  "block.minecraft.polished_blackstone_brick_slab": "Habbogh nagh qIj ngoghmey buq'Ir bID",
  "block.minecraft.polished_blackstone_brick_stairs": "Habbogh nagh qIj ngoghmey letlh",
  "block.minecraft.polished_blackstone_brick_wall": "Habbogh nagh qIj ngoghmey tlhoy'",
  "block.minecraft.polished_blackstone_bricks": "Habbogh nagh qIj ngoghmey",
  "block.minecraft.polished_blackstone_button": "Habbogh nagh qIj leQ",
  "block.minecraft.polished_blackstone_pressure_plate": "Habbogh nagh qIj jembogh 'echlet",
  "block.minecraft.polished_blackstone_slab": "Habbogh nagh qIj buq'Ir bID",
  "block.minecraft.polished_blackstone_stairs": "Habbogh nagh qIj letlh",
  "block.minecraft.polished_blackstone_wall": "Habbogh nagh qIj tlhoy'",
  "block.minecraft.polished_deepslate": "Habbogh qIj'am jaQ",
  "block.minecraft.polished_deepslate_slab": "Habbogh qIj'am jaQ buq'Ir bID",
  "block.minecraft.polished_deepslate_stairs": "Habbogh qIj'am jaQ letlh",
  "block.minecraft.polished_deepslate_wall": "Habbogh qIj'am jaQ tlhoy'",
  "block.minecraft.polished_diorite": "qopagh Hab",
  "block.minecraft.polished_diorite_slab": "qopagh Hab buq'Ir bID",
  "block.minecraft.polished_diorite_stairs": "qopagh Hab letlh",
  "block.minecraft.polished_granite": "lIvrI' Hab",
  "block.minecraft.polished_granite_slab": "lIvrI' Hab buq'Ir bID",
  "block.minecraft.polished_granite_stairs": "lIvrI' Hab letlh",
  "block.minecraft.polished_tuff": "tIpqan nagh Habqu'",
  "block.minecraft.polished_tuff_slab": "tIpqan nagh buq'Ir bID Habqu'",
  "block.minecraft.polished_tuff_stairs": "tIpqan nagh letlh Habqu'",
  "block.minecraft.polished_tuff_wall": "tIpqan nagh tlhoy' Habqu'",
  "block.minecraft.poppy": "DIghna'",
  "block.minecraft.potatoes": "patat 'oQqarmey",
  "block.minecraft.potted_acacia_sapling": "'aqey'Sa SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_allium": "'anyan o'Qqar 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_azalea_bush": "'aSe'lIya SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_azure_bluet": "'aSur bIlu''et 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_bamboo": "bambu' ngaSbogh 'InSong bal",
  "block.minecraft.potted_birch_sapling": "berIch SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_blue_orchid": "bIlu 'orqID 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_brown_mushroom": "yav 'atlhqam wovbe' ngaSbogh 'InSong bal",
  "block.minecraft.potted_cactus": "qaqtaS San'emDer ngaSbogh 'InSong bal",
  "block.minecraft.potted_cherry_sapling": "tapqej SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_closed_eyeblossom": "mIn 'InSong SoQ ngaSbogh 'InSong bal",
  "block.minecraft.potted_cornflower": "qorInvIlaw''er 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_crimson_fungus": "'atlhqam Doq ngaSbogh 'InSong bal",
  "block.minecraft.potted_crimson_roots": "'oQqar Doq ngaSbogh 'InSong bal",
  "block.minecraft.potted_dandelion": "DanDelay'an 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_dark_oak_sapling": "'oq Hurgh SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_dead_bush": "Heghbogh lav ngaSbogh 'InSong bal",
  "block.minecraft.potted_fern": "DIS'oS ngaSbogh 'InSong bal",
  "block.minecraft.potted_flowering_azalea_bush": "'InSong 'aSe'lIya SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_golden_dandelion": "qol'om DanDelay'an 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_jungle_sapling": "ngem yIQ SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_lily_of_the_valley": "ngech lI'lIy ngaSbogh 'InSong bal",
  "block.minecraft.potted_mangrove_propagule": "mangghov Sor raS'IS'a' ngaSbogh 'InSong bal",
  "block.minecraft.potted_oak_sapling": "'oq SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_open_eyeblossom": "mIn 'InSong poS ngaSbogh 'InSong bal",
  "block.minecraft.potted_orange_tulip": "Doqbogh tu'lIp 'ej beqpuj rurbogh ngaSbogh 'InSong bal",
  "block.minecraft.potted_oxeye_daisy": "'aqSay DeySIy 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_pale_oak_sapling": "'oq wov SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_pink_tulip": "Doqqu'bogh tu'lIp 'ej wovqu'bogh ngaSbogh 'InSong bal",
  "block.minecraft.potted_poppy": "Dighna' ngaSbogh 'InSong bal",
  "block.minecraft.potted_red_mushroom": "yav atlhqam yegh ngaSbogh 'InSong bal",
  "block.minecraft.potted_red_tulip": "tu'lIp Doqqu' ngaSbogh 'InSong bal",
  "block.minecraft.potted_spruce_sapling": "qIrqoD SorHom ngaSbogh 'InSong bal",
  "block.minecraft.potted_torchflower": "Sech 'InSong ngaSbogh 'InSong bal",
  "block.minecraft.potted_warped_fungus": "'atlhqam SuD ngaSbogh 'InSong bal",
  "block.minecraft.potted_warped_roots": "'oQqar SuD ngaSbogh 'InSong bal",
  "block.minecraft.potted_white_tulip": "tu'lIp chIS ngaSbogh 'InSong bal",
  "block.minecraft.potted_wither_rose": "wither ro'Sa' ngaSbogh 'InSong bal",
  "block.minecraft.powder_snow": "chal chuch Say'qIS",
  "block.minecraft.powder_snow_cauldron": "chal chuch Say'qIS bargh'a'",
  "block.minecraft.powered_rail": "HoSbogh tIHmey",
  "block.minecraft.prismarine": "prismarine",
  "block.minecraft.prismarine_brick_slab": "prismarine ngoghmey buq'Ir bID",
  "block.minecraft.prismarine_brick_stairs": "prismarine ngoghmey letlh",
  "block.minecraft.prismarine_bricks": "prismarine ngoghmey",
  "block.minecraft.prismarine_slab": "prismarine buq'Ir bID",
  "block.minecraft.prismarine_stairs": "prismarine letlh",
  "block.minecraft.prismarine_wall": "prismarine tlhoy'",
  "block.minecraft.pumpkin": "'aquta' naH",
  "block.minecraft.pumpkin_stem": "'aquta'",
  "block.minecraft.purple_banner": "ghIrep Hurgh rurbogh joqwI''e'",
  "block.minecraft.purple_bed": "ghIrep Hurgh rurbogh QongDaq'e'",
  "block.minecraft.purple_candle": "ghIrep Hurgh rurbogh weQ'e'",
  "block.minecraft.purple_candle_cake": "ghIrep Hurgh rurbogh weQ ghajbogh chab",
  "block.minecraft.purple_carpet": "ghIrep Hurgh rurbogh tlhIm'e'",
  "block.minecraft.purple_concrete": "ghIrep Hurgh rurbogh tungyen'e'",
  "block.minecraft.purple_concrete_powder": "ghIrep Hurgh rurbogh tungyen Say'qIS'e'",
  "block.minecraft.purple_glazed_terracotta": "ghIrep Hurgh rurbogh HaSreH nagh ghun'e'",
  "block.minecraft.purple_shulker_box": "ghIrep Hurgh rurbogh shulker ngaSwI''e'",
  "block.minecraft.purple_stained_glass": "ghIrep Hurgh rurbogh 'al'on'e'",
  "block.minecraft.purple_stained_glass_pane": "ghIrep Hurgh rurbogh 'al'on 'echlet'e'",
  "block.minecraft.purple_terracotta": "ghIrep rurbogh nagh ghun'e'",
  "block.minecraft.purple_wool": "ghIrep Hurgh rurbogh veD'e'",
  "block.minecraft.purpur_block": "purpur buq'Ir",
  "block.minecraft.purpur_pillar": "purpur tut",
  "block.minecraft.purpur_slab": "purpur buq'Ir bID",
  "block.minecraft.purpur_stairs": "purpur letlh",
  "block.minecraft.quartz_block": "choSom buq'Ir",
  "block.minecraft.quartz_bricks": "choSom ngoghmey",
  "block.minecraft.quartz_pillar": "choSom tut",
  "block.minecraft.quartz_slab": "choSom buq'Ir bID",
  "block.minecraft.quartz_stairs": "choSom letlh",
  "block.minecraft.rail": "tIHmey",
  "block.minecraft.raw_copper_block": "Sorpuq tlhol buq'Ir",
  "block.minecraft.raw_gold_block": "qol'om tlhol buq'Ir",
  "block.minecraft.raw_iron_block": "'uSqan tlhol buq'Ir",
  "block.minecraft.red_banner": "joqwI' Doqqu'",
  "block.minecraft.red_bed": "QongDaq Doqqu'",
  "block.minecraft.red_candle": "weQ Doqqu'",
  "block.minecraft.red_candle_cake": "weQ Doqqu' ghajbogh chab",
  "block.minecraft.red_carpet": "tlhIm Doqqu'",
  "block.minecraft.red_concrete": "tungyen Doqqu'",
  "block.minecraft.red_concrete_powder": "tungyen Say'qIS Doqqu'",
  "block.minecraft.red_glazed_terracotta": "Doqqu'bogh HaSreH nagh ghun",
  "block.minecraft.red_mushroom": "yav atlhqam yegh",
  "block.minecraft.red_mushroom_block": "yav atlhqam yegh buq'Ir",
  "block.minecraft.red_nether_brick_slab": "nether ngogh wov buq'Ir bID",
  "block.minecraft.red_nether_brick_stairs": "nether ngogh wov letlh",
  "block.minecraft.red_nether_brick_wall": "nether ngogh wov tlhoy'",
  "block.minecraft.red_nether_bricks": "nether ngoghmey wov",
  "block.minecraft.red_sand": "Do'ol Doq",
  "block.minecraft.red_sandstone": "Do'ol nagh Doq",
  "block.minecraft.red_sandstone_slab": "Do'ol nagh Doq buq'Ir bID",
  "block.minecraft.red_sandstone_stairs": "Do'ol nagh Doq letlh",
  "block.minecraft.red_sandstone_wall": "Do'ol nagh Doq tlhoy'",
  "block.minecraft.red_shulker_box": "shulker ngaSwI' Doqqu'",
  "block.minecraft.red_stained_glass": "'al'on Doqqu'",
  "block.minecraft.red_stained_glass_pane": "'al'on 'echlet Doqqu'",
  "block.minecraft.red_terracotta": "Doqqu'bogh nagh ghun",
  "block.minecraft.red_tulip": "tu'lIp Doqqu'",
  "block.minecraft.red_wool": "veD Doqqu'",
  "block.minecraft.redstone_block": "redstone buq'Ir",
  "block.minecraft.redstone_lamp": "redstone wovmoHwI'",
  "block.minecraft.redstone_ore": "nagh redstone",
  "block.minecraft.redstone_torch": "redstone Sech",
  "block.minecraft.redstone_wall_torch": "redstone tlhoy' Sech",
  "block.minecraft.redstone_wire": "redstone SIrgh",
  "block.minecraft.reinforced_deepslate": "HoSbogh qIj'am jaQ",
  "block.minecraft.repeater": "redstone HoSmoHwI'",
  "block.minecraft.repeating_command_block": "ra'qa'bogh ra'wI' buq'Ir",
  "block.minecraft.resin_block": "rebmugh buq'Ir",
  "block.minecraft.resin_brick_slab": "rebmugh ngogh buq'Ir bID",
  "block.minecraft.resin_brick_stairs": "rebmugh ngogh letlh",
  "block.minecraft.resin_brick_wall": "rebmugh ngogh tlhoy'",
  "block.minecraft.resin_bricks": "rebmugh ngoghmey",
  "block.minecraft.resin_clump": "rebmugh Sawqe'",
  "block.minecraft.respawn_anchor": "boghqa'meH jan",
  "block.minecraft.rooted_dirt": "'oQqar lam",
  "block.minecraft.rose_bush": "ro'Sa' lav",
  "block.minecraft.sand": "Do'ol",
  "block.minecraft.sandstone": "Do'ol nagh",
  "block.minecraft.sandstone_slab": "Do'ol nagh buq'Ir bID",
  "block.minecraft.sandstone_stairs": "Do'ol nagh letlh",
  "block.minecraft.sandstone_wall": "Do'ol nagh tlhoy'",
  "block.minecraft.scaffolding": "SIller'It",
  "block.minecraft.sculk": "sculk",
  "block.minecraft.sculk_catalyst": "sculk lIngwI'",
  "block.minecraft.sculk_sensor": "sculk noch",
  "block.minecraft.sculk_shrieker": "sculk jachwI'",
  "block.minecraft.sculk_vein": "sculk SIr'o'",
  "block.minecraft.sea_lantern": "bIQ'a' wovmoHwI'",
  "block.minecraft.sea_pickle": "bIQ'a' Hurgh",
  "block.minecraft.seagrass": "bIQ'a' magh",
  "block.minecraft.set_spawn": "boghqa'meH Daq cherlu'",
  "block.minecraft.short_dry_grass": "runbogh magh QaD",
  "block.minecraft.short_grass": "magh run",
  "block.minecraft.shroomlight": "'atlhqam wovmoHwI'",
  "block.minecraft.shulker_box": "shulker ngaSwI'",
  "block.minecraft.skeleton_skull": "nobmeD DughrI'",
  "block.minecraft.skeleton_wall_skull": "nobmeD tlhoy' DughrI'",
  "block.minecraft.slime_block": "HuH buq'Ir",
  "block.minecraft.small_amethyst_bud": "choSom nguv ghubHom",
  "block.minecraft.small_dripleaf": "por tom mach",
  "block.minecraft.smithing_table": "mitlhmeH raS",
  "block.minecraft.smoker": "tlhIch vIncha'",
  "block.minecraft.smooth_basalt": "Hotnagh Habqu'",
  "block.minecraft.smooth_quartz": "choSom Hab buq'Ir",
  "block.minecraft.smooth_quartz_slab": "choSom Hab buq'Ir bID",
  "block.minecraft.smooth_quartz_stairs": "choSom Hab letlh",
  "block.minecraft.smooth_red_sandstone": "Habbogh Do'ol nagh Doq",
  "block.minecraft.smooth_red_sandstone_slab": "Habbogh Do'ol nagh Doq bID ngogh",
  "block.minecraft.smooth_red_sandstone_stairs": "Habbogh Do'ol nagh Doq letlh",
  "block.minecraft.smooth_sandstone": "Do'ol nagh Hab",
  "block.minecraft.smooth_sandstone_slab": "Do'ol nagh Hab buq'Ir bID",
  "block.minecraft.smooth_sandstone_stairs": "Do'ol nagh Hab letlh",
  "block.minecraft.smooth_stone": "nagh Hab",
  "block.minecraft.smooth_stone_slab": "nagh Hab buq'Ir bID",
  "block.minecraft.sniffer_egg": "larghwI' QIm",
  "block.minecraft.snow": "chal chuch",
  "block.minecraft.snow_block": "chal chuch buq'Ir",
  "block.minecraft.soul_campfire": "qa' raQ qul",
  "block.minecraft.soul_fire": "qa' qul",
  "block.minecraft.soul_lantern": "qa' Sech 'aplo'",
  "block.minecraft.soul_sand": "qa' Do'ol",
  "block.minecraft.soul_soil": "qa' lam",
  "block.minecraft.soul_torch": "qa' Sech",
  "block.minecraft.soul_wall_torch": "qa' tlhoy' Sech",
  "block.minecraft.spawn.not_valid": "juH QongDaq boghqa'meH jan Hujlu'pu' bogh ghap tu'lu'be', pagh waQlu'",
  "block.minecraft.spawner": "tlhapragh boghmoHwI'",
  "block.minecraft.spawner.desc1": "boghmoHbogh QIm lo'lu'DI':",
  "block.minecraft.spawner.desc2": "namlIgh Segh choH",
  "block.minecraft.sponge": "va'chum",
  "block.minecraft.spore_blossom": "SanmIr 'InSong",
  "block.minecraft.spruce_button": "qIrqoD leQ",
  "block.minecraft.spruce_door": "qIrqoD lojmIt",
  "block.minecraft.spruce_fence": "qIrqoD Solrogh",
  "block.minecraft.spruce_fence_gate": "qIrqoD Solrogh lojmIt",
  "block.minecraft.spruce_hanging_sign": "qIrqoD QIn 'echlet tlhep",
  "block.minecraft.spruce_leaves": "qIrqoD pormey",
  "block.minecraft.spruce_log": "qIrqoD Qechjem'a'",
  "block.minecraft.spruce_planks": "qIrqoD 'echletmey",
  "block.minecraft.spruce_pressure_plate": "qIrqoD Surmen 'echlet",
  "block.minecraft.spruce_sapling": "qIrqoD SorHom",
  "block.minecraft.spruce_shelf": "qIrqoD yorgh",
  "block.minecraft.spruce_sign": "qIrqoD QIn 'echlet",
  "block.minecraft.spruce_slab": "qIrqoD buq'Ir bID",
  "block.minecraft.spruce_stairs": "qIrqoD letlh",
  "block.minecraft.spruce_trapdoor": "qIrqoD vonmeH lojmIt",
  "block.minecraft.spruce_wall_hanging_sign": "qIrqoD tlhoy' QIn 'echlet tlhep",
  "block.minecraft.spruce_wall_sign": "qIrqoD tlhoy' QIn 'echlet",
  "block.minecraft.spruce_wood": "qIrqoD Sor Hap",
  "block.minecraft.sticky_piston": "ghunglItlh Hum",
  "block.minecraft.stone": "nagh",
  "block.minecraft.stone_brick_slab": "nagh ngoghmey buq'Ir bID",
  "block.minecraft.stone_brick_stairs": "nagh ngogh letlh",
  "block.minecraft.stone_brick_wall": "nagh ngoghmey tlhoy'",
  "block.minecraft.stone_bricks": "nagh ngoghmey",
  "block.minecraft.stone_button": "nagh leQ",
  "block.minecraft.stone_pressure_plate": "nagh Surmen 'echlet",
  "block.minecraft.stone_slab": "nagh buq'Ir bID",
  "block.minecraft.stone_stairs": "nagh letlh",
  "block.minecraft.stonecutter": "nagh pe'wI'",
  "block.minecraft.stripped_acacia_log": "'aqey'Sa Sor Qechjem'a' Qen",
  "block.minecraft.stripped_acacia_wood": "'aqey'Sa Sor Hap Qen",
  "block.minecraft.stripped_bamboo_block": "bambu' Qen buq'Ir",
  "block.minecraft.stripped_birch_log": "berIch Sor Qechjem'a' Qen",
  "block.minecraft.stripped_birch_wood": "berIch Sor Hap Qen",
  "block.minecraft.stripped_cherry_log": "tapqej Sor Qechjem'a' Qen",
  "block.minecraft.stripped_cherry_wood": "tapqej Sor Hap Qen",
  "block.minecraft.stripped_crimson_hyphae": "nether Sor Doq SIylaw'mey Qen",
  "block.minecraft.stripped_crimson_stem": "nether Sor Doq Qechjem Qen",
  "block.minecraft.stripped_dark_oak_log": "'oq Hurgh Sor Qechjem'a' Qen",
  "block.minecraft.stripped_dark_oak_wood": "'oq Hurgh Sor Hap Qen",
  "block.minecraft.stripped_jungle_log": "ngem yIQ Sor Qechjem'a' Qen",
  "block.minecraft.stripped_jungle_wood": "ngem yIQ Sor Hap Qen",
  "block.minecraft.stripped_mangrove_log": "mangghov Sor Qechjem'a' Qen",
  "block.minecraft.stripped_mangrove_wood": "mangghov Sor Hap Qen",
  "block.minecraft.stripped_oak_log": "'oq Sor Qechjem'a' Qen",
  "block.minecraft.stripped_oak_wood": "'oq Sor Hap Qen",
  "block.minecraft.stripped_pale_oak_log": "'oq wov Sor Qechjem'a' Qen",
  "block.minecraft.stripped_pale_oak_wood": "'oq wov Sor Hap Qen",
  "block.minecraft.stripped_spruce_log": "qIrqoD Qechjem'a' Qen",
  "block.minecraft.stripped_spruce_wood": "qIrqoD Hap Qen",
  "block.minecraft.stripped_warped_hyphae": "nether Sor SuD SIylaw'mey Qen",
  "block.minecraft.stripped_warped_stem": "nether Sor SuD Qechjem Qen",
  "block.minecraft.structure_block": "qach buq'Ir",
  "block.minecraft.structure_void": "qach 'achghej",
  "block.minecraft.sugar_cane": "SIyech",
  "block.minecraft.sunflower": "Du'QamHom",
  "block.minecraft.suspicious_gravel": "yetmoS nub",
  "block.minecraft.suspicious_sand": "Do'ol nub",
  "block.minecraft.sweet_berry_bush": "naHjej",
  "block.minecraft.tall_dry_grass": "wochbogh magh QaD",
  "block.minecraft.tall_grass": "magh woch",
  "block.minecraft.tall_seagrass": "bIQ'a' magh woch",
  "block.minecraft.target": "DoS",
  "block.minecraft.terracotta": "nagh ghun",
  "block.minecraft.test_block": "qaD buq'Ir",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "'al'on nguv",
  "block.minecraft.tnt": "jorwI'",
  "block.minecraft.tnt.disabled": "jor jorwI' net chu'Ha'",
  "block.minecraft.torch": "Sech",
  "block.minecraft.torchflower": "Sech 'InSong",
  "block.minecraft.torchflower_crop": "Sech 'InSong San'emDer",
  "block.minecraft.trapped_chest": "vonwI' DerlIq",
  "block.minecraft.trial_spawner": "qaD boghmoHwI'",
  "block.minecraft.tripwire": "jemmeH SIrgh",
  "block.minecraft.tripwire_hook": "tangmoHmeH SIrgh SIrIl",
  "block.minecraft.tube_coral": "'och 'oqe'",
  "block.minecraft.tube_coral_block": "'och 'oqe' buq'Ir",
  "block.minecraft.tube_coral_fan": "'och 'oqe' mIjDang",
  "block.minecraft.tube_coral_wall_fan": "'och 'oqe' tlhoy' mIjDang",
  "block.minecraft.tuff": "tipqan nagh",
  "block.minecraft.tuff_brick_slab": "tIpqan nagh ngogh buq'Ir bID",
  "block.minecraft.tuff_brick_stairs": "tIpqan nagh ngogh letlh",
  "block.minecraft.tuff_brick_wall": "tIpqan nagh ngogh tlhoy'",
  "block.minecraft.tuff_bricks": "tIpqan nagh ngoghmey",
  "block.minecraft.tuff_slab": "tIpqan nagh buq'Ir bID",
  "block.minecraft.tuff_stairs": "tIpqan nagh letlh",
  "block.minecraft.tuff_wall": "tIpqan nagh tlhoy'",
  "block.minecraft.turtle_egg": "la'SIv QIm",
  "block.minecraft.twisting_vines": "'arDeH ver",
  "block.minecraft.twisting_vines_plant": "'arDeH ver San'emDer",
  "block.minecraft.vault": "qengHoD buq'Ir",
  "block.minecraft.verdant_froglight": "mabeb wovmoHwI' SuDqu'",
  "block.minecraft.vine": "'arDeH",
  "block.minecraft.void_air": "'achghej rewve'",
  "block.minecraft.wall_torch": "tlhoy' Sech",
  "block.minecraft.warped_button": "nether Sor SuD leQ",
  "block.minecraft.warped_door": "nether Sor SuD lojmIt",
  "block.minecraft.warped_fence": "nether Sor SuD tlhoy'Hom",
  "block.minecraft.warped_fence_gate": "nether Sor SuD tlhoy'Hom lojmIt",
  "block.minecraft.warped_fungus": "'atlhqam SuD",
  "block.minecraft.warped_hanging_sign": "nether Sor SuD QIn 'echlet tlhep",
  "block.minecraft.warped_hyphae": "nether Sor SuD SIylaw'mey",
  "block.minecraft.warped_nylium": "nether magh SuD",
  "block.minecraft.warped_planks": "nether Sor SuD 'echletmey",
  "block.minecraft.warped_pressure_plate": "nether Sor SuD Surmen 'echlet",
  "block.minecraft.warped_roots": "'oQqar SuD",
  "block.minecraft.warped_shelf": "nether Sor SuD yorgh",
  "block.minecraft.warped_sign": "nether Sor SuD QIn 'echlet",
  "block.minecraft.warped_slab": "nether Sor SuD buq'Ir bID",
  "block.minecraft.warped_stairs": "nether Sor SuD letlh",
  "block.minecraft.warped_stem": "nether Sor SuD Qechjem",
  "block.minecraft.warped_trapdoor": "nether Sor SuD vonmeH lojmIt",
  "block.minecraft.warped_wall_hanging_sign": "nether Sor SuD tlhoy' QIn 'echlet tlhep",
  "block.minecraft.warped_wall_sign": "nether Sor SuD tlhoy' QIn 'echlet",
  "block.minecraft.warped_wart_block": "nether 'ejtlhal SuD buq'Ir",
  "block.minecraft.water": "bIQ",
  "block.minecraft.water_cauldron": "bIQ bargh'a'",
  "block.minecraft.waxed_chiseled_copper": "Sorpuq nanlu'bogh velbogh req",
  "block.minecraft.waxed_copper_bars": "Sorpuq naQmey velbogh req",
  "block.minecraft.waxed_copper_block": "Sorpuq buq'Ir velbogh req",
  "block.minecraft.waxed_copper_bulb": "Sorpuq wovmoHwI' velbogh req",
  "block.minecraft.waxed_copper_chain": "Sorpuq mIr velbogh req",
  "block.minecraft.waxed_copper_chest": "Sorpuq DerlIq velbogh req",
  "block.minecraft.waxed_copper_door": "Sorpuq lojmIt velbogh req",
  "block.minecraft.waxed_copper_golem_statue": "Sorpuq yoq pargh Hew velbogh req",
  "block.minecraft.waxed_copper_grate": "Sorpuq neng'el velbogh req",
  "block.minecraft.waxed_copper_lantern": "Sorpuq Sech 'aplo' velbogh req",
  "block.minecraft.waxed_copper_trapdoor": "Sorpuq vonmeH lojmIt velbogh req",
  "block.minecraft.waxed_cut_copper": "Sorpuq pe'lu'bogh velbogh req",
  "block.minecraft.waxed_cut_copper_slab": "Sorpuq pe'lu'bogh buq'Ir bID velbogh req",
  "block.minecraft.waxed_cut_copper_stairs": "Sorpuq pe'lu'bogh letlh velbogh req",
  "block.minecraft.waxed_exposed_chiseled_copper": "raghchoHbogh Sorpuq nanlu'bogh velbogh req",
  "block.minecraft.waxed_exposed_copper": "raghchoHbogh Sorpuq velbogh req",
  "block.minecraft.waxed_exposed_copper_bars": "raghchoHbogh Sorpuq naQmey velbogh req",
  "block.minecraft.waxed_exposed_copper_bulb": "raghchoHbogh Sorpuq wovmoHwI' velbogh req",
  "block.minecraft.waxed_exposed_copper_chain": "raghchoHbogh Sorpuq mIr velbogh req",
  "block.minecraft.waxed_exposed_copper_chest": "raghchoHbogh Sorpuq DerlIq velbogh req",
  "block.minecraft.waxed_exposed_copper_door": "raghchoHbogh Sorpuq lojmIt velbogh req",
  "block.minecraft.waxed_exposed_copper_golem_statue": "raghchoHbogh Sorpuq yoq pargh Hew velbogh req",
  "block.minecraft.waxed_exposed_copper_grate": "raghchoHbogh Sorpuq neng'el velbogh req",
  "block.minecraft.waxed_exposed_copper_lantern": "raghchoHbogh Sorpuq Sech 'aplo' velbogh req",
  "block.minecraft.waxed_exposed_copper_trapdoor": "raghchoHbogh Sorpuq vonmeH lojmIt velbogh req",
  "block.minecraft.waxed_exposed_cut_copper": "raghchoHbogh Sorpuq pe'lu'bogh velbogh req",
  "block.minecraft.waxed_exposed_cut_copper_slab": "raghchoHbogh Sorpuq pe'lu'bogh buq'Ir bID velbogh req",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "raghchoHbogh Sorpuq pe'lu'bogh letlh velbogh req",
  "block.minecraft.waxed_exposed_lightning_rod": "raghchoHbogh pe'bIl naQ velbogh req",
  "block.minecraft.waxed_lightning_rod": "pe'bIl naQ velbogh req",
  "block.minecraft.waxed_oxidized_chiseled_copper": "raghchu'bogh Sorpuq nanlu'bogh velbogh req",
  "block.minecraft.waxed_oxidized_copper": "raghchu'bogh Sorpuq velbogh req",
  "block.minecraft.waxed_oxidized_copper_bars": "raghchu'bogh Sorpuq naQmey velbogh req",
  "block.minecraft.waxed_oxidized_copper_bulb": "raghchu'bogh Sorpuq wovmoHwI' velbogh req",
  "block.minecraft.waxed_oxidized_copper_chain": "raghchu'bogh Sorpuq mIr velbogh req",
  "block.minecraft.waxed_oxidized_copper_chest": "raghchu'bogh Sorpuq DerlIq velbogh req",
  "block.minecraft.waxed_oxidized_copper_door": "raghchu'bogh Sorpuq lojmIt velbogh req",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "raghchu'bogh Sorpuq yoq pargh Hew velbogh req",
  "block.minecraft.waxed_oxidized_copper_grate": "raghchu'bogh Sorpuq neng'el velbogh req",
  "block.minecraft.waxed_oxidized_copper_lantern": "raghchu'bogh Sorpuq Sech 'aplo' velbogh req",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "raghchu'bogh Sorpuq vonmeH lojmIt velbogh req",
  "block.minecraft.waxed_oxidized_cut_copper": "raghchu'bogh Sorpuq pe'lu'bogh velbogh req",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "raghchu'bogh Sorpuq pe'lu'bogh buq'Ir bID velbogh req",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "raghchu'bogh Sorpuq pe'lu'bogh letlh velbogh req",
  "block.minecraft.waxed_oxidized_lightning_rod": "raghchu'bogh pe'bIl naQ velbogh req",
  "block.minecraft.waxed_weathered_chiseled_copper": "raghtaHbogh Sorpuq nanlu'bogh velbogh req",
  "block.minecraft.waxed_weathered_copper": "raghtaHbogh Sorpuq velbogh req",
  "block.minecraft.waxed_weathered_copper_bars": "raghtaHbogh Sorpuq naQmey velbogh req",
  "block.minecraft.waxed_weathered_copper_bulb": "raghtaHbogh Sorpuq wovmoHwI' velbogh req",
  "block.minecraft.waxed_weathered_copper_chain": "raghtaHbogh Sorpuq mIr velbogh req",
  "block.minecraft.waxed_weathered_copper_chest": "raghtaHbogh Sorpuq DerlIq velbogh req",
  "block.minecraft.waxed_weathered_copper_door": "raghtaHbogh Sorpuq lojmIt velbogh req",
  "block.minecraft.waxed_weathered_copper_golem_statue": "raghtaHbogh Sorpuq yoq pargh Hew velbogh req",
  "block.minecraft.waxed_weathered_copper_grate": "raghtaHbogh Sorpuq neng'el velbogh req",
  "block.minecraft.waxed_weathered_copper_lantern": "raghtaHbogh Sorpuq Sech 'aplo' velbogh req",
  "block.minecraft.waxed_weathered_copper_trapdoor": "raghtaHbogh Sorpuq vonmeH lojmIt velbogh req",
  "block.minecraft.waxed_weathered_cut_copper": "raghtaHbogh Sorpuq pe'lu'bogh velbogh req",
  "block.minecraft.waxed_weathered_cut_copper_slab": "raghtaHbogh Sorpuq pe'lu'bogh buq'Ir bID velbogh req",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "raghtaHbogh Sorpuq pe'lu'bogh letlh velbogh req",
  "block.minecraft.waxed_weathered_lightning_rod": "raghtaHbogh pe'bIl naQ velbogh req",
  "block.minecraft.weathered_chiseled_copper": "raghtaHbogh Sorpuq nanlu'bogh",
  "block.minecraft.weathered_copper": "raghtaHbogh Sorpuq",
  "block.minecraft.weathered_copper_bars": "raghtaHbogh Sorpuq naQmey",
  "block.minecraft.weathered_copper_bulb": "raghtaHbogh Sorpuq wovmoHwI'",
  "block.minecraft.weathered_copper_chain": "raghtaHbogh Sorpuq mIr",
  "block.minecraft.weathered_copper_chest": "raghtaHbogh Sorpuq DerlIq",
  "block.minecraft.weathered_copper_door": "raghtaHbogh Sorpuq lojmIt",
  "block.minecraft.weathered_copper_golem_statue": "raghtaHbogh Sorpuq yoq pargh Hew",
  "block.minecraft.weathered_copper_grate": "raghtaHbogh Sorpuq neng'el",
  "block.minecraft.weathered_copper_lantern": "raghtaHbogh Sorpuq Sech 'aplo'",
  "block.minecraft.weathered_copper_trapdoor": "raghtaHbogh Sorpuq vonmeH lojmIt",
  "block.minecraft.weathered_cut_copper": "raghtaHbogh Sorpuq pe'lu'pu'bogh",
  "block.minecraft.weathered_cut_copper_slab": "raghtaHbogh Sorpuq pe'lu'pu'bogh buq'Ir bID",
  "block.minecraft.weathered_cut_copper_stairs": "raghtaHbogh Sorpuq pe'lu'pu'bogh letlh",
  "block.minecraft.weathered_lightning_rod": "raghtaHbogh pe'bIl naQ",
  "block.minecraft.weeping_vines": "SaQbogh 'arDeH",
  "block.minecraft.weeping_vines_plant": "SaQbogh 'arDeH San'emDer",
  "block.minecraft.wet_sponge": "va'chum yIQ",
  "block.minecraft.wheat": "wevpev San'emDer",
  "block.minecraft.white_banner": "joqwI' chIS",
  "block.minecraft.white_bed": "QongDaq chIS",
  "block.minecraft.white_candle": "weQ chIS",
  "block.minecraft.white_candle_cake": "weQ chIS ghajbogh chab",
  "block.minecraft.white_carpet": "tlhIm chIS",
  "block.minecraft.white_concrete": "tungyen chIS",
  "block.minecraft.white_concrete_powder": "tungyen Say'qIS chIS",
  "block.minecraft.white_glazed_terracotta": "chISbogh HaSreH nagh ghun",
  "block.minecraft.white_shulker_box": "shulker ngaSwI' chIS",
  "block.minecraft.white_stained_glass": "'al'on chIS",
  "block.minecraft.white_stained_glass_pane": "'al'on 'echlet chIS",
  "block.minecraft.white_terracotta": "chISbogh nagh ghun",
  "block.minecraft.white_tulip": "tu'lIp chIS",
  "block.minecraft.white_wool": "veD chIS",
  "block.minecraft.wildflowers": "'InSongmey tlhab",
  "block.minecraft.wither_rose": "wither ro'Sa'",
  "block.minecraft.wither_skeleton_skull": "wither nobmeD DughrI'",
  "block.minecraft.wither_skeleton_wall_skull": "wither nobmeD tlhoy' DughrI'",
  "block.minecraft.yellow_banner": "SuDbogh joqwI' 'ej wovqu'bogh",
  "block.minecraft.yellow_bed": "SuDbogh QongDaq 'ej wovqu'bogh",
  "block.minecraft.yellow_candle": "SuDbogh weQ 'ej wovqu'bogh",
  "block.minecraft.yellow_candle_cake": "SuDbogh weQ 'ej wovqu'bogh ghajbogh chab",
  "block.minecraft.yellow_carpet": "SuDbogh tlhIm 'ej wovqu'bogh",
  "block.minecraft.yellow_concrete": "SuDbogh tungyen 'ej wovqu'bogh",
  "block.minecraft.yellow_concrete_powder": "SuDbogh tungyen Say'qIS 'ej wovqu'bogh",
  "block.minecraft.yellow_glazed_terracotta": "SuDbogh HaSreH nagh ghun 'ej wovqu'bogh",
  "block.minecraft.yellow_shulker_box": "SuDbogh shulker ngaSwI' 'ej wovqu'bogh",
  "block.minecraft.yellow_stained_glass": "'al'on SuD 'ej wovqu'",
  "block.minecraft.yellow_stained_glass_pane": "'al'on 'echlet SuD 'ej wovqu'",
  "block.minecraft.yellow_terracotta": "SuDbogh nagh ghun 'ej wovqu'bogh",
  "block.minecraft.yellow_wool": "SuDbogh veD 'ej wovqu'bogh",
  "block.minecraft.zombie_head": "yInbogh lom nach",
  "block.minecraft.zombie_wall_head": "yInbogh lom tlhoy' nach",
  "item.minecraft.acacia_boat": "'aqey'Sa Sor bIQ Duj",
  "item.minecraft.acacia_chest_boat": "DerlIq ghajbogh 'aqey'Sa Sor bIQ Duj'e'",
  "item.minecraft.allay_spawn_egg": "yIrwI' boghmoHbogh QIm'e'",
  "item.minecraft.amethyst_shard": "choSom nguv qut",
  "item.minecraft.angler_pottery_shard": "ghotI' wamwI' mIllogh bal 'ay'",
  "item.minecraft.angler_pottery_sherd": "ghotI' mIllogh bal re'nop",
  "item.minecraft.apple": "'epIl naH",
  "item.minecraft.archer_pottery_shard": "HurwI' mIllogh bal 'ay'",
  "item.minecraft.archer_pottery_sherd": "HurwI' mIllogh bal re'nop",
  "item.minecraft.armadillo_scute": "woSwa' ghISDen",
  "item.minecraft.armadillo_spawn_egg": "woSwa' boghmoHbogh QIm'e'",
  "item.minecraft.armor_stand": "may' Sut qal'aq",
  "item.minecraft.arms_up_pottery_shard": "DeSDu' mIllogh bal 'ay'",
  "item.minecraft.arms_up_pottery_sherd": "DeSDu' mIllogh bal re'nop",
  "item.minecraft.arrow": "chollar",
  "item.minecraft.axolotl_bucket": "'evta' HaySIn",
  "item.minecraft.axolotl_spawn_egg": "'evta' boghmoHbogh QIm",
  "item.minecraft.baked_potato": "patat 'oQqar meQ",
  "item.minecraft.bamboo_chest_raft": "DerlIq ghajbogh bambu' bIQ Duj'e'",
  "item.minecraft.bamboo_raft": "bambu' bIQ Duj",
  "item.minecraft.bat_spawn_egg": "valqe' boghmoHbogh QIm'e'",
  "item.minecraft.bee_spawn_egg": "maqSung boghmoHbogh QIm'e'",
  "item.minecraft.beef": "tangqa' ghab tlhol",
  "item.minecraft.beetroot": "'oQqar Doqqu'",
  "item.minecraft.beetroot_seeds": "'oQqar Doqqu' raS'IS",
  "item.minecraft.beetroot_soup": "'oQqar Doqqu' chatlh",
  "item.minecraft.birch_boat": "berIch Sor bIQ Duj",
  "item.minecraft.birch_chest_boat": "DerlIq ghajbogh berIch Sor bIQ Duj'e'",
  "item.minecraft.black_bundle": "Doj buq qIj",
  "item.minecraft.black_dye": "rItlh qIj",
  "item.minecraft.black_harness": "'aHra' qIj",
  "item.minecraft.blade_pottery_shard": "'etlh mIllogh bal 'ay'",
  "item.minecraft.blade_pottery_sherd": "'etlh mIllogh bal re'nop",
  "item.minecraft.blaze_powder": "qul yagh Say'qIS",
  "item.minecraft.blaze_rod": "qul naQ",
  "item.minecraft.blaze_spawn_egg": "qul tlhapragh boghmoHbogh QIm'e'",
  "item.minecraft.blue_bundle": "SuDbogh Doj buq 'ej Hurghbogh",
  "item.minecraft.blue_dye": "SuDbogh rItlh 'ej Hurghbogh",
  "item.minecraft.blue_egg": "QIm SuD",
  "item.minecraft.blue_harness": "SuDbogh 'aHra' 'ej Hurghbogh",
  "item.minecraft.bogged_spawn_egg": "nobmeD yIQ boghmoHbogh QIm'e'",
  "item.minecraft.bolt_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Hut'In may' Sut HaSreH",
  "item.minecraft.bone": "Hom",
  "item.minecraft.bone_meal": "Hom Say'qIS",
  "item.minecraft.book": "paq",
  "item.minecraft.bordure_indented_banner_pattern": "HeH tIy joqwI' HaSreH",
  "item.minecraft.bow": "HurwI'",
  "item.minecraft.bowl": "Duq",
  "item.minecraft.bread": "tIr ngogh",
  "item.minecraft.breeze_rod": "SuS naQ",
  "item.minecraft.breeze_spawn_egg": "SuS tlhapragh boghmoHbogh QIm'e'",
  "item.minecraft.brewer_pottery_shard": "bewSom mIllogh bal 'ay'",
  "item.minecraft.brewer_pottery_sherd": "bewSom mIllogh bal re'nop",
  "item.minecraft.brewing_stand": "taS vutmeH qal'aq",
  "item.minecraft.brick": "ngogh",
  "item.minecraft.brown_bundle": "Doqbogh Doj buq 'ej wovbe'bogh",
  "item.minecraft.brown_dye": "Doqbogh rItlh 'ej wovbe'bogh",
  "item.minecraft.brown_egg": "QIm Doq",
  "item.minecraft.brown_harness": "Doqbogh 'aHra' 'ej wovbe'bogh",
  "item.minecraft.brush": "yachwI'",
  "item.minecraft.bucket": "HaySIn",
  "item.minecraft.bundle": "Doj tlhum",
  "item.minecraft.bundle.empty": "chIm",
  "item.minecraft.bundle.empty.description": "wa' Doj mergh ngaSlaH",
  "item.minecraft.bundle.full": "buy'",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "meQ mIllogh bal 'ay'",
  "item.minecraft.burn_pottery_sherd": "meQ mIllogh bal re'nop",
  "item.minecraft.camel_husk_spawn_egg": "qa'mel yub boghmoHbogh QIm'e'",
  "item.minecraft.camel_spawn_egg": "qa'mel boghmoHbogh QIm'e'",
  "item.minecraft.carrot": "qe'rot 'oQqar",
  "item.minecraft.carrot_on_a_stick": "qe'rot 'oQqar naQ",
  "item.minecraft.cat_spawn_egg": "vIghro' boghmoHbogh QIm'e'",
  "item.minecraft.cauldron": "bargh'a'",
  "item.minecraft.cave_spider_spawn_egg": "DIS voDchuch boghmoHbogh QIm'e'",
  "item.minecraft.chainmail_boots": "mIr DaS",
  "item.minecraft.chainmail_chestplate": "mIr wep",
  "item.minecraft.chainmail_helmet": "mIr mIv",
  "item.minecraft.chainmail_leggings": "mIr yopwaH",
  "item.minecraft.charcoal": "nIl'atrogh",
  "item.minecraft.cherry_boat": "tapqej Sor bIQ Duj",
  "item.minecraft.cherry_chest_boat": "DerlIq ghajbogh tapqej Sor bIQ Duj'e'",
  "item.minecraft.chest_minecart": "DerlIq ghajbogh tlhIlHal Duj'e'",
  "item.minecraft.chicken": "'uSgheb tlhol",
  "item.minecraft.chicken_spawn_egg": "'uSgheb boghmoHbogh QIm'e'",
  "item.minecraft.chorus_fruit": "bomwI' ghom naH",
  "item.minecraft.clay_ball": "DabqI' 'ay'",
  "item.minecraft.clock": "tlhaq",
  "item.minecraft.coal": "meStlhal",
  "item.minecraft.coast_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.coast_armor_trim_smithing_template.new": "HeH may' Sut HaSreH",
  "item.minecraft.cocoa_beans": "yuch qurgh",
  "item.minecraft.cod": "qaD ghotI' tlhol",
  "item.minecraft.cod_bucket": "qaD ghotI' HaySIn",
  "item.minecraft.cod_spawn_egg": "qaD ghotI' boghmoHbogh QIm'e'",
  "item.minecraft.command_block_minecart": "ra'wI' buq'Ir tlhIlHal Duj",
  "item.minecraft.compass": "SInan",
  "item.minecraft.cooked_beef": "tangqa' ghab meQ",
  "item.minecraft.cooked_chicken": "'uSgheb meQ",
  "item.minecraft.cooked_cod": "qaD ghotI' meQ",
  "item.minecraft.cooked_mutton": "DI'raq ghab meQ",
  "item.minecraft.cooked_porkchop": "targh ghab meQ",
  "item.minecraft.cooked_rabbit": "cheS meQ",
  "item.minecraft.cooked_salmon": "Se'mon meQ",
  "item.minecraft.cookie": "Su'ghar chabHom",
  "item.minecraft.copper_axe": "Sorpuq 'obmaQ",
  "item.minecraft.copper_boots": "Sorpuq DaS",
  "item.minecraft.copper_chestplate": "Sorpuq wep",
  "item.minecraft.copper_golem_spawn_egg": "Sorpuq yoq pargh boghmoHbogh QIm'e'",
  "item.minecraft.copper_helmet": "Sorpuq mIv",
  "item.minecraft.copper_hoe": "Sorpuq rutneD",
  "item.minecraft.copper_horse_armor": "Sorpuq Sargh may' Sut",
  "item.minecraft.copper_ingot": "Sorpuq ngogh",
  "item.minecraft.copper_leggings": "Sorpuq yopwaH",
  "item.minecraft.copper_nautilus_armor": "Sorpuq qatvoH may' Sut",
  "item.minecraft.copper_nugget": "Sorpuq Sawqe'",
  "item.minecraft.copper_pickaxe": "Sorpuq tlhIlwI' SommI'",
  "item.minecraft.copper_shovel": "Sorpuq ghevjur",
  "item.minecraft.copper_spear": "Sorpuq naQjej",
  "item.minecraft.copper_sword": "Sorpuq yan",
  "item.minecraft.cow_spawn_egg": "tangqa' boghmoHbogh QIm'e'",
  "item.minecraft.creaking_spawn_egg": "HaSwI' boghmoHbogh QIm'e'",
  "item.minecraft.creeper_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.creeper_banner_pattern.desc": "creeper Degh",
  "item.minecraft.creeper_banner_pattern.new": "creeper Degh joqwI' HaSreH",
  "item.minecraft.creeper_spawn_egg": "creeper boghmoHbogh QIm'e'",
  "item.minecraft.crossbow": "jo' HurwI'",
  "item.minecraft.crossbow.projectile": "nIch:",
  "item.minecraft.crossbow.projectile.multiple": "nIch: %2$s %1$s",
  "item.minecraft.crossbow.projectile.single": "nIch: %s",
  "item.minecraft.cyan_bundle": "SuDqu'bogh Doj buq 'ej wovbogh",
  "item.minecraft.cyan_dye": "SuDqu'bogh rItlh 'ej wovbogh",
  "item.minecraft.cyan_harness": "SuDqu'bogh 'aHra' 'ej wovbogh",
  "item.minecraft.danger_pottery_shard": "Qob mIllogh bal 'ay'",
  "item.minecraft.danger_pottery_sherd": "Qob mIllogh bal re'nop",
  "item.minecraft.dark_oak_boat": "'oq Hurgh Sor bIQ Duj",
  "item.minecraft.dark_oak_chest_boat": "DerlIq ghajbogh 'oq Hurgh Sor bIQ Duj'e'",
  "item.minecraft.debug_stick": "tI'meH naQ",
  "item.minecraft.debug_stick.empty": "DI'onmey Hutlh %s",
  "item.minecraft.debug_stick.select": "\"%s\" (%s) wIvlu'pu'",
  "item.minecraft.debug_stick.update": "%s moj \"%s\"",
  "item.minecraft.diamond": "chanmon",
  "item.minecraft.diamond_axe": "chanmon 'obmaQ",
  "item.minecraft.diamond_boots": "chanmon DaS",
  "item.minecraft.diamond_chestplate": "chanmon wep",
  "item.minecraft.diamond_helmet": "chanmon mIv",
  "item.minecraft.diamond_hoe": "chanmon rutneD",
  "item.minecraft.diamond_horse_armor": "chanmon Sargh may'Sut",
  "item.minecraft.diamond_leggings": "chanmon yopwaH",
  "item.minecraft.diamond_nautilus_armor": "chanmon qatvoH may' Sut",
  "item.minecraft.diamond_pickaxe": "chanmon tlhIlwI' jan",
  "item.minecraft.diamond_shovel": "chanmon ghevjur",
  "item.minecraft.diamond_spear": "chanmon naQjej",
  "item.minecraft.diamond_sword": "chanmon yan",
  "item.minecraft.disc_fragment_5": "QoQ ngop 'ay'",
  "item.minecraft.disc_fragment_5.desc": "QoQ ngop - 5",
  "item.minecraft.dolphin_spawn_egg": "SolbIS boghmoHbogh QIm'e'",
  "item.minecraft.donkey_spawn_egg": "jachbogh Sargh boghmoHbogh QIm'e'",
  "item.minecraft.dragon_breath": "lung'a' tlhuH",
  "item.minecraft.dried_kelp": "nI'qur QaD",
  "item.minecraft.drowned_spawn_egg": "yInbogh lom yIQ boghmoHbogh QIm'e'",
  "item.minecraft.dune_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Do'ol HuD may' Sut HaSreH",
  "item.minecraft.echo_shard": "ya'rIS 'ay'",
  "item.minecraft.egg": "QIm",
  "item.minecraft.elder_guardian_spawn_egg": "'avwI' qup boghmoHbogh QIm'e'",
  "item.minecraft.elytra": "telDu'qoq",
  "item.minecraft.emerald": "patmor",
  "item.minecraft.enchanted_book": "tlheH paq",
  "item.minecraft.enchanted_golden_apple": "tlheH qol'om ep'Il naH",
  "item.minecraft.end_crystal": "end qut",
  "item.minecraft.ender_dragon_spawn_egg": "ender lung'a' boghmoHbogh QIm'e'",
  "item.minecraft.ender_eye": "ender mIn",
  "item.minecraft.ender_pearl": "ender moQ",
  "item.minecraft.enderman_spawn_egg": "enderman boghmoHbogh QIm'e'",
  "item.minecraft.endermite_spawn_egg": "endermite boghmoHbogh QIm'e'",
  "item.minecraft.evoker_spawn_egg": "reSwI' boghmoHbogh QIm'e'",
  "item.minecraft.experience_bottle": "reSmeH bal",
  "item.minecraft.explorer_pottery_shard": "tlharghwI' mIllogh bal 'ay'",
  "item.minecraft.explorer_pottery_sherd": "tlharghwI' mIllogh bal re'nop",
  "item.minecraft.eye_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.eye_armor_trim_smithing_template.new": "mIn may' Sut HaSreH",
  "item.minecraft.feather": "bo",
  "item.minecraft.fermented_spider_eye": "ghew naS mIn roghmoHlu'",
  "item.minecraft.field_masoned_banner_pattern": "ngogh reD joqwI' HaSreH",
  "item.minecraft.filled_map": "pu'jIn",
  "item.minecraft.fire_charge": "qul moQ",
  "item.minecraft.firework_rocket": "lop jorwI'",
  "item.minecraft.firework_rocket.flight": "leng poH:",
  "item.minecraft.firework_rocket.multiple_stars": "%2$s %1$s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "lop jorwI' Hov",
  "item.minecraft.firework_star.black": "qIj",
  "item.minecraft.firework_star.blue": "SuD 'ej Hurgh",
  "item.minecraft.firework_star.brown": "Doq 'ej wovbe'",
  "item.minecraft.firework_star.custom_color": "tlhIn",
  "item.minecraft.firework_star.cyan": "SuD 'ej wov",
  "item.minecraft.firework_star.fade_to": "moj",
  "item.minecraft.firework_star.flicker": "ghon",
  "item.minecraft.firework_star.gray": "qIj 'ej wov",
  "item.minecraft.firework_star.green": "SuDqu'",
  "item.minecraft.firework_star.light_blue": "SuD 'ej wov",
  "item.minecraft.firework_star.light_gray": "qIj 'ej wovqu'",
  "item.minecraft.firework_star.lime": "SuDqu' 'ej wovqu'",
  "item.minecraft.firework_star.magenta": "Doqqu' 'ej wov",
  "item.minecraft.firework_star.orange": "Doq 'ej beqpuj rur",
  "item.minecraft.firework_star.pink": "Doqqu' 'ej wovqu'",
  "item.minecraft.firework_star.purple": "ghIrep Hurgh rur",
  "item.minecraft.firework_star.red": "Doqqu'",
  "item.minecraft.firework_star.shape": "tu'qom Sovbe'lu'bogh",
  "item.minecraft.firework_star.shape.burst": "jorqu'",
  "item.minecraft.firework_star.shape.creeper": "creeper rur",
  "item.minecraft.firework_star.shape.large_ball": "moQ tIn",
  "item.minecraft.firework_star.shape.small_ball": "moQHom",
  "item.minecraft.firework_star.shape.star": "DujtlhuQ",
  "item.minecraft.firework_star.trail": "ratlh",
  "item.minecraft.firework_star.white": "chIS",
  "item.minecraft.firework_star.yellow": "SuD 'ej wovqu'",
  "item.minecraft.fishing_rod": "ghotI' jonmeH naQ",
  "item.minecraft.flint": "qIjbogh 'ej letbogh nagh",
  "item.minecraft.flint_and_steel": "qul chenmoHwI'",
  "item.minecraft.flow_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Dem'ot may' Sut HaSreH",
  "item.minecraft.flow_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.flow_banner_pattern.desc": "Dem'ot",
  "item.minecraft.flow_banner_pattern.new": "Dem'ot joqwI' HaSreH",
  "item.minecraft.flow_pottery_sherd": "Dem'ot mIllogh bal re'nop",
  "item.minecraft.flower_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.flower_banner_pattern.desc": "'InSong Degh",
  "item.minecraft.flower_banner_pattern.new": "'InSong Degh joqwI' HaSreH",
  "item.minecraft.flower_pot": "'InSong bal",
  "item.minecraft.fox_spawn_egg": "qeSHoS boghmoHbogh QIm'e'",
  "item.minecraft.friend_pottery_shard": "jup mIllogh bal 'ay'",
  "item.minecraft.friend_pottery_sherd": "jup mIllogh bal re'nop",
  "item.minecraft.frog_spawn_egg": "mabeb boghmoHbogh QIm'e'",
  "item.minecraft.furnace_minecart": "vIncha' ghajbogh tlhIlHal Duj",
  "item.minecraft.ghast_spawn_egg": "ghast boghmoHbogh QIm'e'",
  "item.minecraft.ghast_tear": "ghast mIn 'onroS",
  "item.minecraft.glass_bottle": "'al'on bal",
  "item.minecraft.glistering_melon_slice": "ghonbogh qaq naH baylaD",
  "item.minecraft.globe_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.globe_banner_pattern.desc": "qo'",
  "item.minecraft.globe_banner_pattern.new": "yuQ joqwI' HaSreH",
  "item.minecraft.glow_berries": "wewbogh naH",
  "item.minecraft.glow_ink_sac": "wewbogh rItlh 'enDeq",
  "item.minecraft.glow_item_frame": "wewbogh Doch bey'",
  "item.minecraft.glow_squid_spawn_egg": "wewbogh cheyIS boghmoHbogh QIm",
  "item.minecraft.glowstone_dust": "wewbogh nagh Say'qIS",
  "item.minecraft.goat_horn": "gha'cher pu'",
  "item.minecraft.goat_spawn_egg": "gha'cher boghmoHbogh QIm",
  "item.minecraft.gold_ingot": "qol'om ngogh",
  "item.minecraft.gold_nugget": "qol'om Sawqe'",
  "item.minecraft.golden_apple": "qol'om 'epIl naH",
  "item.minecraft.golden_axe": "qol'om 'obmaQ",
  "item.minecraft.golden_boots": "qol'om DaSmey",
  "item.minecraft.golden_carrot": "qol'om qe'rot 'oQqar",
  "item.minecraft.golden_chestplate": "qol'om wep",
  "item.minecraft.golden_helmet": "qol'om mIv",
  "item.minecraft.golden_hoe": "qol'om rutneD",
  "item.minecraft.golden_horse_armor": "qol'om Sargh may' Sut",
  "item.minecraft.golden_leggings": "qol'om yopwaH",
  "item.minecraft.golden_nautilus_armor": "qol'om qatvoH may' Sut",
  "item.minecraft.golden_pickaxe": "qol'om tlhIlwI' jan",
  "item.minecraft.golden_shovel": "qol'om ghevjur",
  "item.minecraft.golden_spear": "qol'om naQjej",
  "item.minecraft.golden_sword": "qol'om yan",
  "item.minecraft.gray_bundle": "qIjbogh Doj buq 'ej wovbogh",
  "item.minecraft.gray_dye": "qIjbogh 'ej wovbogh rItlh",
  "item.minecraft.gray_harness": "qIjbogh 'aHra' 'ej wovbogh",
  "item.minecraft.green_bundle": "Doj buq SuDqu'",
  "item.minecraft.green_dye": "rItlh SuDqu'",
  "item.minecraft.green_harness": "'aHra' SuDqu'",
  "item.minecraft.guardian_spawn_egg": "'avwI' boghmoHbogh QIm'e'",
  "item.minecraft.gunpowder": "ngat",
  "item.minecraft.guster_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.guster_banner_pattern.desc": "cheqwI'",
  "item.minecraft.guster_banner_pattern.new": "cheqwI' joqwI' HaSreH",
  "item.minecraft.guster_pottery_sherd": "cheqwI' mIllogh bal re'nop",
  "item.minecraft.happy_ghast_spawn_egg": "ghast Quch boghmoHbogh QIm'e'",
  "item.minecraft.harness": "'aHra'",
  "item.minecraft.heart_of_the_sea": "bIQ'a' tIq",
  "item.minecraft.heart_pottery_shard": "tIq mIllogh bal 'ay'",
  "item.minecraft.heart_pottery_sherd": "tIq mIllogh bal re'nop",
  "item.minecraft.heartbreak_pottery_shard": "ghor tIq mIllogh bal 'ay'",
  "item.minecraft.heartbreak_pottery_sherd": "ghor tIq mIllogh bal re'nop",
  "item.minecraft.hoglin_spawn_egg": "hoglin boghmoHbogh QIm'e'",
  "item.minecraft.honey_bottle": "DayqIr bal",
  "item.minecraft.honeycomb": "DayqIr SIr'o'",
  "item.minecraft.hopper_minecart": "tomter ghajbogh tlhIlHal Duj",
  "item.minecraft.horse_spawn_egg": "Sargh boghmoHbogh QIm'e'",
  "item.minecraft.host_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.host_armor_trim_smithing_template.new": "ma'wI' may' Sut HaSreH",
  "item.minecraft.howl_pottery_shard": "bey mIllogh bal 'ay'",
  "item.minecraft.howl_pottery_sherd": "bey mIllogh bal re'nop",
  "item.minecraft.husk_spawn_egg": "yub boghmoHbogh QIm'e'",
  "item.minecraft.ink_sac": "qIjbogh rItlh",
  "item.minecraft.iron_axe": "'uSqan 'obmaQ",
  "item.minecraft.iron_boots": "'uSqan DaS",
  "item.minecraft.iron_chestplate": "'uSqan wep",
  "item.minecraft.iron_golem_spawn_egg": "'uSqan yoq pargh boghmoHbogh QIm'e'",
  "item.minecraft.iron_helmet": "'uSqan mIv",
  "item.minecraft.iron_hoe": "'uSqan rutneD",
  "item.minecraft.iron_horse_armor": "'uSqan Sargh may'Sut",
  "item.minecraft.iron_ingot": "'uSqan ngogh",
  "item.minecraft.iron_leggings": "'uSqan yopwaH",
  "item.minecraft.iron_nautilus_armor": "'uSqan qatvoH",
  "item.minecraft.iron_nugget": "'uSqan Sawqe'",
  "item.minecraft.iron_pickaxe": "'uSqan tlhIlwI' jan",
  "item.minecraft.iron_shovel": "'uSqan ghevjur",
  "item.minecraft.iron_spear": "'uSqan naQjej",
  "item.minecraft.iron_sword": "'uSqan yan",
  "item.minecraft.item_frame": "Doch bey'",
  "item.minecraft.jungle_boat": "ngem yIQ Sor bIQ Duj",
  "item.minecraft.jungle_chest_boat": "DerlIq ghajbogh ngem yIQ Sor bIQ Duj'e'",
  "item.minecraft.knowledge_book": "Sov paq",
  "item.minecraft.lapis_lazuli": "Doltop",
  "item.minecraft.lava_bucket": "vaHbo' HaySIn",
  "item.minecraft.lead": "rIjmeH tlhegh",
  "item.minecraft.leather": "qo'rIn DIr",
  "item.minecraft.leather_boots": "qo'rIn DIr DaS",
  "item.minecraft.leather_chestplate": "qo'rIn DIr wep",
  "item.minecraft.leather_helmet": "qo'rIn DIr mIv",
  "item.minecraft.leather_horse_armor": "qo'rIn DIr Sargh may'Sut",
  "item.minecraft.leather_leggings": "qo'rIn DIr yopwaH",
  "item.minecraft.light_blue_bundle": "SuDbogh Doj buq 'ej wovbogh",
  "item.minecraft.light_blue_dye": "SuDbogh 'ej wovbogh rItlh",
  "item.minecraft.light_blue_harness": "SuDbogh 'aHra' 'ej wovbogh",
  "item.minecraft.light_gray_bundle": "qIjbogh Doj buq 'ej wovqu'bogh",
  "item.minecraft.light_gray_dye": "qIjbogh 'ej wovqu'bogh rItlh",
  "item.minecraft.light_gray_harness": "qIjbogh 'aHra' 'ej wovqu'bogh",
  "item.minecraft.lime_bundle": "SuDqu'bogh Doj buq 'ej wovqu'bogh",
  "item.minecraft.lime_dye": "SuDbogh 'ej wovbe'bogh rItlh",
  "item.minecraft.lime_harness": "SuDqu'bogh 'aHra' 'ej wovqu'bogh",
  "item.minecraft.lingering_potion": "ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.awkward": "ratlhbogh 'IDnar taS mItHa'",
  "item.minecraft.lingering_potion.effect.empty": "ratlhbogh 'IDnar taS'e' chenmoHlaHbe'bogh vay'",
  "item.minecraft.lingering_potion.effect.fire_resistance": "qul 'ommeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.harming": "QIH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.healing": "Do Hergh ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.infested": "ngejmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.invisibility": "So'meH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.leaping": "pe'vIl SupmoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.levitation": "'almoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.luck": "Do'moHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.mundane": "ratlhbogh 'IDnar taS motlh",
  "item.minecraft.lingering_potion.effect.night_vision": "ram leghlaHghach ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.oozing": "charmoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.poison": "tar ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.regeneration": "rachmoHtaHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.slow_falling": "peDmoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.slowness": "QIt vIHmoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.strength": "HoS ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.swiftness": "Do ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.thick": "ratlhbogh 'IDnar taS jeD",
  "item.minecraft.lingering_potion.effect.turtle_master": "la'SIv pIn'a' ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.water": "ratlhbogh bIQ bal",
  "item.minecraft.lingering_potion.effect.water_breathing": "nIwqen ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.weakness": "pujmoHmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.weaving": "nIqmeH ratlhbogh 'IDnar taS",
  "item.minecraft.lingering_potion.effect.wind_charged": "SuS bach ratlhbogh 'IDnar taS",
  "item.minecraft.llama_spawn_egg": "'ImtIy boghmoHbogh QIm'e'",
  "item.minecraft.lodestone_compass": "peQnagh SInan",
  "item.minecraft.mace": "ghanjaq",
  "item.minecraft.magenta_bundle": "Doqqu'bogh Doj buq 'ej wovbogh",
  "item.minecraft.magenta_dye": "Doqqu'bogh rItlh 'ej wovbogh",
  "item.minecraft.magenta_harness": "Doqqu'bogh 'aHra' 'ej wovbogh",
  "item.minecraft.magma_cream": "vaHbo' tlhagh",
  "item.minecraft.magma_cube_spawn_egg": "vaHbo' buq'Ir boghmoHbogh QIm'e'",
  "item.minecraft.mangrove_boat": "mangghov Sor bIQ Duj",
  "item.minecraft.mangrove_chest_boat": "DerlIq ghajbogh mangghov Sor bIQ Duj'e'",
  "item.minecraft.map": "pu'jIn chIm",
  "item.minecraft.melon_seeds": "qaq naH raS'IS",
  "item.minecraft.melon_slice": "qaq naH baylaD",
  "item.minecraft.milk_bucket": "nIm HaySIn",
  "item.minecraft.minecart": "tlhIlHal Duj",
  "item.minecraft.miner_pottery_shard": "tlhIlwI' mIllogh bal 'ay'",
  "item.minecraft.miner_pottery_sherd": "tlhIlwI' mIllogh bal re'nop",
  "item.minecraft.mojang_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.mojang_banner_pattern.desc": "Doch",
  "item.minecraft.mojang_banner_pattern.new": "vIqraq joqwI' HaSreH",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom boghmoHbogh QIm'e'",
  "item.minecraft.mourner_pottery_shard": "'ubwI' mIllogh bal 'ay'",
  "item.minecraft.mourner_pottery_sherd": "'ubwI' mIllogh bal re'nop",
  "item.minecraft.mule_spawn_egg": "qu'vatlh boghmoHbogh QIm'e'",
  "item.minecraft.mushroom_stew": "yav 'atlhqam tlhIq",
  "item.minecraft.music_disc_11": "bom jengva'",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "bom jengva'",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "bom jengva'",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "bom jengva'",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "bom jengva'",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "bom jengva'",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "bom jengva'",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "bom jengva'",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "bom jengva'",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "bom jengva'",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "bom jengva'",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "bom jengva'",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "bom jengva'",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - Dop Dop",
  "item.minecraft.music_disc_pigstep": "bom jengva'",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - pigstep",
  "item.minecraft.music_disc_precipice": "bom jengva'",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "bom jengva'",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "bom jengva'",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "bom jengva'",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "bom jengva'",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "bom jengva'",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "bom jengva'",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "DI'raq ghab tlhol",
  "item.minecraft.name_tag": "pong per",
  "item.minecraft.nautilus_shell": "qatvoH nagh DIr",
  "item.minecraft.nautilus_spawn_egg": "qatvoH boghmoHbogh QIm'e'",
  "item.minecraft.nether_brick": "nether ngogh",
  "item.minecraft.nether_star": "nether Hov",
  "item.minecraft.nether_wart": "nether 'ejtlhal 'atlhqam",
  "item.minecraft.netherite_axe": "netherite 'obmaQ",
  "item.minecraft.netherite_boots": "netherite DaS",
  "item.minecraft.netherite_chestplate": "netherite wep",
  "item.minecraft.netherite_helmet": "netherite mIv",
  "item.minecraft.netherite_hoe": "netherite rutneD",
  "item.minecraft.netherite_horse_armor": "netherite Sargh may' Sut",
  "item.minecraft.netherite_ingot": "netherite ngogh",
  "item.minecraft.netherite_leggings": "netherite yopwaH",
  "item.minecraft.netherite_nautilus_armor": "netherite qatvoH may' Sut",
  "item.minecraft.netherite_pickaxe": "netherite tlhIlwI' jan",
  "item.minecraft.netherite_scrap": "netherite baS 'ay'",
  "item.minecraft.netherite_shovel": "netherite ghevjur",
  "item.minecraft.netherite_spear": "netherite naQjej",
  "item.minecraft.netherite_sword": "netherite yan",
  "item.minecraft.netherite_upgrade_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.netherite_upgrade_smithing_template.new": "netherite DubwI'",
  "item.minecraft.oak_boat": "'oq Sor bIQ Duj",
  "item.minecraft.oak_chest_boat": "DerlIq ghajbogh 'oq Sor bIQ Duj'e'",
  "item.minecraft.ocelot_spawn_egg": "vIghro''a' boghmoHbogh QIm'e'",
  "item.minecraft.ominous_bottle": "maQmIgh bal",
  "item.minecraft.ominous_trial_key": "maQmIgh qaD ngaQHa'moHwI'",
  "item.minecraft.orange_bundle": "Doqbogh Doj buq 'ej beqpuj rurbogh",
  "item.minecraft.orange_dye": "Doqbogh rItlh 'ej beqpuj rurbogh",
  "item.minecraft.orange_harness": "Doqbogh 'aHra' 'ej beqpuj rurbogh",
  "item.minecraft.painting": "nagh beQ",
  "item.minecraft.pale_oak_boat": "'oq wov Sor bIQ Duj",
  "item.minecraft.pale_oak_chest_boat": "DerlIq ngaSbogh 'oq wov Sor bIQ Duj",
  "item.minecraft.panda_spawn_egg": "panDa' boghmoHbogh QIm'e'",
  "item.minecraft.paper": "nav",
  "item.minecraft.parched_spawn_egg": "nobmeD QaD boghmoHbogh QIm'e'",
  "item.minecraft.parrot_spawn_egg": "vIlInHoD boghmoHbogh QIm'e'",
  "item.minecraft.phantom_membrane": "ram toQ yelmo'",
  "item.minecraft.phantom_spawn_egg": "ram toQ boghmoHbogh QIm'e'",
  "item.minecraft.pig_spawn_egg": "Suy' boghmoHbogh QIm'e'",
  "item.minecraft.piglin_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.piglin_banner_pattern.desc": "ghIch",
  "item.minecraft.piglin_banner_pattern.new": "ghIch joqwI' HaSreH",
  "item.minecraft.piglin_brute_spawn_egg": "piglin mang boghmoHbogh QIm'e'",
  "item.minecraft.piglin_spawn_egg": "piglin boghmoHbogh QIm'e'",
  "item.minecraft.pillager_spawn_egg": "weHwI' boghmoHbogh QIm'e'",
  "item.minecraft.pink_bundle": "Doqqu'bogh Doj buq 'ej wovqu'bogh",
  "item.minecraft.pink_dye": "Doqqu'bogh 'ej wovbogh rItlh",
  "item.minecraft.pink_harness": "Doqqu'bogh 'aHra' 'ej wovqu'bogh",
  "item.minecraft.pitcher_plant": "bal San'emDer",
  "item.minecraft.pitcher_pod": "bal San'emDer raS'IS",
  "item.minecraft.plenty_pottery_shard": "qengHoD mIllogh bal 'ay'",
  "item.minecraft.plenty_pottery_sherd": "qengHoD mIllogh bal re'nop",
  "item.minecraft.poisonous_potato": "patat 'oQqar SuQ",
  "item.minecraft.polar_bear_spawn_egg": "chuch mIl'oD boghmoHbogh QIm'e'",
  "item.minecraft.popped_chorus_fruit": "bomwI' ghom naH ghorlu'pu'bogh",
  "item.minecraft.porkchop": "targh ghab tlhol",
  "item.minecraft.potato": "patat 'oQqar",
  "item.minecraft.potion": "'IDnar taS",
  "item.minecraft.potion.effect.awkward": "'IDnar taS mItHa'",
  "item.minecraft.potion.effect.empty": "'IDnar taS'e' chenmoHlaHbe'bogh vay'",
  "item.minecraft.potion.effect.fire_resistance": "qul 'ommeH 'IDnar taS",
  "item.minecraft.potion.effect.harming": "QIH 'IDnar taS",
  "item.minecraft.potion.effect.healing": "Do Hergh 'IDnar taS",
  "item.minecraft.potion.effect.infested": "ngejmeH 'IDnar taS",
  "item.minecraft.potion.effect.invisibility": "So'meH 'IDnar taS",
  "item.minecraft.potion.effect.leaping": "pe'vIl SupmoHmeH 'IDnar taS",
  "item.minecraft.potion.effect.levitation": "'almoHmeH 'IDnar taS",
  "item.minecraft.potion.effect.luck": "Do'moHmeH 'IDnar taS",
  "item.minecraft.potion.effect.mundane": "'IDnar taS motlh",
  "item.minecraft.potion.effect.night_vision": "ram leghlaHghach 'IDnar taS",
  "item.minecraft.potion.effect.oozing": "charmoHmeH 'IDnar taS",
  "item.minecraft.potion.effect.poison": "tar 'IDnar taS",
  "item.minecraft.potion.effect.regeneration": "rachmoHtaHmeH 'IDnar taS",
  "item.minecraft.potion.effect.slow_falling": "peDmoHmeH 'IDnar taS",
  "item.minecraft.potion.effect.slowness": "QIt vIHmoHwI' 'IDnar taS",
  "item.minecraft.potion.effect.strength": "HoS 'IDnar taS",
  "item.minecraft.potion.effect.swiftness": "Do 'IDnar taS",
  "item.minecraft.potion.effect.thick": "'IDnar taS jeD",
  "item.minecraft.potion.effect.turtle_master": "la'SIv pIn'a' 'IDnar taS",
  "item.minecraft.potion.effect.water": "bIQ bal",
  "item.minecraft.potion.effect.water_breathing": "nIwqen 'IDnar taS",
  "item.minecraft.potion.effect.weakness": "pujmoHmeH 'IDnar taS",
  "item.minecraft.potion.effect.weaving": "nIqmeH 'IDnar taS",
  "item.minecraft.potion.effect.wind_charged": "SuS bach 'IDnar taS",
  "item.minecraft.pottery_shard_archer": "HurwI' mIllogh bal 'ay'",
  "item.minecraft.pottery_shard_arms_up": "DeSDu' mIllogh bal 'ay'",
  "item.minecraft.pottery_shard_prize": "tev mIllogh bal 'ay'",
  "item.minecraft.pottery_shard_skull": "DughrI' mIllogh bal 'ay'",
  "item.minecraft.powder_snow_bucket": "chal chuch Say'qIS HaySIn",
  "item.minecraft.prismarine_crystals": "prismarine qutmey",
  "item.minecraft.prismarine_shard": "prismarine 'ay'",
  "item.minecraft.prize_pottery_shard": "tev mIllogh bal 'ay'",
  "item.minecraft.prize_pottery_sherd": "tev mIllogh bal re'nop",
  "item.minecraft.pufferfish": "lunbogh ghotI'",
  "item.minecraft.pufferfish_bucket": "lunbogh ghotI' HaySIn",
  "item.minecraft.pufferfish_spawn_egg": "lunbogh ghotI' boghmoHbogh QIm'e'",
  "item.minecraft.pumpkin_pie": "'aquta' chab",
  "item.minecraft.pumpkin_seeds": "'aquta' raS'IS",
  "item.minecraft.purple_bundle": "ghIrep Hurgh rurbogh Doj buq",
  "item.minecraft.purple_dye": "ghIrep Hurgh rurbogh rItlh'e'",
  "item.minecraft.purple_harness": "ghIrep Hurgh rurbogh 'aHra'",
  "item.minecraft.quartz": "nether choSom",
  "item.minecraft.rabbit": "cheS tlhol",
  "item.minecraft.rabbit_foot": "cheS qam",
  "item.minecraft.rabbit_hide": "cheS DIr",
  "item.minecraft.rabbit_spawn_egg": "cheS boghmoHbogh QIm'e'",
  "item.minecraft.rabbit_stew": "cheS chatlh",
  "item.minecraft.raiser_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "pepwI' may' Sut HaSreH",
  "item.minecraft.ravager_spawn_egg": "Ha'DIbaH Qaw'bogh boghmoHbogh QIm'e'",
  "item.minecraft.raw_copper": "Sorpuq tlhol",
  "item.minecraft.raw_gold": "qol'om tlhol",
  "item.minecraft.raw_iron": "'uSqan tlhol",
  "item.minecraft.recovery_compass": "cheghwI' SInan",
  "item.minecraft.red_bundle": "Doj buq Doqqu'",
  "item.minecraft.red_dye": "rItlh Doqqu'",
  "item.minecraft.red_harness": "'aHra' Doqqu'",
  "item.minecraft.redstone": "redstone Say'qIS",
  "item.minecraft.resin_brick": "rebmugh ngogh",
  "item.minecraft.resin_clump": "rebmugh Sawqe'",
  "item.minecraft.rib_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.rib_armor_trim_smithing_template.new": "joQ may' Sut HaSreH",
  "item.minecraft.rotten_flesh": "Ha'DIbaH non",
  "item.minecraft.saddle": "ba'qIn",
  "item.minecraft.salmon": "Se'mon tlhol",
  "item.minecraft.salmon_bucket": "Se'mon HaySIn",
  "item.minecraft.salmon_spawn_egg": "Se'mon boghmoHbogh QIm'e'",
  "item.minecraft.scrape_pottery_sherd": "tey mIllogh bal re'nop",
  "item.minecraft.scute": "ghISDen",
  "item.minecraft.sentry_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "'avwI' may' Sut HaSreH",
  "item.minecraft.shaper_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "chenmoHwI' may' Sut HaSreH",
  "item.minecraft.sheaf_pottery_shard": "Doj mIllogh bal 'ay'",
  "item.minecraft.sheaf_pottery_sherd": "Doj mIllogh bal re'nop",
  "item.minecraft.shears": "cha''etlh pe'wI''a'",
  "item.minecraft.sheep_spawn_egg": "DI'raq boghmoHbogh QIm'e'",
  "item.minecraft.shelter_pottery_shard": "lulIgh mIllogh bal 'ay'",
  "item.minecraft.shelter_pottery_sherd": "lulIgh mIllogh bal re'nop",
  "item.minecraft.shield": "yoD",
  "item.minecraft.shield.black": "yoD qIj",
  "item.minecraft.shield.blue": "SuDbogh yoD 'ej Hurghbogh",
  "item.minecraft.shield.brown": "Doqbogh yoD 'ej wovbe'bogh",
  "item.minecraft.shield.cyan": "SuDqu'bogh yoD 'ej wovbogh",
  "item.minecraft.shield.gray": "qIjbogh yoD 'ej wovbogh",
  "item.minecraft.shield.green": "yoD SuDqu'",
  "item.minecraft.shield.light_blue": "SuDbogh yoD 'ej wovbogh",
  "item.minecraft.shield.light_gray": "qIjbogh yoD 'ej wovqu'bogh",
  "item.minecraft.shield.lime": "SuDqu'bogh yoD 'ej wovqu'bogh",
  "item.minecraft.shield.magenta": "Doqqu'bogh yoD 'ej wovbogh",
  "item.minecraft.shield.orange": "Doqbogh yoD 'ej beqpuj rurbogh",
  "item.minecraft.shield.pink": "Doqqu'bogh yoD 'ej wovqu'bogh",
  "item.minecraft.shield.purple": "ghIrep Hurgh rurbogh yoD'e'",
  "item.minecraft.shield.red": "yoD Doqqu'",
  "item.minecraft.shield.white": "yoD chIS",
  "item.minecraft.shield.yellow": "SuDbogh yoD 'ej wovqu'bogh",
  "item.minecraft.shulker_shell": "ghachwI' nagh DIr",
  "item.minecraft.shulker_spawn_egg": "shulker boghmoHbogh QIm'e'",
  "item.minecraft.sign": "QIn 'echlet",
  "item.minecraft.silence_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.silence_armor_trim_smithing_template.new": "tam may' Sut HaSreH",
  "item.minecraft.silverfish_spawn_egg": "SIrlIy ghew boghmoHbogh QIm'e'",
  "item.minecraft.skeleton_horse_spawn_egg": "nobmeD Sargh boghmoHbogh QIm'e'",
  "item.minecraft.skeleton_spawn_egg": "nobmeD boghmoHbogh QIm'e'",
  "item.minecraft.skull_banner_pattern": "joqwI' HaSreH",
  "item.minecraft.skull_banner_pattern.desc": "DughrI' Degh",
  "item.minecraft.skull_banner_pattern.new": "DughrI' Degh joqwI' HasreH",
  "item.minecraft.skull_pottery_shard": "DughrI' mIllogh bal 'ay'",
  "item.minecraft.skull_pottery_sherd": "DughrI' mIllogh bal re'nop",
  "item.minecraft.slime_ball": "HuH moQ",
  "item.minecraft.slime_spawn_egg": "HuH boghmoHbogh QIm'e'",
  "item.minecraft.smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.smithing_template.applies_to": "bop:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "baS ngogh, qut ghap yIlan",
  "item.minecraft.smithing_template.armor_trim.applies_to": "may' Sut",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "may' Sut yIlan",
  "item.minecraft.smithing_template.armor_trim.ingredients": "baS ngogh qut je",
  "item.minecraft.smithing_template.ingredients": "qurme':",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "netherite ngogh yIlan",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "chanmon luch",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "chanmon may' Sut, nuH, SommI' ghap yIlan",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "netherite ngogh",
  "item.minecraft.smithing_template.upgrade": "Dub:",
  "item.minecraft.sniffer_spawn_egg": "larghwI' boghmoHbogh QIm'e'",
  "item.minecraft.snort_pottery_shard": "Qoghogh mIllogh bal 'ay'",
  "item.minecraft.snort_pottery_sherd": "Qoghogh mIllogh bal re'nop",
  "item.minecraft.snout_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.snout_armor_trim_smithing_template.new": "ghIch may' Sut HaSreH",
  "item.minecraft.snow_golem_spawn_egg": "chal chuch yoq pargh boghmoHbogh QIm'e'",
  "item.minecraft.snowball": "chal chuch moQ",
  "item.minecraft.spectral_arrow": "wewmoHbogh chollar",
  "item.minecraft.spider_eye": "voDchuch mIn",
  "item.minecraft.spider_spawn_egg": "voDchuch boghmoHbogh QIm'e'",
  "item.minecraft.spire_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.spire_armor_trim_smithing_template.new": "chalqach may' Sut HaSreH",
  "item.minecraft.splash_potion": "bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.awkward": "bobDar 'IDnar taS mItHa'",
  "item.minecraft.splash_potion.effect.empty": "bobDar 'IDnar taS'e' chenmoHlaHbe'bogh vay'",
  "item.minecraft.splash_potion.effect.fire_resistance": "qul 'ommeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.harming": "QIH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.healing": "Do Hergh bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.infested": "ngejmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.invisibility": "So'meH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.leaping": "pe'vIl SupmoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.levitation": "'almoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.luck": "Do'moHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.mundane": "'bobDar 'IDnar taS motlh",
  "item.minecraft.splash_potion.effect.night_vision": "ram leghlaHghach bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.oozing": "charmoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.poison": "tar bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.regeneration": "rachmoHtaHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.slow_falling": "peDmoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.slowness": "QIt vIHmoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.strength": "HoS bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.swiftness": "Do bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.thick": "bobDar 'IDnar taS jeD",
  "item.minecraft.splash_potion.effect.turtle_master": "la'SIv pIn'a' bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.water": "bobDar bIQ bal",
  "item.minecraft.splash_potion.effect.water_breathing": "nIwqen bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.weakness": "pujmoHmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.weaving": "nIqmeH bobDar 'IDnar taS",
  "item.minecraft.splash_potion.effect.wind_charged": "SuS bach bobDar 'IDnar taS",
  "item.minecraft.spruce_boat": "qIrqoD bIQ Duj",
  "item.minecraft.spruce_chest_boat": "DerlIq ghajbogh qIrqoD bIQ Duj'e'",
  "item.minecraft.spyglass": "Hov tut",
  "item.minecraft.squid_spawn_egg": "cheyIS boghmoHbogh QIm'e'",
  "item.minecraft.stick": "naQ",
  "item.minecraft.stone_axe": "nagh 'obmaQ",
  "item.minecraft.stone_hoe": "nagh rutneD",
  "item.minecraft.stone_pickaxe": "nagh tlhIlwI' jan",
  "item.minecraft.stone_shovel": "nagh ghevjur",
  "item.minecraft.stone_spear": "nagh naQjej",
  "item.minecraft.stone_sword": "nagh yan",
  "item.minecraft.stray_spawn_egg": "nobmeD taD boghmoHbogh QIm'e'",
  "item.minecraft.strider_spawn_egg": "yItwI' boghmoHbogh QIm'e'",
  "item.minecraft.string": "SIrgh",
  "item.minecraft.sugar": "Su'ghar",
  "item.minecraft.suspicious_stew": "tlhIq nub",
  "item.minecraft.sweet_berries": "naH Doqqu'",
  "item.minecraft.tadpole_bucket": "yemghaw HaySIn",
  "item.minecraft.tadpole_spawn_egg": "mabeb ghu boghmoHbogh QIm'e'",
  "item.minecraft.tide_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.tide_armor_trim_smithing_template.new": "vI'Ir may' Sut HaSreH",
  "item.minecraft.tipped_arrow": "'IDnar chollar",
  "item.minecraft.tipped_arrow.effect.awkward": "'IDnar chollar",
  "item.minecraft.tipped_arrow.effect.empty": "'IDnar chollar'e' chenmoHlaHbe'bogh vay'",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "qul 'ommeH chollar",
  "item.minecraft.tipped_arrow.effect.harming": "QIH chollar",
  "item.minecraft.tipped_arrow.effect.healing": "Do 'on'aS chollar",
  "item.minecraft.tipped_arrow.effect.infested": "ngejmeH chollar",
  "item.minecraft.tipped_arrow.effect.invisibility": "So'meH chollar",
  "item.minecraft.tipped_arrow.effect.leaping": "pe'vIl SupmoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.levitation": "'almoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.luck": "Do'moHmeH chollar",
  "item.minecraft.tipped_arrow.effect.mundane": "'IDnar chollar",
  "item.minecraft.tipped_arrow.effect.night_vision": "ram leghlaHghach chollar",
  "item.minecraft.tipped_arrow.effect.oozing": "charmoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.poison": "tar chollar",
  "item.minecraft.tipped_arrow.effect.regeneration": "rachmoHtaHmeH chollar",
  "item.minecraft.tipped_arrow.effect.slow_falling": "peDmoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.slowness": "QIt vIHmoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.strength": "HoS chollar",
  "item.minecraft.tipped_arrow.effect.swiftness": "Do chollar",
  "item.minecraft.tipped_arrow.effect.thick": "'IDnar chollar",
  "item.minecraft.tipped_arrow.effect.turtle_master": "la'SIv pIn'a' chollar",
  "item.minecraft.tipped_arrow.effect.water": "bobDar chollar",
  "item.minecraft.tipped_arrow.effect.water_breathing": "nIwqen chollar",
  "item.minecraft.tipped_arrow.effect.weakness": "pujmoHmeH chollar",
  "item.minecraft.tipped_arrow.effect.weaving": "nIqmeH chollar",
  "item.minecraft.tipped_arrow.effect.wind_charged": "SuS bach chollar",
  "item.minecraft.tnt_minecart": "jorwI' tlhIlHal Duj",
  "item.minecraft.torchflower_seeds": "Sech 'InSong raS'IS",
  "item.minecraft.totem_of_undying": "jubmoHmeH HewHom",
  "item.minecraft.trader_llama_spawn_egg": "Suy 'ImtIy boghmoHbogh QIm'e'",
  "item.minecraft.trial_key": "qaD ngaQHa'moHwI'",
  "item.minecraft.trident": "chonnaQ",
  "item.minecraft.tropical_fish": "bIQ ghun ghotI'",
  "item.minecraft.tropical_fish_bucket": "bIQ ghun ghotI' HaySIn",
  "item.minecraft.tropical_fish_spawn_egg": "bIQ ghun ghotI' boghmoHbogh QIm'e'",
  "item.minecraft.turtle_helmet": "la'SIv nagh DIr",
  "item.minecraft.turtle_scute": "la'SIv ghISDen",
  "item.minecraft.turtle_spawn_egg": "la'SIv boghmoHbogh QIm'e'",
  "item.minecraft.vex_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.vex_armor_trim_smithing_template.new": "nuQ may' Sut HaSreH",
  "item.minecraft.vex_spawn_egg": "nuQwI' boghmoHbogh QIm'e'",
  "item.minecraft.villager_spawn_egg": "vengHom ghot boghmoHbogh QIm",
  "item.minecraft.vindicator_spawn_egg": "'obmaQ ghajbogh weHwI' boghmoHbogh QIm",
  "item.minecraft.wandering_trader_spawn_egg": "yorqej Suy boghmoHbogh QIm'e'",
  "item.minecraft.ward_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.ward_armor_trim_smithing_template.new": "'av may' Sut HaSreH",
  "item.minecraft.warden_spawn_egg": "HubwI' boghmoHbogh QIm'e'",
  "item.minecraft.warped_fungus_on_a_stick": "'atlhqam SuD naQ",
  "item.minecraft.water_bucket": "bIQ HaySIn",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "chIjwI' may' Sut HaSreH",
  "item.minecraft.wheat": "wevpev",
  "item.minecraft.wheat_seeds": "wevpev raS'IS",
  "item.minecraft.white_bundle": "Doj buq chIS",
  "item.minecraft.white_dye": "rItlh chIS",
  "item.minecraft.white_harness": "'aHra' chIS",
  "item.minecraft.wild_armor_trim_smithing_template": "mItlhmeH ghantoH",
  "item.minecraft.wild_armor_trim_smithing_template.new": "tlhab may' Sut HaSreH",
  "item.minecraft.wind_charge": "SuS bach",
  "item.minecraft.witch_spawn_egg": "'IDnar pIn'a' boghmoHbogh QIm",
  "item.minecraft.wither_skeleton_spawn_egg": "wither nobmeD boghmoHbogh QIm'e'",
  "item.minecraft.wither_spawn_egg": "wither boghmoHbogh QIm'e'",
  "item.minecraft.wolf_armor": "ngavyaw' may' Sut",
  "item.minecraft.wolf_spawn_egg": "ngavyaw' boghmoHbogh QIm'e'",
  "item.minecraft.wooden_axe": "Sor Hap 'obmaQ",
  "item.minecraft.wooden_hoe": "Sor Hap rutneD",
  "item.minecraft.wooden_pickaxe": "Sor Hap tlhIlwI' jan",
  "item.minecraft.wooden_shovel": "Sor Hap ghevjur",
  "item.minecraft.wooden_spear": "Sor Hap naQjej",
  "item.minecraft.wooden_sword": "Sor Hap yan",
  "item.minecraft.writable_book": "paq ghItlhwI' bo je",
  "item.minecraft.written_book": "ghItlhta' paq",
  "item.minecraft.yellow_bundle": "SuDbogh Doj buq 'ej wovqu'bogh",
  "item.minecraft.yellow_dye": "SuDbogh rItlh 'ej wovqu'bogh",
  "item.minecraft.yellow_harness": "SuDbogh 'aHra' 'ej wovqu'bogh",
  "item.minecraft.zoglin_spawn_egg": "zoglin boghmoHbogh QIm'e'",
  "item.minecraft.zombie_horse_spawn_egg": "yInbogh Sargh lom boghmoHbogh QIm'e'",
  "item.minecraft.zombie_nautilus_spawn_egg": "yInbogh qatvoH lom boghmoHbogh QIm'e'",
  "item.minecraft.zombie_spawn_egg": "yInbogh lom boghmoHbogh QIm'e'",
  "item.minecraft.zombie_villager_spawn_egg": "yInbogh vengHom ghot lom boghmoHbogh QIm'e'",
  "item.minecraft.zombified_piglin_spawn_egg": "yInbogh piglin lom boghmoHbogh QIm'e'"
}
export const tlh_aa = items; 
